// GENERATED by .scratch/gen-coop-full.cjs from jcfieldsdev data.js, then hand-maintained.
// Co-op commander rosters + their command entries (bootstrap clause, extended to co-op;
// commander axis). Every command `key` is bare-key-verified against TheCore (golden guard).
// Build-menu drill-downs, built addons (Tech Lab / Tech Reactor as their own structure
// Contexts), and unit forms (burrowed / flying / morphed / a hero's learn menu as drill-down
// sub-Contexts; opener-less suits/death-states as their own top-level Contexts) are all modeled.
// See .scratch reports for each form's disposition and what was dropped.
import type { SC2Command, SC2Roster } from "./sc2-registry";

export const COOP_COMMANDS: Record<string, SC2Command> = {
  co_TerranBuild_SCV_Raynor: {
    name: "Build Basic",
    category: "command",
    key: "TerranBuild",
    unit: "SCV",
    opens: "scv_build0",
  },
  co_TerranBuildAdvanced_SCV_Raynor: {
    name: "Build Advanced",
    category: "command",
    key: "TerranBuildAdvanced",
    unit: "SCV",
    opens: "scv_build1",
  },
  co_SupplyDepot_SCV: {
    name: "Supply Depot",
    category: "structure",
    key: "SupplyDepot",
    unit: "SCV",
  },
  co_SpiderMine_Vulture: {
    name: "Deploy Spider Mine",
    category: "ability",
    key: "SpiderMine",
    unit: "Vulture",
  },
  co_SpiderMineReplenish_Vulture: {
    name: "Replenish Spider Mine",
    category: "ability",
    key: "SpiderMineReplenish",
    unit: "Vulture",
  },
  co_IgniteAfterburners_Vulture: {
    name: "Ignite Afterburners",
    category: "ability",
    key: "IgniteAfterburners",
    unit: "Vulture",
  },
  co_IgniteAfterburners_SiegeTank: {
    name: "Ignite Afterburners",
    category: "ability",
    key: "IgniteAfterburners",
    unit: "SiegeTank",
  },
  co_IgniteAfterburners_VikingAssault: {
    name: "Ignite Afterburners",
    category: "ability",
    key: "IgniteAfterburners",
    unit: "VikingAssault",
  },
  co_IgniteAfterburners_Banshee: {
    name: "Ignite Afterburners",
    category: "ability",
    key: "IgniteAfterburners",
    unit: "Banshee",
  },
  co_IgniteAfterburners_Battlecruiser: {
    name: "Ignite Afterburners",
    category: "ability",
    key: "IgniteAfterburners",
    unit: "Battlecruiser",
  },
  co_HyperionVoidCoopHyperjump_HyperionVoidCoop: {
    name: "Hyperjump",
    category: "ability",
    key: "HyperionVoidCoopHyperjump",
    unit: "HyperionVoidCoop",
  },
  co_HyperionVoidCoopYamatoCannon_HyperionVoidCoop: {
    name: "Yamato Cannon",
    category: "ability",
    key: "HyperionVoidCoopYamatoCannon",
    unit: "HyperionVoidCoop",
  },
  co_HyperionAdvancedPDD_HyperionVoidCoop: {
    name: "Point Defense Drone",
    category: "ability",
    key: "HyperionAdvancedPDD",
    unit: "HyperionVoidCoop",
  },
  co_OrbitalCommand_CommandCenter_commandcenterorbitalcommand: {
    name: "Orbital Command",
    category: "command",
    key: "OrbitalCommand",
    unit: "CommandCenter",
    opens: "commandcenter_orbitalcommand",
  },
  co_Lift_commandcenterflying: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "commandcenter_flying",
  },
  co_Land: { name: "Land", category: "ability", key: "Land" },
  co_Lower_SupplyDepot_supplydepotlowered: {
    name: "Lower",
    category: "command",
    key: "Lower",
    unit: "SupplyDepot",
    opens: "supplydepot_lowered",
  },
  co_Raise_SupplyDepotLowered: {
    name: "Raise",
    category: "unit",
    key: "Raise",
    unit: "SupplyDepotLowered",
  },
  co_Firebat_Barracks: { name: "Firebat", category: "unit", key: "Firebat", unit: "Barracks" },
  co_Medic_Barracks: { name: "Medic", category: "unit", key: "Medic", unit: "Barracks" },
  co_Lift_barracksflying: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "barracks_flying",
  },
  co_ResearchIncineratorGauntlets_BarracksTechLab: {
    name: "Incinerator Gauntlets",
    category: "ability",
    key: "ResearchIncineratorGauntlets",
    unit: "BarracksTechLab",
  },
  co_ResearchJuggernautPlating_BarracksTechLab: {
    name: "Juggernaut Plating",
    category: "ability",
    key: "ResearchJuggernautPlating",
    unit: "BarracksTechLab",
  },
  co_ResearchShieldWall_BarracksTechReactor: {
    name: "Combat Shield",
    category: "ability",
    key: "ResearchShieldWall",
    unit: "BarracksTechReactor",
  },
  co_Stimpack_BarracksTechReactor: {
    name: "Stabilizer Medpacks",
    category: "ability",
    key: "Stimpack",
    unit: "BarracksTechReactor",
  },
  co_ResearchPunisherGrenades_BarracksTechReactor: {
    name: "Concussive Shells",
    category: "ability",
    key: "ResearchPunisherGrenades",
    unit: "BarracksTechReactor",
  },
  co_ResearchIncineratorGauntlets_BarracksTechReactor: {
    name: "Incinerator Gauntlets",
    category: "ability",
    key: "ResearchIncineratorGauntlets",
    unit: "BarracksTechReactor",
  },
  co_ResearchJuggernautPlating_BarracksTechReactor: {
    name: "Juggernaut Plating",
    category: "ability",
    key: "ResearchJuggernautPlating",
    unit: "BarracksTechReactor",
  },
  co_Land_2: { name: "Land", category: "ability", key: "Land" },
  co_ResearchNeosteelFrame_EngineeringBay: {
    name: "Neosteel Frame",
    category: "ability",
    key: "ResearchNeosteelFrame",
    unit: "EngineeringBay",
  },
  co_Salvage_MissileTurret: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "MissileTurret",
  },
  co_Lift_factoryflying: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "factory_flying",
  },
  co_ResearchHellbatHellArmor_FactoryTechLab: {
    name: "Infernal Plating",
    category: "ability",
    key: "ResearchHellbatHellArmor",
    unit: "FactoryTechLab",
  },
  co_ResearchImprovedSiegeMode_FactoryTechLab: {
    name: "Advanced Siege Tech",
    category: "ability",
    key: "ResearchImprovedSiegeMode",
    unit: "FactoryTechLab",
  },
  co_ResearchHighCapacityBarrels_FactoryTechReactor: {
    name: "Infernal Pre-igniter",
    category: "ability",
    key: "ResearchHighCapacityBarrels",
    unit: "FactoryTechReactor",
  },
  co_ResearchHellbatHellArmor_FactoryTechReactor: {
    name: "Infernal Plating",
    category: "ability",
    key: "ResearchHellbatHellArmor",
    unit: "FactoryTechReactor",
  },
  co_ResearchImprovedSiegeMode_FactoryTechReactor: {
    name: "Advanced Siege Tech",
    category: "ability",
    key: "ResearchImprovedSiegeMode",
    unit: "FactoryTechReactor",
  },
  co_Land_3: { name: "Land", category: "ability", key: "Land" },
  co_TerranVehicleAndShipWeaponsLevel1_Armory: {
    name: "Vehicle and Ship Weapons",
    category: "ability",
    key: "TerranVehicleAndShipWeaponsLevel1",
    unit: "Armory",
  },
  co_ResearchVehicleWeaponRange_Armory: {
    name: "Advanced Optics",
    category: "ability",
    key: "ResearchVehicleWeaponRange",
    unit: "Armory",
  },
  co_ResearchRegenerativeBioSteel_Armory: {
    name: "Regenerative Bio-Steel",
    category: "ability",
    key: "ResearchRegenerativeBioSteel",
    unit: "Armory",
  },
  co_Lift_starportflying: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "starport_flying",
  },
  co_ResearchShockwaveMissileBattery_StarportTechLab: {
    name: "Shockwave Missile Battery",
    category: "ability",
    key: "ResearchShockwaveMissileBattery",
    unit: "StarportTechLab",
  },
  co_ResearchPhobosClassWeaponsSystem_StarportTechLab: {
    name: "Phobos-class Weapons System",
    category: "ability",
    key: "ResearchPhobosClassWeaponsSystem",
    unit: "StarportTechLab",
  },
  co_ResearchRipwaveMissiles_StarportTechLab: {
    name: "Ripwave Missiles",
    category: "ability",
    key: "ResearchRipwaveMissiles",
    unit: "StarportTechLab",
  },
  co_ResearchBansheeCloak_StarportTechReactor: {
    name: "Cloaking Field",
    category: "ability",
    key: "ResearchBansheeCloak",
    unit: "StarportTechReactor",
  },
  co_ResearchShockwaveMissileBattery_StarportTechReactor: {
    name: "Shockwave Missile Battery",
    category: "ability",
    key: "ResearchShockwaveMissileBattery",
    unit: "StarportTechReactor",
  },
  co_ResearchPhobosClassWeaponsSystem_StarportTechReactor: {
    name: "Phobos-class Weapons System",
    category: "ability",
    key: "ResearchPhobosClassWeaponsSystem",
    unit: "StarportTechReactor",
  },
  co_ResearchRipwaveMissiles_StarportTechReactor: {
    name: "Ripwave Missiles",
    category: "ability",
    key: "ResearchRipwaveMissiles",
    unit: "StarportTechReactor",
  },
  co_Land_4: { name: "Land", category: "ability", key: "Land" },
  co_AdvancedConstructionAuto_SCV: {
    name: "Advanced Construction",
    category: "ability",
    key: "AdvancedConstructionAuto",
    unit: "SCV",
  },
  co_TerranBuild_SCV_Swann: {
    name: "Build Basic",
    category: "command",
    key: "TerranBuild",
    unit: "SCV",
    opens: "scv_build0",
  },
  co_TerranBuildAdvanced_SCV_Swann: {
    name: "Build Advanced",
    category: "command",
    key: "TerranBuildAdvanced",
    unit: "SCV",
    opens: "scv_build1",
  },
  co_SupplyDepot_SCV_2: {
    name: "Supply Depot",
    category: "structure",
    key: "SupplyDepot",
    unit: "SCV",
  },
  co_BuildKelMorianRocketTurret_SCV: {
    name: "Devastation Turret",
    category: "structure",
    key: "BuildKelMorianRocketTurret",
    unit: "SCV",
  },
  co_SwannCommanderRebuild: { name: "Rebuild", category: "ability", key: "SwannCommanderRebuild" },
  co_250mmStrikeCannons_Thor: {
    name: "250mm Strike Cannons",
    category: "ability",
    key: "250mmStrikeCannons",
    unit: "Thor",
  },
  co_SwannCommanderRebuild_2: {
    name: "Rebuild",
    category: "ability",
    key: "SwannCommanderRebuild",
  },
  co_WraithCloakOn_Wraith: {
    name: "Cloak",
    category: "ability",
    key: "WraithCloakOn",
    unit: "Wraith",
  },
  co_WraithCloakOff_Wraith: {
    name: "Decloak",
    category: "ability",
    key: "WraithCloakOff",
    unit: "Wraith",
  },
  co_HerculesLoad_Hercules: {
    name: "Load",
    category: "ability",
    key: "HerculesLoad",
    unit: "Hercules",
  },
  co_HerculesUnloadAll_Hercules: {
    name: "Unload All",
    category: "ability",
    key: "HerculesUnloadAll",
    unit: "Hercules",
  },
  co_HyperjumpHercules_Hercules: {
    name: "Tactical Jump",
    category: "ability",
    key: "HyperjumpHercules",
    unit: "Hercules",
  },
  co_NanoRepair_ScienceVessel: {
    name: "Nano-Repair",
    category: "ability",
    key: "NanoRepair",
    unit: "ScienceVessel",
  },
  co_Irradiate_ScienceVessel: {
    name: "Irradiate",
    category: "ability",
    key: "Irradiate",
    unit: "ScienceVessel",
  },
  co_DefensiveMatrixTarget_ScienceVessel: {
    name: "Defensive Matrix",
    category: "ability",
    key: "DefensiveMatrixTarget",
    unit: "ScienceVessel",
  },
  co_FleetwideJump_ScienceVessel: {
    name: "Tactical Jump",
    category: "ability",
    key: "FleetwideJump",
    unit: "ScienceVessel",
  },
  co_VespeneDrone_CommandCenter: {
    name: "Vespene Harvester",
    category: "unit",
    key: "VespeneDrone",
    unit: "CommandCenter",
  },
  co_Lift_commandcenterflying_2: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "commandcenter_flying",
  },
  co_Land_5: { name: "Land", category: "ability", key: "Land" },
  co_Lower_SupplyDepot_supplydepotlowered_2: {
    name: "Lower",
    category: "command",
    key: "Lower",
    unit: "SupplyDepot",
    opens: "supplydepot_lowered",
  },
  co_Raise_SupplyDepotLowered_2: {
    name: "Raise",
    category: "unit",
    key: "Raise",
    unit: "SupplyDepotLowered",
  },
  co_ResearchNeosteelFrame_EngineeringBay_2: {
    name: "Neosteel Frame",
    category: "ability",
    key: "ResearchNeosteelFrame",
    unit: "EngineeringBay",
  },
  co_ResearchFireSuppressionSystems_EngineeringBay: {
    name: "Fire Suppression Systems",
    category: "ability",
    key: "ResearchFireSuppressionSystems",
    unit: "EngineeringBay",
  },
  co_ResearchImprovedTurretAttackSpeed_EngineeringBay: {
    name: "KMC Auto-Loaders",
    category: "ability",
    key: "ResearchImprovedTurretAttackSpeed",
    unit: "EngineeringBay",
  },
  co_Salvage_PerditionTurret: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "PerditionTurret",
  },
  co_Salvage_KelMorianGrenadeTurret: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "KelMorianGrenadeTurret",
  },
  co_Salvage_KelMorianMissileTurret: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "KelMorianMissileTurret",
  },
  co_Goliath_Factory: { name: "Goliath", category: "unit", key: "Goliath", unit: "Factory" },
  co_Lift_factoryflying_2: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "factory_flying",
  },
  co_ResearchHellbatHellArmor_FactoryTechLab_2: {
    name: "Infernal Plating",
    category: "ability",
    key: "ResearchHellbatHellArmor",
    unit: "FactoryTechLab",
  },
  co_ResearchImprovedSiegeMode_FactoryTechLab_2: {
    name: "Advanced Siege Tech",
    category: "ability",
    key: "ResearchImprovedSiegeMode",
    unit: "FactoryTechLab",
  },
  co_ResearchMultiLockWeaponsSystem_FactoryTechLab: {
    name: "Multi-Lock Weapons System",
    category: "ability",
    key: "ResearchMultiLockWeaponsSystem",
    unit: "FactoryTechLab",
  },
  co_ResearchMaelstromRounds_FactoryTechLab: {
    name: "Maelstrom Rounds",
    category: "ability",
    key: "ResearchMaelstromRounds",
    unit: "FactoryTechLab",
  },
  co_ResearchLockOnRangeUpgrade_FactoryTechLab: {
    name: "Targeting Optics",
    category: "ability",
    key: "ResearchLockOnRangeUpgrade",
    unit: "FactoryTechLab",
  },
  co_ResearchCycloneLockOnDamageUpgrade_FactoryTechLab: {
    name: "Mag-Field Accelerator",
    category: "ability",
    key: "ResearchCycloneLockOnDamageUpgrade",
    unit: "FactoryTechLab",
  },
  co_Research330mmBarrageCannon_FactoryTechLab: {
    name: "330mm Barrage Cannon",
    category: "ability",
    key: "Research330mmBarrageCannon",
    unit: "FactoryTechLab",
  },
  co_ResearchHighCapacityBarrels_FactoryTechReactor_2: {
    name: "Infernal Pre-igniter",
    category: "ability",
    key: "ResearchHighCapacityBarrels",
    unit: "FactoryTechReactor",
  },
  co_ResearchHellbatHellArmor_FactoryTechReactor_2: {
    name: "Infernal Plating",
    category: "ability",
    key: "ResearchHellbatHellArmor",
    unit: "FactoryTechReactor",
  },
  co_ResearchImprovedSiegeMode_FactoryTechReactor_2: {
    name: "Advanced Siege Tech",
    category: "ability",
    key: "ResearchImprovedSiegeMode",
    unit: "FactoryTechReactor",
  },
  co_ResearchMultiLockWeaponsSystem_FactoryTechReactor: {
    name: "Multi-Lock Weapons System",
    category: "ability",
    key: "ResearchMultiLockWeaponsSystem",
    unit: "FactoryTechReactor",
  },
  co_ResearchMaelstromRounds_FactoryTechReactor: {
    name: "Maelstrom Rounds",
    category: "ability",
    key: "ResearchMaelstromRounds",
    unit: "FactoryTechReactor",
  },
  co_ResearchLockOnRangeUpgrade_FactoryTechReactor: {
    name: "Targeting Optics",
    category: "ability",
    key: "ResearchLockOnRangeUpgrade",
    unit: "FactoryTechReactor",
  },
  co_ResearchCycloneLockOnDamageUpgrade_FactoryTechReactor: {
    name: "Mag-Field Accelerator",
    category: "ability",
    key: "ResearchCycloneLockOnDamageUpgrade",
    unit: "FactoryTechReactor",
  },
  co_Research330mmBarrageCannon_FactoryTechReactor: {
    name: "330mm Barrage Cannon",
    category: "ability",
    key: "Research330mmBarrageCannon",
    unit: "FactoryTechReactor",
  },
  co_Land_6: { name: "Land", category: "ability", key: "Land" },
  co_TerranVehicleAndShipWeaponsLevel1_Armory_2: {
    name: "Vehicle and Ship Weapons",
    category: "ability",
    key: "TerranVehicleAndShipWeaponsLevel1",
    unit: "Armory",
  },
  co_ResearchVehicleWeaponRange_Armory_2: {
    name: "Advanced Optics",
    category: "ability",
    key: "ResearchVehicleWeaponRange",
    unit: "Armory",
  },
  co_ResearchRegenerativeBioSteel_Armory_2: {
    name: "Regenerative Bio-Steel",
    category: "ability",
    key: "ResearchRegenerativeBioSteel",
    unit: "Armory",
  },
  co_Wraith_Starport: { name: "Wraith", category: "unit", key: "Wraith", unit: "Starport" },
  co_BuildHercules_Starport: {
    name: "Hercules",
    category: "unit",
    key: "BuildHercules",
    unit: "Starport",
  },
  co_BuildScienceVessel_Starport: {
    name: "Science Vessel",
    category: "unit",
    key: "BuildScienceVessel",
    unit: "Starport",
  },
  co_Lift_starportflying_2: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "starport_flying",
  },
  co_ResearchShockwaveMissileBattery_StarportTechLab_2: {
    name: "Shockwave Missile Battery",
    category: "ability",
    key: "ResearchShockwaveMissileBattery",
    unit: "StarportTechLab",
  },
  co_ResearchPhobosClassWeaponsSystem_StarportTechLab_2: {
    name: "Phobos-class Weapons System",
    category: "ability",
    key: "ResearchPhobosClassWeaponsSystem",
    unit: "StarportTechLab",
  },
  co_ResearchRipwaveMissiles_StarportTechLab_2: {
    name: "Ripwave Missiles",
    category: "ability",
    key: "ResearchRipwaveMissiles",
    unit: "StarportTechLab",
  },
  co_ResearchBansheeCloak_StarportTechReactor_2: {
    name: "Cloaking Field",
    category: "ability",
    key: "ResearchBansheeCloak",
    unit: "StarportTechReactor",
  },
  co_ResearchShockwaveMissileBattery_StarportTechReactor_2: {
    name: "Shockwave Missile Battery",
    category: "ability",
    key: "ResearchShockwaveMissileBattery",
    unit: "StarportTechReactor",
  },
  co_ResearchPhobosClassWeaponsSystem_StarportTechReactor_2: {
    name: "Phobos-class Weapons System",
    category: "ability",
    key: "ResearchPhobosClassWeaponsSystem",
    unit: "StarportTechReactor",
  },
  co_ResearchRipwaveMissiles_StarportTechReactor_2: {
    name: "Ripwave Missiles",
    category: "ability",
    key: "ResearchRipwaveMissiles",
    unit: "StarportTechReactor",
  },
  co_Land_7: { name: "Land", category: "ability", key: "Land" },
  co_ResearchDrakkenLaserDrillBFG_DrakkenLaserDrillCoop: {
    name: "Pulse Cannon",
    category: "ability",
    key: "ResearchDrakkenLaserDrillBFG",
    unit: "DrakkenLaserDrillCoop",
  },
  co_GhostHoldFire_NovaCoop: {
    name: "Hold Fire",
    category: "ability",
    key: "GhostHoldFire",
    unit: "NovaCoop",
  },
  co_WeaponsFree_NovaCoop: {
    name: "Weapons Free",
    category: "ability",
    key: "WeaponsFree",
    unit: "NovaCoop",
  },
  co_NovaWeaponImprovedCanisterRifleSnipe: {
    name: "Snipe",
    category: "ability",
    key: "NovaWeaponImprovedCanisterRifleSnipe",
  },
  co_NovaGadgetBoombots: { name: "Sabotage Drone", category: "unit", key: "NovaGadgetBoombots" },
  co_NovaUnitNuke: { name: "Tac Nuke Strike", category: "ability", key: "NovaUnitNuke" },
  co_NovaSwitchAssaultMode: {
    name: "Assault Mode",
    category: "ability",
    key: "NovaSwitchAssaultMode",
  },
  co_NovaWeaponImprovedCanisterRifleSnipe_2: {
    name: "Snipe",
    category: "ability",
    key: "NovaWeaponImprovedCanisterRifleSnipe",
  },
  co_NovaGadgetBoombots_2: { name: "Sabotage Drone", category: "unit", key: "NovaGadgetBoombots" },
  co_NovaUnitNuke_2: { name: "Tac Nuke Strike", category: "ability", key: "NovaUnitNuke" },
  co_NovaSwitchAssaultMode_2: {
    name: "Assault Mode",
    category: "ability",
    key: "NovaSwitchAssaultMode",
  },
  co_TerranBuild_SCV_Nova: {
    name: "Build Basic",
    category: "command",
    key: "TerranBuild",
    unit: "SCV",
    opens: "scv_build0",
  },
  co_TerranBuildAdvanced_SCV_Nova: {
    name: "Build Advanced",
    category: "command",
    key: "TerranBuildAdvanced",
    unit: "SCV",
    opens: "scv_build1",
  },
  co_MarineSuperStimpack_MarineBlackOps: {
    name: "Super Stimpack",
    category: "ability",
    key: "MarineSuperStimpack",
    unit: "Marine_BlackOps",
  },
  co_MagrailMunitions_MarauderBlackOps: {
    name: "Magrail Munitions",
    category: "ability",
    key: "MagrailMunitions",
    unit: "Marauder_BlackOps",
  },
  co_GhostHoldFire_GhostBlackOps: {
    name: "Hold Fire",
    category: "ability",
    key: "GhostHoldFire",
    unit: "Ghost_BlackOps",
  },
  co_WeaponsFree_GhostBlackOps: {
    name: "Weapons Free",
    category: "ability",
    key: "WeaponsFree",
    unit: "Ghost_BlackOps",
  },
  co_SnipeBlackOps_GhostBlackOps: {
    name: "Snipe",
    category: "ability",
    key: "Snipe_BlackOps",
    unit: "Ghost_BlackOps",
  },
  co_EMP_GhostBlackOps: {
    name: "EMP Round",
    category: "ability",
    key: "EMP",
    unit: "Ghost_BlackOps",
  },
  co_MorphToHellion_HellionBlackOps: {
    name: "Hellion Mode",
    category: "ability",
    key: "MorphToHellion",
    unit: "HellionBlackOps",
  },
  co_MorphToHellbatBlackOps_HellionBlackOps: {
    name: "Hellbat Mode",
    category: "ability",
    key: "MorphToHellbatBlackOps",
    unit: "HellionBlackOps",
  },
  co_HellbatJumpJetAssault_HellionBlackOps: {
    name: "Jump Jet Assault",
    category: "ability",
    key: "HellbatJumpJetAssault",
    unit: "HellionBlackOps",
  },
  co_SiegeTankBlackOpsSiege: {
    name: "Siege Mode",
    category: "unit",
    key: "SiegeTank_BlackOpsSiege",
  },
  co_SiegeTankBlackOpsUnsiege: {
    name: "Tank Mode",
    category: "unit",
    key: "SiegeTank_BlackOpsUnsiege",
  },
  co_DeploySpiderMines_SiegeTankBlackOps: {
    name: "Deploy Spider Mines",
    category: "ability",
    key: "DeploySpiderMines",
    unit: "SiegeTank_BlackOps",
  },
  co_LiberatorBlackOpsMorphtoAG_LiberatorBlackOps: {
    name: "Defender Mode",
    category: "ability",
    key: "Liberator_BlackOpsMorphtoAG",
    unit: "Liberator_BlackOps",
  },
  co_LiberatorBlackOpsMorphtoAA_LiberatorBlackOps: {
    name: "Fighter Mode",
    category: "ability",
    key: "Liberator_BlackOpsMorphtoAA",
    unit: "Liberator_BlackOps",
  },
  co_AutoTurret_RavenBlackOps: {
    name: "Railgun Turret",
    category: "ability",
    key: "AutoTurret",
    unit: "Raven_BlackOps",
  },
  co_PointDefenseDrone_RavenBlackOps: {
    name: "Deploy Bio-Mechanical Repair Drone",
    category: "ability",
    key: "PointDefenseDrone",
    unit: "Raven_BlackOps",
  },
  co_InstantHunterSeekerMissile_RavenBlackOps: {
    name: "Predator Missile",
    category: "ability",
    key: "InstantHunterSeekerMissile",
    unit: "Raven_BlackOps",
  },
  co_BansheeBlackOpsAirstrike_BansheeBlackOps: {
    name: "Rocket Barrage",
    category: "ability",
    key: "Banshee_BlackOpsAirstrike",
    unit: "Banshee_BlackOps",
  },
  co_DefensiveMatrixTarget_NovaDefensiveMatrixDrone: {
    name: "Defensive Matrix",
    category: "ability",
    key: "DefensiveMatrixTarget",
    unit: "NovaDefensiveMatrixDrone",
  },
  co_NovaBoombotBurrow_NovaBoombot: {
    name: "Detonation",
    category: "ability",
    key: "NovaBoombotBurrow",
    unit: "NovaBoombot",
  },
  co_BioMechanicalHeal_HealingDrone: {
    name: "Bio-Mechanical Repair",
    category: "ability",
    key: "BioMechanicalHeal",
    unit: "HealingDrone",
  },
  co_Lift_commandcenterflying_3: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "commandcenter_flying",
  },
  co_Land_8: { name: "Land", category: "ability", key: "Land" },
  co_Firebat_Barracks_2: { name: "Firebat", category: "unit", key: "Firebat", unit: "Barracks" },
  co_Lift_barracksflying_2: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "barracks_flying",
  },
  co_ResearchMarauderMagrailMunitions_BarracksTechLab: {
    name: "Magrail Munitions",
    category: "ability",
    key: "ResearchMarauderMagrailMunitions",
    unit: "BarracksTechLab",
  },
  co_ResearchIncineratorGauntlets_BarracksTechLab_2: {
    name: "Incinerator Gauntlets",
    category: "ability",
    key: "ResearchIncineratorGauntlets",
    unit: "BarracksTechLab",
  },
  co_ResearchJuggernautPlating_BarracksTechLab_2: {
    name: "Juggernaut Plating",
    category: "ability",
    key: "ResearchJuggernautPlating",
    unit: "BarracksTechLab",
  },
  co_ResearchShieldWall_BarracksTechReactor_2: {
    name: "Combat Shield",
    category: "ability",
    key: "ResearchShieldWall",
    unit: "BarracksTechReactor",
  },
  co_Stimpack_BarracksTechReactor_2: {
    name: "Stabilizer Medpacks",
    category: "ability",
    key: "Stimpack",
    unit: "BarracksTechReactor",
  },
  co_ResearchPunisherGrenades_BarracksTechReactor_2: {
    name: "Concussive Shells",
    category: "ability",
    key: "ResearchPunisherGrenades",
    unit: "BarracksTechReactor",
  },
  co_ResearchMarauderMagrailMunitions_BarracksTechReactor: {
    name: "Magrail Munitions",
    category: "ability",
    key: "ResearchMarauderMagrailMunitions",
    unit: "BarracksTechReactor",
  },
  co_ResearchIncineratorGauntlets_BarracksTechReactor_2: {
    name: "Incinerator Gauntlets",
    category: "ability",
    key: "ResearchIncineratorGauntlets",
    unit: "BarracksTechReactor",
  },
  co_ResearchJuggernautPlating_BarracksTechReactor_2: {
    name: "Juggernaut Plating",
    category: "ability",
    key: "ResearchJuggernautPlating",
    unit: "BarracksTechReactor",
  },
  co_Land_9: { name: "Land", category: "ability", key: "Land" },
  co_Salvage_NovaACLaserTurret: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "NovaACLaserTurret",
  },
  co_Salvage_MissileTurret_2: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "MissileTurret",
  },
  co_Goliath_Factory_2: { name: "Goliath", category: "unit", key: "Goliath", unit: "Factory" },
  co_Lift_factoryflying_3: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "factory_flying",
  },
  co_ResearchHellbatHellArmor_FactoryTechLab_3: {
    name: "Infernal Plating",
    category: "ability",
    key: "ResearchHellbatHellArmor",
    unit: "FactoryTechLab",
  },
  co_ResearchImprovedSiegeMode_FactoryTechLab_3: {
    name: "Advanced Siege Tech",
    category: "ability",
    key: "ResearchImprovedSiegeMode",
    unit: "FactoryTechLab",
  },
  co_ResearchMultiLockWeaponsSystem_FactoryTechLab_2: {
    name: "Multi-Lock Weapons System",
    category: "ability",
    key: "ResearchMultiLockWeaponsSystem",
    unit: "FactoryTechLab",
  },
  co_ResearchMaelstromRounds_FactoryTechLab_2: {
    name: "Maelstrom Rounds",
    category: "ability",
    key: "ResearchMaelstromRounds",
    unit: "FactoryTechLab",
  },
  co_ResearchLockOnRangeUpgrade_FactoryTechLab_2: {
    name: "Targeting Optics",
    category: "ability",
    key: "ResearchLockOnRangeUpgrade",
    unit: "FactoryTechLab",
  },
  co_ResearchHighCapacityBarrels_FactoryTechReactor_3: {
    name: "Infernal Pre-igniter",
    category: "ability",
    key: "ResearchHighCapacityBarrels",
    unit: "FactoryTechReactor",
  },
  co_ResearchHellbatHellArmor_FactoryTechReactor_3: {
    name: "Infernal Plating",
    category: "ability",
    key: "ResearchHellbatHellArmor",
    unit: "FactoryTechReactor",
  },
  co_ResearchImprovedSiegeMode_FactoryTechReactor_3: {
    name: "Advanced Siege Tech",
    category: "ability",
    key: "ResearchImprovedSiegeMode",
    unit: "FactoryTechReactor",
  },
  co_ResearchMultiLockWeaponsSystem_FactoryTechReactor_2: {
    name: "Multi-Lock Weapons System",
    category: "ability",
    key: "ResearchMultiLockWeaponsSystem",
    unit: "FactoryTechReactor",
  },
  co_ResearchMaelstromRounds_FactoryTechReactor_2: {
    name: "Maelstrom Rounds",
    category: "ability",
    key: "ResearchMaelstromRounds",
    unit: "FactoryTechReactor",
  },
  co_ResearchLockOnRangeUpgrade_FactoryTechReactor_2: {
    name: "Targeting Optics",
    category: "ability",
    key: "ResearchLockOnRangeUpgrade",
    unit: "FactoryTechReactor",
  },
  co_Land_10: { name: "Land", category: "ability", key: "Land" },
  co_TerranVehicleAndShipWeaponsLevel1_Armory_3: {
    name: "Vehicle and Ship Weapons",
    category: "ability",
    key: "TerranVehicleAndShipWeaponsLevel1",
    unit: "Armory",
  },
  co_Lift_starportflying_3: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "starport_flying",
  },
  co_ResearchShockwaveMissileBattery_StarportTechLab_3: {
    name: "Shockwave Missile Battery",
    category: "ability",
    key: "ResearchShockwaveMissileBattery",
    unit: "StarportTechLab",
  },
  co_ResearchPhobosClassWeaponsSystem_StarportTechLab_3: {
    name: "Phobos-class Weapons System",
    category: "ability",
    key: "ResearchPhobosClassWeaponsSystem",
    unit: "StarportTechLab",
  },
  co_ResearchRipwaveMissiles_StarportTechLab_3: {
    name: "Ripwave Missiles",
    category: "ability",
    key: "ResearchRipwaveMissiles",
    unit: "StarportTechLab",
  },
  co_ResearchMedivacCloakedHealBeam_StarportTechLab: {
    name: "Covert Triage",
    category: "ability",
    key: "ResearchMedivacCloakedHealBeam",
    unit: "StarportTechLab",
  },
  co_ResearchBansheeCloak_StarportTechReactor_3: {
    name: "Cloaking Field",
    category: "ability",
    key: "ResearchBansheeCloak",
    unit: "StarportTechReactor",
  },
  co_ResearchShockwaveMissileBattery_StarportTechReactor_3: {
    name: "Shockwave Missile Battery",
    category: "ability",
    key: "ResearchShockwaveMissileBattery",
    unit: "StarportTechReactor",
  },
  co_ResearchPhobosClassWeaponsSystem_StarportTechReactor_3: {
    name: "Phobos-class Weapons System",
    category: "ability",
    key: "ResearchPhobosClassWeaponsSystem",
    unit: "StarportTechReactor",
  },
  co_ResearchRipwaveMissiles_StarportTechReactor_3: {
    name: "Ripwave Missiles",
    category: "ability",
    key: "ResearchRipwaveMissiles",
    unit: "StarportTechReactor",
  },
  co_ResearchMedivacCloakedHealBeam_StarportTechReactor: {
    name: "Covert Triage",
    category: "ability",
    key: "ResearchMedivacCloakedHealBeam",
    unit: "StarportTechReactor",
  },
  co_ResearchSuperScience_StarportTechReactor: {
    name: "Enhanced Manufacturing",
    category: "ability",
    key: "ResearchSuperScience",
    unit: "StarportTechReactor",
  },
  co_Land_11: { name: "Land", category: "ability", key: "Land" },
  co_ResearchNovaDetector_GhostAcademyNova: {
    name: "Ghost Visor",
    category: "ability",
    key: "ResearchNovaDetector",
    unit: "GhostAcademyNova",
  },
  co_ResearchNovaLifeRegen_GhostAcademyNova: {
    name: "Caduceus Reactor",
    category: "ability",
    key: "ResearchNovaLifeRegen",
    unit: "GhostAcademyNova",
  },
  co_ResearchNovaShotgunBlastRange_GhostAcademyNova: {
    name: "Infernal Projectiles",
    category: "ability",
    key: "ResearchNovaShotgunBlastRange",
    unit: "GhostAcademyNova",
  },
  co_ResearchNovaSnipeRefund_GhostAcademyNova: {
    name: "Operational Efficiency",
    category: "ability",
    key: "ResearchNovaSnipeRefund",
    unit: "GhostAcademyNova",
  },
  co_TerranBuild_HHSCV_Han: {
    name: "Build Basic",
    category: "command",
    key: "TerranBuild",
    unit: "HHSCV",
    opens: "scv_build0",
  },
  co_TerranBuildAdvanced_HHSCV_Han: {
    name: "Build Advanced",
    category: "command",
    key: "TerranBuildAdvanced",
    unit: "HHSCV",
    opens: "scv_build1",
  },
  co_CommandCenter_HHSCV: {
    name: "Command Center",
    category: "structure",
    key: "CommandCenter",
    unit: "HHSCV",
  },
  co_Refinery_HHSCV: { name: "Refinery", category: "structure", key: "Refinery", unit: "HHSCV" },
  co_SupplyDepot_HHSCV: {
    name: "Supply Depot",
    category: "structure",
    key: "SupplyDepot",
    unit: "HHSCV",
  },
  co_BuildHHMercStarport_HHSCV: {
    name: "Assault Galleon",
    category: "structure",
    key: "BuildHHMercStarport",
    unit: "HHSCV",
  },
  co_HHMercCompound_HHSCV: {
    name: "Engineering Bay",
    category: "structure",
    key: "HHMercCompound",
    unit: "HHSCV",
  },
  co_MissileTurret_HHSCV: {
    name: "Missile Turret",
    category: "structure",
    key: "MissileTurret",
    unit: "HHSCV",
  },
  co_BuildHHBomberPlatform_HHSCV: {
    name: "Strike Fighter Platform",
    category: "structure",
    key: "BuildHHBomberPlatform",
    unit: "HHSCV",
  },
  co_HHArmory_HHSCV: { name: "Armory", category: "structure", key: "HHArmory", unit: "HHSCV" },
  co_FusionCore_HHSCV: {
    name: "Fusion Core",
    category: "structure",
    key: "FusionCore",
    unit: "HHSCV",
  },
  co_HHKD8Charge_HHReaper: {
    name: "KD8 Charge",
    category: "ability",
    key: "HHKD8Charge",
    unit: "HHReaper",
  },
  co_HHReaperFly_HHReaper: {
    name: "Jet Pack Overdrive",
    category: "ability",
    key: "HHReaperFly",
    unit: "HHReaper",
  },
  co_WidowMineBurrow_HHWidowMine: {
    name: "Activate Mine",
    category: "ability",
    key: "WidowMineBurrow",
    unit: "HHWidowMine",
  },
  co_WidowMineUnburrow_HHWidowMine: {
    name: "Deactivate Mine",
    category: "ability",
    key: "WidowMineUnburrow",
    unit: "HHWidowMine",
  },
  co_MorphToHHHellion_HHHellionTank_hellbathellion: {
    name: "Hellion Mode",
    category: "command",
    key: "MorphToHHHellion",
    unit: "HHHellionTank",
    opens: "hellbat_hellion",
  },
  co_MorphToHellionTank_HHHellion: {
    name: "Hellbat Mode",
    category: "ability",
    key: "MorphToHellionTank",
    unit: "HHHellion",
  },
  co_HHHellionBomb_HHHellion: {
    name: "Tar Bombs",
    category: "ability",
    key: "HHHellionBomb",
    unit: "HHHellion",
  },
  co_FleetwideJump_HHWraith: {
    name: "Tactical Jump",
    category: "ability",
    key: "FleetwideJump",
    unit: "HHWraith",
  },
  co_WraithCloakOn_HHWraith: {
    name: "Cloak",
    category: "ability",
    key: "WraithCloakOn",
    unit: "HHWraith",
  },
  co_WraithCloakOff_HHWraith: {
    name: "Decloak",
    category: "ability",
    key: "WraithCloakOff",
    unit: "HHWraith",
  },
  co_FleetwideJump_HHVikingFighter: {
    name: "Tactical Jump",
    category: "ability",
    key: "FleetwideJump",
    unit: "HHVikingFighter",
  },
  co_HHVikingRockets_HHVikingFighter: {
    name: "W.I.L.D. Missiles",
    category: "ability",
    key: "HHVikingRockets",
    unit: "HHVikingFighter",
  },
  co_AssaultMode_vikingassaultmode: {
    name: "Assault Mode",
    category: "unit",
    key: "AssaultMode",
    opens: "viking_assaultmode",
  },
  co_FleetwideJump_HHVikingAssault: {
    name: "Tactical Jump",
    category: "ability",
    key: "FleetwideJump",
    unit: "HHVikingAssault",
  },
  co_FleetwideJump_HHRaven: {
    name: "Tactical Jump",
    category: "ability",
    key: "FleetwideJump",
    unit: "HHRaven",
  },
  co_HHNomadTargetLock_HHRaven: {
    name: "Analyze Weakness",
    category: "ability",
    key: "HHNomadTargetLock",
    unit: "HHRaven",
  },
  co_MorphtoHHRavenSiege_HHRaven: {
    name: "Enable Silent Mode",
    category: "ability",
    key: "MorphtoHHRavenSiege",
    unit: "HHRaven",
  },
  co_MorphtoHHRaven_HHRaven: {
    name: "Cancel Silent Mode",
    category: "ability",
    key: "MorphtoHHRaven",
    unit: "HHRaven",
  },
  co_Hyperjump_HHBattlecruiser: {
    name: "Tactical Jump",
    category: "ability",
    key: "Hyperjump",
    unit: "HHBattlecruiser",
  },
  co_HHYamatoShots_HHBattlecruiser: {
    name: "Overcharged Reactor",
    category: "ability",
    key: "HHYamatoShots",
    unit: "HHBattlecruiser",
  },
  co_HHBattlecruiserShots_HHBattlecruiser: {
    name: "Revert to ATX Laser Battery",
    category: "ability",
    key: "HHBattlecruiserShots",
    unit: "HHBattlecruiser",
  },
  co_Lift_commandcenterflying_4: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "commandcenter_flying",
  },
  co_Land_12: { name: "Land", category: "ability", key: "Land" },
  co_Lower_SupplyDepot_supplydepotlowered_3: {
    name: "Lower",
    category: "command",
    key: "Lower",
    unit: "SupplyDepot",
    opens: "supplydepot_lowered",
  },
  co_Raise_SupplyDepotLowered_3: {
    name: "Raise",
    category: "unit",
    key: "Raise",
    unit: "SupplyDepotLowered",
  },
  co_ResearchHHMercStarportHangarBay_HHMercStarportUpgraded: {
    name: "Install Drone Hangar",
    category: "ability",
    key: "ResearchHHMercStarportHangarBay",
    unit: "HHMercStarportUpgraded",
  },
  co_HHReaper_HHMercStarportUpgraded: {
    name: "Reaper",
    category: "unit",
    key: "HHReaper",
    unit: "HHMercStarportUpgraded",
  },
  co_HHWidowMine_HHMercStarportUpgraded: {
    name: "Widow Mine",
    category: "unit",
    key: "HHWidowMine",
    unit: "HHMercStarportUpgraded",
  },
  co_HHHellion_HHMercStarportUpgraded: {
    name: "Hellion",
    category: "unit",
    key: "HHHellion",
    unit: "HHMercStarportUpgraded",
  },
  co_HHHellionTank_HHMercStarportUpgraded: {
    name: "Hellbat",
    category: "unit",
    key: "HHHellionTank",
    unit: "HHMercStarportUpgraded",
  },
  co_ResearchHHReaperClusterBombs_HHMercCompound: {
    name: "LE9 Cluster Charges",
    category: "ability",
    key: "ResearchHHReaperClusterBombs",
    unit: "HHMercCompound",
  },
  co_ResearchHHReaperFlight_HHMercCompound: {
    name: "Jet Pack Overdrive",
    category: "ability",
    key: "ResearchHHReaperFlight",
    unit: "HHMercCompound",
  },
  co_ResearchHHWidowMineDeathBlossom_HHMercCompound: {
    name: "Executioner Missiles",
    category: "ability",
    key: "ResearchHHWidowMineDeathBlossom",
    unit: "HHMercCompound",
  },
  co_ResearchHHWidowMineRangeAttack_HHMercCompound: {
    name: "Black Market Launchers",
    category: "ability",
    key: "ResearchHHWidowMineRangeAttack",
    unit: "HHMercCompound",
  },
  co_ResearchHHHellionDeathStim_HHMercCompound: {
    name: "Aerosol Stim Emitters",
    category: "ability",
    key: "ResearchHHHellionDeathStim",
    unit: "HHMercCompound",
  },
  co_ResearchHHHellionRocket_HHMercCompound: {
    name: "Tar Bombs",
    category: "ability",
    key: "ResearchHHHellionRocket",
    unit: "HHMercCompound",
  },
  co_ResearchHHHellionDeathFear_HHMercCompound: {
    name: "Wildfire Explosives",
    category: "ability",
    key: "ResearchHHHellionDeathFear",
    unit: "HHMercCompound",
  },
  co_ResearchHHHellionAttackDoT_HHMercCompound: {
    name: "Immolation Fluid",
    category: "ability",
    key: "ResearchHHHellionAttackDoT",
    unit: "HHMercCompound",
  },
  co_Salvage_MissileTurret_3: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "MissileTurret",
  },
  co_HHBomberAreaBomb_HHBomberPlatform: {
    name: "Precision Strike",
    category: "unit",
    key: "HHBomberAreaBomb",
    unit: "HHBomberPlatform",
  },
  co_TrainHHBomber_HHBomberPlatform: {
    name: "Strike Fighter",
    category: "unit",
    key: "TrainHHBomber",
    unit: "HHBomberPlatform",
  },
  co_TerranVehicleAndShipWeaponsLevel1_Armory_4: {
    name: "Vehicle and Ship Weapons",
    category: "ability",
    key: "TerranVehicleAndShipWeaponsLevel1",
    unit: "Armory",
  },
  co_Wraith_HHStarport: {
    name: "Asteria Wraith",
    category: "unit",
    key: "Wraith",
    unit: "HHStarport",
  },
  co_VikingFighter_HHStarport: {
    name: "Deimos Viking",
    category: "unit",
    key: "VikingFighter",
    unit: "HHStarport",
  },
  co_Battlecruiser_HHStarport: {
    name: "Sovereign Battlecruiser",
    category: "unit",
    key: "Battlecruiser",
    unit: "HHStarport",
  },
  co_HHRaven_HHStarport: {
    name: "Theia Raven",
    category: "unit",
    key: "HHRaven",
    unit: "HHStarport",
  },
  co_HHTechLabStarport_HHStarport: {
    name: "Han’s Tech Lab",
    category: "unit",
    key: "HHTechLabStarport",
    unit: "HHStarport",
  },
  co_ResearchShockwaveMissileBattery_StarportTechLab_4: {
    name: "Shockwave Missile Battery",
    category: "ability",
    key: "ResearchShockwaveMissileBattery",
    unit: "StarportTechLab",
  },
  co_ResearchPhobosClassWeaponsSystem_StarportTechLab_4: {
    name: "Phobos-class Weapons System",
    category: "ability",
    key: "ResearchPhobosClassWeaponsSystem",
    unit: "StarportTechLab",
  },
  co_ResearchRipwaveMissiles_StarportTechLab_4: {
    name: "Ripwave Missiles",
    category: "ability",
    key: "ResearchRipwaveMissiles",
    unit: "StarportTechLab",
  },
  co_ResearchMedivacCloakedHealBeam_StarportTechLab_2: {
    name: "Covert Triage",
    category: "ability",
    key: "ResearchMedivacCloakedHealBeam",
    unit: "StarportTechLab",
  },
  co_ResearchHHTacticalJumpCharges_StarportTechLab: {
    name: "Tactical Jump",
    category: "ability",
    key: "ResearchHHTacticalJumpCharges",
    unit: "StarportTechLab",
  },
  co_ResearchHHBomberNapalm_FusionCore: {
    name: "Napalm Payload",
    category: "ability",
    key: "ResearchHHBomberNapalm",
    unit: "FusionCore",
  },
  co_TychusHeroCommonAbil1: { name: "Move", category: "ability", key: "TychusHeroCommonAbil1" },
  co_TychusHeroCommonAbil2: { name: "Stop", category: "ability", key: "TychusHeroCommonAbil2" },
  co_TychusHeroCommonAbil3: {
    name: "Hold Position",
    category: "ability",
    key: "TychusHeroCommonAbil3",
  },
  co_TychusHeroCommonAbil4: { name: "Patrol", category: "ability", key: "TychusHeroCommonAbil4" },
  co_TychusHeroCommonAbil5: { name: "Attack", category: "ability", key: "TychusHeroCommonAbil5" },
  co_TychusOdinRedButton_TychusOdin: {
    name: "Barrage",
    category: "ability",
    key: "TychusOdinRedButton",
    unit: "TychusOdin",
  },
  co_TychusHeroCommonAbil2_2: { name: "Stop", category: "ability", key: "TychusHeroCommonAbil2" },
  co_TychusHeroCommonAbil3_2: {
    name: "Hold Position",
    category: "ability",
    key: "TychusHeroCommonAbil3",
  },
  co_TychusHeroCommonAbil4_2: { name: "Patrol", category: "ability", key: "TychusHeroCommonAbil4" },
  co_TychusHeroCommonAbil5_2: { name: "Attack", category: "ability", key: "TychusHeroCommonAbil5" },
  co_TychusReaperEvasionBuff_TychusReaper: {
    name: "Procyon Shade Suit",
    category: "ability",
    key: "TychusReaperEvasionBuff",
    unit: "TychusReaper",
  },
  co_TychusHeroCommonAbil1_2: { name: "Move", category: "ability", key: "TychusHeroCommonAbil1" },
  co_TychusHeroCommonAbil2_3: { name: "Stop", category: "ability", key: "TychusHeroCommonAbil2" },
  co_TychusHeroCommonAbil3_3: {
    name: "Hold Position",
    category: "ability",
    key: "TychusHeroCommonAbil3",
  },
  co_TychusHeroCommonAbil4_3: { name: "Patrol", category: "ability", key: "TychusHeroCommonAbil4" },
  co_TychusHeroCommonAbil5_3: { name: "Attack", category: "ability", key: "TychusHeroCommonAbil5" },
  co_TychusWarhoundHaywireMissiles_TychusWarhound: {
    name: "SA-55 Thunderbolt Missiles",
    category: "ability",
    key: "TychusWarhoundHaywireMissiles",
    unit: "TychusWarhound",
  },
  co_TychusHeroCommonAbil1_3: { name: "Move", category: "ability", key: "TychusHeroCommonAbil1" },
  co_TychusHeroCommonAbil2_4: { name: "Stop", category: "ability", key: "TychusHeroCommonAbil2" },
  co_TychusHeroCommonAbil3_4: {
    name: "Hold Position",
    category: "ability",
    key: "TychusHeroCommonAbil3",
  },
  co_TychusHeroCommonAbil4_4: { name: "Patrol", category: "ability", key: "TychusHeroCommonAbil4" },
  co_TychusHeroCommonAbil5_4: { name: "Attack", category: "ability", key: "TychusHeroCommonAbil5" },
  co_TychusWarhoundTurretHaywireMissiles_TychusWarhoundAutoTurret: {
    name: "SA-55 Thunderbolt Missiles",
    category: "ability",
    key: "TychusWarhoundTurretHaywireMissiles",
    unit: "TychusWarhoundAutoTurret",
  },
  co_TychusHeroCommonAbil1_4: { name: "Move", category: "ability", key: "TychusHeroCommonAbil1" },
  co_TychusHeroCommonAbil2_5: { name: "Stop", category: "ability", key: "TychusHeroCommonAbil2" },
  co_TychusHeroCommonAbil3_5: {
    name: "Hold Position",
    category: "ability",
    key: "TychusHeroCommonAbil3",
  },
  co_TychusHeroCommonAbil4_5: { name: "Patrol", category: "ability", key: "TychusHeroCommonAbil4" },
  co_TychusHeroCommonAbil5_5: { name: "Attack", category: "ability", key: "TychusHeroCommonAbil5" },
  co_TychusMarauderSuperStim_TychusMarauder: {
    name: "Secret Stash Stimpack",
    category: "ability",
    key: "TychusMarauderSuperStim",
    unit: "TychusMarauder",
  },
  co_TychusHeroCommonAbil1_5: { name: "Move", category: "ability", key: "TychusHeroCommonAbil1" },
  co_TychusHeroCommonAbil2_6: { name: "Stop", category: "ability", key: "TychusHeroCommonAbil2" },
  co_TychusHeroCommonAbil3_6: {
    name: "Hold Position",
    category: "ability",
    key: "TychusHeroCommonAbil3",
  },
  co_TychusHeroCommonAbil4_6: { name: "Patrol", category: "ability", key: "TychusHeroCommonAbil4" },
  co_TychusHeroCommonAbil5_6: { name: "Attack", category: "ability", key: "TychusHeroCommonAbil5" },
  co_TychusHeroCommonAbil1_6: { name: "Move", category: "ability", key: "TychusHeroCommonAbil1" },
  co_TychusHeroCommonAbil2_7: { name: "Stop", category: "ability", key: "TychusHeroCommonAbil2" },
  co_TychusHeroCommonAbil3_7: {
    name: "Hold Position",
    category: "ability",
    key: "TychusHeroCommonAbil3",
  },
  co_TychusHeroCommonAbil4_7: { name: "Patrol", category: "ability", key: "TychusHeroCommonAbil4" },
  co_TychusHeroCommonAbil5_7: { name: "Attack", category: "ability", key: "TychusHeroCommonAbil5" },
  co_TychusGhostPsychicSnare_TychusGhost: {
    name: "Psi Projector",
    category: "ability",
    key: "TychusGhostPsychicSnare",
    unit: "TychusGhost",
  },
  co_TychusHeroCommonAbil1_7: { name: "Move", category: "ability", key: "TychusHeroCommonAbil1" },
  co_TychusHeroCommonAbil2_8: { name: "Stop", category: "ability", key: "TychusHeroCommonAbil2" },
  co_TychusHeroCommonAbil3_8: {
    name: "Hold Position",
    category: "ability",
    key: "TychusHeroCommonAbil3",
  },
  co_TychusHeroCommonAbil4_8: { name: "Patrol", category: "ability", key: "TychusHeroCommonAbil4" },
  co_TychusHeroCommonAbil5_8: { name: "Attack", category: "ability", key: "TychusHeroCommonAbil5" },
  co_TychusHeroCommonAbil1_8: { name: "Move", category: "ability", key: "TychusHeroCommonAbil1" },
  co_TychusHeroCommonAbil2_9: { name: "Stop", category: "ability", key: "TychusHeroCommonAbil2" },
  co_TychusHeroCommonAbil3_9: {
    name: "Hold Position",
    category: "ability",
    key: "TychusHeroCommonAbil3",
  },
  co_TychusHeroCommonAbil4_9: { name: "Patrol", category: "ability", key: "TychusHeroCommonAbil4" },
  co_TychusHeroCommonAbil5_9: { name: "Attack", category: "ability", key: "TychusHeroCommonAbil5" },
  co_TychusMedicDefensiveMatrix_TychusMedic: {
    name: "XM-77 Matrix Generator",
    category: "ability",
    key: "TychusMedicDefensiveMatrix",
    unit: "TychusMedic",
  },
  co_TychusMedicHeal_TychusMedic: {
    name: "Super Heal",
    category: "ability",
    key: "TychusMedicHeal",
    unit: "TychusMedic",
  },
  co_TychusHeroCommonAbil1_9: { name: "Move", category: "ability", key: "TychusHeroCommonAbil1" },
  co_TychusHeroCommonAbil2_10: { name: "Stop", category: "ability", key: "TychusHeroCommonAbil2" },
  co_TychusHeroCommonAbil3_10: {
    name: "Hold Position",
    category: "ability",
    key: "TychusHeroCommonAbil3",
  },
  co_TychusHeroCommonAbil4_10: {
    name: "Patrol",
    category: "ability",
    key: "TychusHeroCommonAbil4",
  },
  co_TychusHeroCommonAbil5_10: {
    name: "Attack",
    category: "ability",
    key: "TychusHeroCommonAbil5",
  },
  co_TerranBuild_TychusSCV_Tychus: {
    name: "Build Basic",
    category: "command",
    key: "TerranBuild",
    unit: "TychusSCV",
    opens: "scv_build0",
  },
  co_TychusCommandCenter_TychusSCV: {
    name: "Command Center",
    category: "structure",
    key: "TychusCommandCenter",
    unit: "TychusSCV",
  },
  co_TychusRefinery_TychusSCV: {
    name: "Refinery",
    category: "structure",
    key: "TychusRefinery",
    unit: "TychusSCV",
  },
  co_BuildTychusBar_TychusSCV: {
    name: "Joeyray’s Bar",
    category: "structure",
    key: "BuildTychusBar",
    unit: "TychusSCV",
  },
  co_TychusEngineeringBay_TychusSCV: {
    name: "Engineering Bay",
    category: "structure",
    key: "TychusEngineeringBay",
    unit: "TychusSCV",
  },
  co_TychusSCVAutoTurret_TychusSCV: {
    name: "Auto-Turret",
    category: "structure",
    key: "TychusSCVAutoTurret",
    unit: "TychusSCV",
  },
  co_TychusMercCompound_TychusSCV: {
    name: "Gunslingers’ Hideout",
    category: "structure",
    key: "TychusMercCompound",
    unit: "TychusSCV",
  },
  co_TychusArmory_TychusSCV: {
    name: "Muscle Armory",
    category: "structure",
    key: "TychusArmory",
    unit: "TychusSCV",
  },
  co_TychusGhostAcademy_TychusSCV: {
    name: "Fixers’ Safehouse",
    category: "structure",
    key: "TychusGhostAcademy",
    unit: "TychusSCV",
  },
  co_BuildTychusMedivacPlatform_TychusSCV: {
    name: "Medivac Platform",
    category: "structure",
    key: "BuildTychusMedivacPlatform",
    unit: "TychusSCV",
  },
  co_TychusSCV_TychusCommandCenter: {
    name: "SCV",
    category: "unit",
    key: "TychusSCV",
    unit: "TychusCommandCenter",
  },
  co_Lift_commandcenterflying_5: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "commandcenter_flying",
  },
  co_Land_13: { name: "Land", category: "ability", key: "Land" },
  co_TychusACHero_TychusResearchCenter: {
    name: "Tychus Findlay",
    category: "unit",
    key: "TychusACHero",
    unit: "TychusResearchCenter",
  },
  co_TychusReaper_TychusResearchCenter: {
    name: "Crooked Sam",
    category: "unit",
    key: "TychusReaper",
    unit: "TychusResearchCenter",
  },
  co_TychusWarhound_TychusResearchCenter: {
    name: "James “Sirius” Sykes",
    category: "unit",
    key: "TychusWarhound",
    unit: "TychusResearchCenter",
  },
  co_TychusFirebat_TychusResearchCenter: {
    name: "Miles “Blaze” Lewis",
    category: "unit",
    key: "TychusFirebat",
    unit: "TychusResearchCenter",
  },
  co_TychusHERC_TychusResearchCenter: {
    name: "Rob “Cannonball” Boswell",
    category: "unit",
    key: "TychusHERC",
    unit: "TychusResearchCenter",
  },
  co_TychusMarauder_TychusResearchCenter: {
    name: "Kev “Rattlesnake” West",
    category: "unit",
    key: "TychusMarauder",
    unit: "TychusResearchCenter",
  },
  co_TychusGhost_TychusResearchCenter: {
    name: "Vega",
    category: "unit",
    key: "TychusGhost",
    unit: "TychusResearchCenter",
  },
  co_TychusSpectre_TychusResearchCenter: {
    name: "Nux",
    category: "unit",
    key: "TychusSpectre",
    unit: "TychusResearchCenter",
  },
  co_TychusMedic_TychusResearchCenter: {
    name: "Lt. Layna Nikara",
    category: "unit",
    key: "TychusMedic",
    unit: "TychusResearchCenter",
  },
  co_TychusOutlawWeaponsLevel1_TychusEngineeringBay: {
    name: "Outlaw Weapons",
    category: "ability",
    key: "TychusOutlawWeaponsLevel1",
    unit: "TychusEngineeringBay",
  },
  co_TychusOutlawArmorLevel1_TychusEngineeringBay: {
    name: "Outlaw Armor",
    category: "ability",
    key: "TychusOutlawArmorLevel1",
    unit: "TychusEngineeringBay",
  },
  co_TychusSquadAttackSpeed_TychusEngineeringBay: {
    name: "ITC-E Triggers",
    category: "unit",
    key: "TychusSquadAttackSpeed",
    unit: "TychusEngineeringBay",
  },
  co_TychusSquadHealth_TychusEngineeringBay: {
    name: "Endurance Supplements",
    category: "unit",
    key: "TychusSquadHealth",
    unit: "TychusEngineeringBay",
  },
  co_TychusSquadDetection_TychusEngineeringBay: {
    name: "Flashforce GDM Visor",
    category: "unit",
    key: "TychusSquadDetection",
    unit: "TychusEngineeringBay",
  },
  co_TychusUpgradeOdinRedButton_TychusEngineeringBay: {
    name: "Big Red Button",
    category: "unit",
    key: "TychusUpgradeOdinRedButton",
    unit: "TychusEngineeringBay",
  },
  co_Salvage_TychusSCVAutoTurret: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "TychusSCVAutoTurret",
  },
  co_TychusACImplosionGrenadesLearn_TychusMercCompound: {
    name: "Purchase KD9a Implosion Core",
    category: "unit",
    key: "TychusACImplosionGrenadesLearn",
    unit: "TychusMercCompound",
  },
  co_TychusACRageGrenadesLearn_TychusMercCompound: {
    name: "Purchase Vanadium Shell",
    category: "unit",
    key: "TychusACRageGrenadesLearn",
    unit: "TychusMercCompound",
  },
  co_TychusACPiercingRoundsLearn_TychusMercCompound: {
    name: "Purchase Kel-Morian Ripper Rounds",
    category: "unit",
    key: "TychusACPiercingRoundsLearn",
    unit: "TychusMercCompound",
  },
  co_TychusACBandofBrothersLearn_TychusMercCompound: {
    name: "Purchase SureShot Networked Helm",
    category: "unit",
    key: "TychusACBandofBrothersLearn",
    unit: "TychusMercCompound",
  },
  co_TychusReaperBombDamageLearn_TychusMercCompound: {
    name: "Purchase LarsCorp G7 Charges",
    category: "unit",
    key: "TychusReaperBombDamageLearn",
    unit: "TychusMercCompound",
  },
  co_TychusReaperBombStunLearn_TychusMercCompound: {
    name: "Purchase Moebius Restraint Matrix",
    category: "unit",
    key: "TychusReaperBombStunLearn",
    unit: "TychusMercCompound",
  },
  co_TychusReaperEvasionLearn_TychusMercCompound: {
    name: "Purchase Procyon Shade Suit",
    category: "unit",
    key: "TychusReaperEvasionLearn",
    unit: "TychusMercCompound",
  },
  co_TychusReaperBombChargesLearn_TychusMercCompound: {
    name: "Purchase Enhanced Hostilities Kit",
    category: "unit",
    key: "TychusReaperBombChargesLearn",
    unit: "TychusMercCompound",
  },
  co_TychusWarhoundHaywireMissilesUpgrade_TychusMercCompound: {
    name: "Purchase SA-55 Thunderbolt Missiles",
    category: "unit",
    key: "TychusWarhoundHaywireMissilesUpgrade",
    unit: "TychusMercCompound",
  },
  co_TychusWarhoundFearUpgrade_TychusMercCompound: {
    name: "Purchase Moebius M34 Terror Rounds",
    category: "unit",
    key: "TychusWarhoundFearUpgrade",
    unit: "TychusMercCompound",
  },
  co_TychusWarhoundDeathExplosionUpgrade_TychusMercCompound: {
    name: "Purchase D99 Detonator",
    category: "unit",
    key: "TychusWarhoundDeathExplosionUpgrade",
    unit: "TychusMercCompound",
  },
  co_TychusWarhoundTurretUpgrade_TychusMercCompound: {
    name: "Purchase Umojan Turret Frame",
    category: "unit",
    key: "TychusWarhoundTurretUpgrade",
    unit: "TychusMercCompound",
  },
  co_TychusFirebatPremiumPetroleumLearn_TychusArmory: {
    name: "Purchase High Capacity Containers",
    category: "unit",
    key: "TychusFirebatPremiumPetroleumLearn",
    unit: "TychusArmory",
  },
  co_TychusFirebatBlueFlameOilLearn_TychusArmory: {
    name: "Purchase Hades Oil",
    category: "unit",
    key: "TychusFirebatBlueFlameOilLearn",
    unit: "TychusArmory",
  },
  co_TychusFirebatIncendiaryPetroleumLearn_TychusArmory: {
    name: "Purchase Wildflame Fuel Additives",
    category: "unit",
    key: "TychusFirebatIncendiaryPetroleumLearn",
    unit: "TychusArmory",
  },
  co_TychusFirebatShieldLearn_TychusArmory: {
    name: "Purchase XCMC-670 Combat Suit",
    category: "unit",
    key: "TychusFirebatShieldLearn",
    unit: "TychusArmory",
  },
  co_TychusHercGrappleImpacts_TychusArmory: {
    name: "Purchase X-71 Impact Boots",
    category: "unit",
    key: "TychusHercGrappleImpacts",
    unit: "TychusArmory",
  },
  co_TychusHercGrappleArmor_TychusArmory: {
    name: "Purchase Critical Response System",
    category: "unit",
    key: "TychusHercGrappleArmor",
    unit: "TychusArmory",
  },
  co_TychusHercRageLearn_TychusArmory: {
    name: "Purchase Redline Power Cells",
    category: "unit",
    key: "TychusHercRageLearn",
    unit: "TychusArmory",
  },
  co_TychusHercCrit_TychusArmory: {
    name: "Purchase M.A.L.I.C.E. Ammunition",
    category: "unit",
    key: "TychusHercCrit",
    unit: "TychusArmory",
  },
  co_TychusMarauderHealingWardBuffLearn_TychusArmory: {
    name: "Purchase Umojan Signal Modulator",
    category: "unit",
    key: "TychusMarauderHealingWardBuffLearn",
    unit: "TychusArmory",
  },
  co_TychusMarauderHealingWardSpeedBuffLearn_TychusArmory: {
    name: "Purchase Moebius Aggression Blend",
    category: "unit",
    key: "TychusMarauderHealingWardSpeedBuffLearn",
    unit: "TychusArmory",
  },
  co_TychusMarauderSuperStimLearn_TychusArmory: {
    name: "Purchase Secret Stash Stimpack",
    category: "unit",
    key: "TychusMarauderSuperStimLearn",
    unit: "TychusArmory",
  },
  co_TychusMarauderAttackSplashLearn_TychusArmory: {
    name: "Purchase Hammer Munitions",
    category: "unit",
    key: "TychusMarauderAttackSplashLearn",
    unit: "TychusArmory",
  },
  co_TychusGhostDominateBuffLearn_TychusGhostAcademy: {
    name: "Purchase Moebius Psionic Motivator",
    category: "unit",
    key: "TychusGhostDominateBuffLearn",
    unit: "TychusGhostAcademy",
  },
  co_TychusGhostConfusingDominationLearn_TychusGhostAcademy: {
    name: "Purchase Neural Disruption Device",
    category: "unit",
    key: "TychusGhostConfusingDominationLearn",
    unit: "TychusGhostAcademy",
  },
  co_TychusGhostPsychicSnareLearn_TychusGhostAcademy: {
    name: "Purchase Psi Projector",
    category: "unit",
    key: "TychusGhostPsychicSnareLearn",
    unit: "TychusGhostAcademy",
  },
  co_TychusGhostConcentrationHelmetLearn_TychusGhostAcademy: {
    name: "Purchase Type-88 Persuader",
    category: "unit",
    key: "TychusGhostConcentrationHelmetLearn",
    unit: "TychusGhostAcademy",
  },
  co_TychusSpectreSuperUltrasonicPulseLearn_TychusGhostAcademy: {
    name: "Purchase T4 Cloudburst Shells",
    category: "unit",
    key: "TychusSpectreSuperUltrasonicPulseLearn",
    unit: "TychusGhostAcademy",
  },
  co_TychusSpectreVisionSuitLearn_TychusGhostAcademy: {
    name: "Purchase Ultrasonic Boosters",
    category: "unit",
    key: "TychusSpectreVisionSuitLearn",
    unit: "TychusGhostAcademy",
  },
  co_TychusSpectreExtendedPulseGunLearn_TychusGhostAcademy: {
    name: "Purchase Crystalline Amplifiers",
    category: "unit",
    key: "TychusSpectreExtendedPulseGunLearn",
    unit: "TychusGhostAcademy",
  },
  co_TychusSpectreBrillianceAuraLearn_TychusGhostAcademy: {
    name: "Purchase N3 Networking",
    category: "unit",
    key: "TychusSpectreBrillianceAuraLearn",
    unit: "TychusGhostAcademy",
  },
  co_TychusMedicHealingSprayUpgrade_TychusGhostAcademy: {
    name: "Purchase Umojan Repair Nanites",
    category: "unit",
    key: "TychusMedicHealingSprayUpgrade",
    unit: "TychusGhostAcademy",
  },
  co_TychusMedicHealUpgrade_TychusGhostAcademy: {
    name: "Purchase Procyon Serum",
    category: "unit",
    key: "TychusMedicHealUpgrade",
    unit: "TychusGhostAcademy",
  },
  co_TychusMedicDoubleHealLearn_TychusGhostAcademy: {
    name: "Purchase Procyon Twin Heal Beam Gauntlet",
    category: "unit",
    key: "TychusMedicDoubleHealLearn",
    unit: "TychusGhostAcademy",
  },
  co_TychusMedicDefensiveMatrixLearn_TychusGhostAcademy: {
    name: "Purchase XM-77 Matrix Generator",
    category: "unit",
    key: "TychusMedicDefensiveMatrixLearn",
    unit: "TychusGhostAcademy",
  },
  co_TychusMedicTransportUnits_TychusMedivacPlatform: {
    name: "Medivac Pickup",
    category: "unit",
    key: "TychusMedicTransportUnits",
    unit: "TychusMedivacPlatform",
  },
  co_TerranBuild_SCVMengsk_Mengsk: {
    name: "Build Basic",
    category: "command",
    key: "TerranBuild",
    unit: "SCVMengsk",
    opens: "laborer_build0",
  },
  co_TerranBuildAdvanced_SCVMengsk_Mengsk: {
    name: "Build Advanced",
    category: "command",
    key: "TerranBuildAdvanced",
    unit: "SCVMengsk",
    opens: "laborer_build1",
  },
  co_TrooperMengskEnlist_SCVMengsk: {
    name: "Report for Combat",
    category: "ability",
    key: "TrooperMengskEnlist",
    unit: "SCVMengsk",
  },
  co_CommandCenterMengsk_SCVMengsk: {
    name: "Enlistment Center",
    category: "structure",
    key: "CommandCenterMengsk",
    unit: "SCVMengsk",
  },
  co_RefineryMengsk_SCVMengsk: {
    name: "Refinery",
    category: "structure",
    key: "RefineryMengsk",
    unit: "SCVMengsk",
  },
  co_BunkerMengsk_SCVMengsk: {
    name: "Supply Bunker",
    category: "structure",
    key: "BunkerMengsk",
    unit: "SCVMengsk",
  },
  co_BarracksMengsk_SCVMengsk: {
    name: "Barracks",
    category: "structure",
    key: "BarracksMengsk",
    unit: "SCVMengsk",
  },
  co_EngineeringBayMengsk_SCVMengsk: {
    name: "Engineering Bay",
    category: "structure",
    key: "EngineeringBayMengsk",
    unit: "SCVMengsk",
  },
  co_ArtilleryMengsk_SCVMengsk: {
    name: "Earthsplitter Ordnance",
    category: "structure",
    key: "ArtilleryMengsk",
    unit: "SCVMengsk",
  },
  co_MissileTurretMengsk_SCVMengsk: {
    name: "Missile Turret",
    category: "structure",
    key: "MissileTurretMengsk",
    unit: "SCVMengsk",
  },
  co_GhostAcademyMengsk_SCVMengsk: {
    name: "Royal Academy",
    category: "structure",
    key: "GhostAcademyMengsk",
    unit: "SCVMengsk",
  },
  co_FactoryMengsk_SCVMengsk: {
    name: "Factory",
    category: "structure",
    key: "FactoryMengsk",
    unit: "SCVMengsk",
  },
  co_ArmoryMengsk_SCVMengsk: {
    name: "Armory",
    category: "structure",
    key: "ArmoryMengsk",
    unit: "SCVMengsk",
  },
  co_StarportMengsk_SCVMengsk: {
    name: "Starport",
    category: "structure",
    key: "StarportMengsk",
    unit: "SCVMengsk",
  },
  co_FusionCoreMengsk_SCVMengsk: {
    name: "Fusion Core",
    category: "structure",
    key: "FusionCoreMengsk",
    unit: "SCVMengsk",
  },
  co_SCVMengskEnlist_TrooperMengsk: {
    name: "Report for Labor",
    category: "ability",
    key: "SCVMengskEnlist",
    unit: "TrooperMengsk",
  },
  co_TrooperMengskBuild_TrooperMengsk_Mengsk: {
    name: "Build Combat",
    category: "command",
    key: "TrooperMengskBuild",
    unit: "TrooperMengsk",
    opens: "trooper_build0",
  },
  co_TrooperMengskSpecializeImproved_TrooperMengsk: {
    name: "Equip B-2 High-Cal LMG",
    category: "ability",
    key: "TrooperMengskSpecializeImproved",
    unit: "TrooperMengsk",
  },
  co_TrooperMengskSpecializeFlamethrower_TrooperMengsk: {
    name: "Equip CPO-7 Salamander Flamethrower",
    category: "ability",
    key: "TrooperMengskSpecializeFlamethrower",
    unit: "TrooperMengsk",
  },
  co_TrooperMengskSpecializeAA_TrooperMengsk: {
    name: "Equip Hailstorm Launcher",
    category: "ability",
    key: "TrooperMengskSpecializeAA",
    unit: "TrooperMengsk",
  },
  co_BunkerMengsk_TrooperMengsk: {
    name: "Supply Bunker",
    category: "structure",
    key: "BunkerMengsk",
    unit: "TrooperMengsk",
  },
  co_ArtilleryMengsk_TrooperMengsk: {
    name: "Earthsplitter Ordnance",
    category: "structure",
    key: "ArtilleryMengsk",
    unit: "TrooperMengsk",
  },
  co_MissileTurretMengsk_TrooperMengsk: {
    name: "Missile Turret",
    category: "structure",
    key: "MissileTurretMengsk",
    unit: "TrooperMengsk",
  },
  co_MarauderMengskAttackSpeedBoost_MarauderMengsk: {
    name: "High-Grade Stimpacks",
    category: "ability",
    key: "MarauderMengskAttackSpeedBoost",
    unit: "MarauderMengsk",
  },
  co_GhostMengskHoldFire_GhostMengsk: {
    name: "Hold Fire",
    category: "ability",
    key: "GhostMengskHoldFire",
    unit: "GhostMengsk",
  },
  co_WeaponsFreeMengsk_GhostMengsk: {
    name: "Weapons Free",
    category: "ability",
    key: "WeaponsFreeMengsk",
    unit: "GhostMengsk",
  },
  co_GhostMengskIrradiate_GhostMengsk: {
    name: "Pyrokinetic Immolation",
    category: "ability",
    key: "GhostMengskIrradiate",
    unit: "GhostMengsk",
  },
  co_GhostMengskEMP_GhostMengsk: {
    name: "EMP Blast",
    category: "ability",
    key: "GhostMengskEMP",
    unit: "GhostMengsk",
  },
  co_GhostMengskSuperCloak_GhostMengsk: {
    name: "Labyrinth Cloak",
    category: "ability",
    key: "GhostMengskSuperCloak",
    unit: "GhostMengsk",
  },
  co_NukeCalldownMengsk_GhostMengsk: {
    name: "Tactical Missile Strike",
    category: "ability",
    key: "NukeCalldownMengsk",
    unit: "GhostMengsk",
  },
  co_SiegeModeMengsk: { name: "Siege Mode", category: "unit", key: "SiegeModeMengsk" },
  co_UnsiegeMengsk_SiegeTankMengsk: {
    name: "Tank Mode",
    category: "ability",
    key: "UnsiegeMengsk",
    unit: "SiegeTankMengsk",
  },
  co_ThorMengskSiege_ThorMengsk: {
    name: "Overwatch Mode",
    category: "ability",
    key: "ThorMengskSiege",
    unit: "ThorMengsk",
  },
  co_ThorMengskUnsiege_ThorMengsk: {
    name: "Walker Mode",
    category: "ability",
    key: "ThorMengskUnsiege",
    unit: "ThorMengsk",
  },
  co_FighterModeMengsk_VikingMengskFighter: {
    name: "Fighter Mode",
    category: "ability",
    key: "FighterModeMengsk",
    unit: "VikingMengskFighter",
  },
  co_AssaultModeMengsk_VikingMengskFighter: {
    name: "Assault Mode",
    category: "ability",
    key: "AssaultModeMengsk",
    unit: "VikingMengskFighter",
  },
  co_HealMengsk_MedivacMengsk: {
    name: "Heal",
    category: "ability",
    key: "HealMengsk",
    unit: "MedivacMengsk",
  },
  co_IgniteAfterburnersMengsk_MedivacMengsk: {
    name: "Ignite Afterburners",
    category: "ability",
    key: "IgniteAfterburnersMengsk",
    unit: "MedivacMengsk",
  },
  co_MorphtoRavenMengskSieged_RavenMengsk: {
    name: "Patriot Mode",
    category: "ability",
    key: "MorphtoRavenMengskSieged",
    unit: "RavenMengsk",
  },
  co_MorphtoRavenMengsk_RavenMengsk: {
    name: "Cancel Patriot Mode",
    category: "ability",
    key: "MorphtoRavenMengsk",
    unit: "RavenMengsk",
  },
  co_YamatoGunMengsk: { name: "Yamato Cannon", category: "ability", key: "YamatoGunMengsk" },
  co_BattlecruiserMengskHyperjump_BattlecruiserMengsk: {
    name: "Tactical Jump",
    category: "ability",
    key: "BattlecruiserMengskHyperjump",
    unit: "BattlecruiserMengsk",
  },
  co_SCVMengsk: { name: "Conscript Dominion Laborer", category: "unit", key: "SCVMengsk" },
  co_TrooperMengsk_CommandCenterMengsk: {
    name: "Conscript Dominion Trooper",
    category: "unit",
    key: "TrooperMengsk",
    unit: "CommandCenterMengsk",
  },
  co_SCVMengskEnlistCC_CommandCenterMengsk: {
    name: "Call to Labor",
    category: "unit",
    key: "SCVMengskEnlistCC",
    unit: "CommandCenterMengsk",
  },
  co_TrooperMengskEnlistCC_CommandCenterMengsk: {
    name: "Call to Arms",
    category: "unit",
    key: "TrooperMengskEnlistCC",
    unit: "CommandCenterMengsk",
  },
  co_Lift_commandcenterflying_6: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "commandcenter_flying",
  },
  co_Land_14: { name: "Land", category: "ability", key: "Land" },
  co_SCVMengskEnlistCC_BunkerDepotMengsk: {
    name: "Call to Labor",
    category: "unit",
    key: "SCVMengskEnlistCC",
    unit: "BunkerDepotMengsk",
  },
  co_TrooperMengskEnlistCC_BunkerDepotMengsk: {
    name: "Call to Arms",
    category: "unit",
    key: "TrooperMengskEnlistCC",
    unit: "BunkerDepotMengsk",
  },
  co_BunkerDepotMengskLoad: { name: "Load", category: "ability", key: "BunkerDepotMengskLoad" },
  co_BunkerMengskSalvage_BunkerDepotMengsk: {
    name: "Salvage",
    category: "unit",
    key: "BunkerMengskSalvage",
    unit: "BunkerDepotMengsk",
  },
  co_MarauderMengsk_BarracksMengsk: {
    name: "Aegis Guard",
    category: "unit",
    key: "MarauderMengsk",
    unit: "BarracksMengsk",
  },
  co_GhostMengsk_BarracksMengsk: {
    name: "Emperor’s Shadow",
    category: "unit",
    key: "GhostMengsk",
    unit: "BarracksMengsk",
  },
  co_Lift_barracksflying_3: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "barracks_flying",
  },
  co_Land_15: { name: "Land", category: "ability", key: "Land" },
  co_MengskTrooperWeaponsLevel1_EngineeringBayMengsk: {
    name: "Dominion Weapons",
    category: "ability",
    key: "MengskTrooperWeaponsLevel1",
    unit: "EngineeringBayMengsk",
  },
  co_MengskTrooperArmorLevel1_EngineeringBayMengsk: {
    name: "Dominion Armor",
    category: "ability",
    key: "MengskTrooperArmorLevel1",
    unit: "EngineeringBayMengsk",
  },
  co_TrooperMengskDropTrainResearch_EngineeringBayMengsk: {
    name: "Orbital Trooper Pods",
    category: "unit",
    key: "TrooperMengskDropTrainResearch",
    unit: "EngineeringBayMengsk",
  },
  co_StructureArmorMengsk_EngineeringBayMengsk: {
    name: "Neosteel Fortified Armor",
    category: "unit",
    key: "StructureArmorMengsk",
    unit: "EngineeringBayMengsk",
  },
  co_BunkerDepotMengskRangeResearch_EngineeringBayMengsk: {
    name: "Aim-assist Embrasures",
    category: "unit",
    key: "BunkerDepotMengskRangeResearch",
    unit: "EngineeringBayMengsk",
  },
  co_ArtilleryMengskRangeResearch_EngineeringBayMengsk: {
    name: "Hemispheric Accelerants",
    category: "unit",
    key: "ArtilleryMengskRangeResearch",
    unit: "EngineeringBayMengsk",
  },
  co_ArtilleryMengskBombardment_ArtilleryMengsk: {
    name: "Bombardment",
    category: "unit",
    key: "ArtilleryMengskBombardment",
    unit: "ArtilleryMengsk",
  },
  co_ArtilleryMengskLoad: { name: "Load", category: "ability", key: "ArtilleryMengskLoad" },
  co_Salvage_ArtilleryMengsk: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "ArtilleryMengsk",
  },
  co_Salvage_MissileTurretMengsk: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "MissileTurretMengsk",
  },
  co_MarauderMengskSlowResearch_GhostAcademyMengsk: {
    name: "Incapacitator Shells",
    category: "unit",
    key: "MarauderMengskSlowResearch",
    unit: "GhostAcademyMengsk",
  },
  co_GhostMengskGuidedStrikeRessearch_GhostAcademyMengsk: {
    name: "Sovereign Tactical Missiles",
    category: "unit",
    key: "GhostMengskGuidedStrikeRessearch",
    unit: "GhostAcademyMengsk",
  },
  co_NukeMengskArm_GhostAcademyMengsk: {
    name: "Arm Silo with Tactical Missile",
    category: "unit",
    key: "NukeMengskArm",
    unit: "GhostAcademyMengsk",
  },
  co_SiegeTankMengsk_FactoryMengsk: {
    name: "Shock Division",
    category: "unit",
    key: "SiegeTankMengsk",
    unit: "FactoryMengsk",
  },
  co_ThorMengsk_FactoryMengsk: {
    name: "Blackhammer",
    category: "unit",
    key: "ThorMengsk",
    unit: "FactoryMengsk",
  },
  co_Lift_factoryflying_4: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "factory_flying",
  },
  co_Land_16: { name: "Land", category: "ability", key: "Land" },
  co_MedivacMengskSiegeTankAirliftResearch_ArmoryMengsk: {
    name: "Armament Stabilizers",
    category: "unit",
    key: "MedivacMengskSiegeTankAirliftResearch",
    unit: "ArmoryMengsk",
  },
  co_ThorMengskArmorAuraResearch_ArmoryMengsk: {
    name: "Bulwark Field",
    category: "unit",
    key: "ThorMengskArmorAuraResearch",
    unit: "ArmoryMengsk",
  },
  co_MechTransformationSpeedMengsk_ArmoryMengsk: {
    name: "Smart Servos",
    category: "unit",
    key: "MechTransformationSpeedMengsk",
    unit: "ArmoryMengsk",
  },
  co_VikingMengskFighter_StarportMengsk: {
    name: "Sky Fury",
    category: "unit",
    key: "VikingMengskFighter",
    unit: "StarportMengsk",
  },
  co_MedivacMengsk_StarportMengsk: {
    name: "Imperial Intercessor",
    category: "unit",
    key: "MedivacMengsk",
    unit: "StarportMengsk",
  },
  co_RavenMengsk_StarportMengsk: {
    name: "Imperial Witness",
    category: "unit",
    key: "RavenMengsk",
    unit: "StarportMengsk",
  },
  co_BattlecruiserMengsk_StarportMengsk: {
    name: "Pride of Augustgrad",
    category: "unit",
    key: "BattlecruiserMengsk",
    unit: "StarportMengsk",
  },
  co_Lift_starportflying_4: {
    name: "Lift Off",
    category: "ability",
    key: "Lift",
    opens: "starport_flying",
  },
  co_Land_17: { name: "Land", category: "ability", key: "Land" },
  co_MedivacMengskDoubleHealBeamResearch_FusionCoreMengsk: {
    name: "Dual Resuscitators",
    category: "unit",
    key: "MedivacMengskDoubleHealBeamResearch",
    unit: "FusionCoreMengsk",
  },
  co_MedivacMengskPermanentCloakResearch_FusionCoreMengsk: {
    name: "Scatter Veil",
    category: "unit",
    key: "MedivacMengskPermanentCloakResearch",
    unit: "FusionCoreMengsk",
  },
  co_BlimpMengskTopbarRegenResearch_FusionCoreMengsk: {
    name: "Amplified Airwaves",
    category: "unit",
    key: "BlimpMengskTopbarRegenResearch",
    unit: "FusionCoreMengsk",
  },
  co_VikingMengskSpeedResearch_FusionCoreMengsk: {
    name: "Aesir Turbines",
    category: "unit",
    key: "VikingMengskSpeedResearch",
    unit: "FusionCoreMengsk",
  },
  co_BattlecruiserMengskRangeAuraResearch_FusionCoreMengsk: {
    name: "Field-Assist Targeting System",
    category: "unit",
    key: "BattlecruiserMengskRangeAuraResearch",
    unit: "FusionCoreMengsk",
  },
  co_MindBolt_K5Kerrigan: {
    name: "Leaping Strike",
    category: "ability",
    key: "MindBolt",
    unit: "K5Kerrigan",
  },
  co_PsionicLift_K5Kerrigan: {
    name: "Psionic Shift",
    category: "ability",
    key: "PsionicLift",
    unit: "K5Kerrigan",
  },
  co_KerriganVoidCoopEconDrop_K5Kerrigan: {
    name: "Assimilation Aura",
    category: "ability",
    key: "KerriganVoidCoopEconDrop",
    unit: "K5Kerrigan",
  },
  co_KerriganVoidCoopCrushingGripWave_K5Kerrigan: {
    name: "Immobilization Wave",
    category: "ability",
    key: "KerriganVoidCoopCrushingGripWave",
    unit: "K5Kerrigan",
  },
  co_BurrowDown_kerriganburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "kerrigan_burrowed",
  },
  co_MindBolt_K5KerriganBurrowed: {
    name: "Leaping Strike",
    category: "ability",
    key: "MindBolt",
    unit: "K5KerriganBurrowed",
  },
  co_PsionicLift_K5KerriganBurrowed: {
    name: "Psionic Shift",
    category: "ability",
    key: "PsionicLift",
    unit: "K5KerriganBurrowed",
  },
  co_KerriganVoidCoopEconDrop_K5KerriganBurrowed: {
    name: "Assimilation Aura",
    category: "ability",
    key: "KerriganVoidCoopEconDrop",
    unit: "K5KerriganBurrowed",
  },
  co_KerriganVoidCoopCrushingGripWave_K5KerriganBurrowed: {
    name: "Immobilization Wave",
    category: "ability",
    key: "KerriganVoidCoopCrushingGripWave",
    unit: "K5KerriganBurrowed",
  },
  co_ZergBuild_Drone_Kerrigan: {
    name: "Build Basic",
    category: "command",
    key: "ZergBuild",
    unit: "Drone",
    opens: "drone_build0",
  },
  co_ZergBuildAdvanced_Drone_Kerrigan: {
    name: "Build Advanced",
    category: "command",
    key: "ZergBuildAdvanced",
    unit: "Drone",
    opens: "drone_build1",
  },
  co_SpawningPool_Drone: {
    name: "Spawning Pool",
    category: "structure",
    key: "SpawningPool",
    unit: "Drone",
  },
  co_BuildCreepTumor_QueenCoop_queencreeptumor: {
    name: "Spawn Creep Tumor",
    category: "command",
    key: "BuildCreepTumor",
    unit: "QueenCoop",
    opens: "queen_creeptumor",
  },
  co_MorphMorphalisk_QueenCoop: {
    name: "Spawn Larvae",
    category: "ability",
    key: "MorphMorphalisk",
    unit: "QueenCoop",
  },
  co_Transfusion_QueenCoop: {
    name: "Transfusion",
    category: "ability",
    key: "Transfusion",
    unit: "QueenCoop",
  },
  co_BurrowDown_queenburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "queen_burrowed",
  },
  co_GenerateCreep_Overlord_overlordgeneratingcreep: {
    name: "Generate Creep",
    category: "command",
    key: "GenerateCreep",
    unit: "Overlord",
    opens: "overlord_generatingcreep",
  },
  co_BurrowDown_zerglingburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "zergling_burrowed",
  },
  co_Lurker_HydraliskLurker: {
    name: "Lurker",
    category: "ability",
    key: "Lurker",
    unit: "HydraliskLurker",
  },
  co_HydraliskFrenzy_HydraliskLurker: {
    name: "Frenzy",
    category: "ability",
    key: "HydraliskFrenzy",
    unit: "HydraliskLurker",
  },
  co_BurrowDown_hydraliskburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "hydralisk_burrowed",
  },
  co_BurrowLurkerMP_lurkerburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowLurkerMP",
    opens: "lurker_burrowed",
  },
  co_LurkerCancelHoldFire_LurkerBurrowed: {
    name: "Cancel Hold Fire",
    category: "ability",
    key: "LurkerCancelHoldFire",
    unit: "LurkerBurrowed",
  },
  co_LurkerHoldFire_LurkerBurrowed: {
    name: "Hold Fire",
    category: "ability",
    key: "LurkerHoldFire",
    unit: "LurkerBurrowed",
  },
  co_LurkerBurrowUp: { name: "Unburrow", category: "ability", key: "LurkerBurrowUp" },
  co_BroodLord_MutaliskBroodlord: {
    name: "Brood Lord",
    category: "ability",
    key: "BroodLord",
    unit: "MutaliskBroodlord",
  },
  co_BurrowChargeCampaign_HotSTorrasque: {
    name: "Burrow Charge",
    category: "ability",
    key: "BurrowChargeCampaign",
    unit: "HotSTorrasque",
  },
  co_BurrowDown_ultraliskburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "ultralisk_burrowed",
  },
  co_EvolveVentralSacks: { name: "Ventral Sacs", category: "ability", key: "EvolveVentralSacks" },
  co_Lair_Hatchery_hatcherylair: {
    name: "Lair",
    category: "command",
    key: "Lair",
    unit: "Hatchery",
    opens: "hatchery_lair",
  },
  co_EvolveVentralSacks_2: { name: "Ventral Sacs", category: "ability", key: "EvolveVentralSacks" },
  co_EvolveHardenedCarapace_SpawningPool: {
    name: "Hardened Carapace",
    category: "ability",
    key: "EvolveHardenedCarapace",
    unit: "SpawningPool",
  },
  co_EvolveZerglingArmorShred_SpawningPool: {
    name: "Shredding Claws",
    category: "ability",
    key: "EvolveZerglingArmorShred",
    unit: "SpawningPool",
  },
  co_EvolveKerriganHeroicFortitude_EvolutionChamber: {
    name: "Heroic Fortitude",
    category: "ability",
    key: "EvolveKerriganHeroicFortitude",
    unit: "EvolutionChamber",
  },
  co_EvolveK5ChainLightning_EvolutionChamber: {
    name: "Chain Reaction",
    category: "ability",
    key: "EvolveK5ChainLightning",
    unit: "EvolutionChamber",
  },
  co_EvolveK5Cooldowns_EvolutionChamber: {
    name: "Ability Efficiency",
    category: "ability",
    key: "EvolveK5Cooldowns",
    unit: "EvolutionChamber",
  },
  co_SpineCrawlerUproot_SpineCrawler_spinecrawleruprooted: {
    name: "Uproot",
    category: "command",
    key: "SpineCrawlerUproot",
    unit: "SpineCrawler",
    opens: "spinecrawler_uprooted",
  },
  co_SporeCrawlerUproot_SporeCrawler_sporecrawleruprooted: {
    name: "Uproot",
    category: "command",
    key: "SporeCrawlerUproot",
    unit: "SporeCrawler",
    opens: "sporecrawler_uprooted",
  },
  co_EvolveAncillaryCarapace_HydraliskDen: {
    name: "Ancillary Carapace",
    category: "ability",
    key: "EvolveAncillaryCarapace",
    unit: "HydraliskDen",
  },
  co_EvolveFrenzy_HydraliskDen: {
    name: "Frenzy",
    category: "ability",
    key: "EvolveFrenzy",
    unit: "HydraliskDen",
  },
  co_ResearchLurkerRange_HydraliskDen: {
    name: "Seismic Spines",
    category: "ability",
    key: "ResearchLurkerRange",
    unit: "HydraliskDen",
  },
  co_LurkerDen_HydraliskDen: {
    name: "Lurker Den",
    category: "unit",
    key: "LurkerDen",
    unit: "HydraliskDen",
  },
  co_EvolveMutaliskRapidRegeneration_Spire: {
    name: "Rapid Regeneration",
    category: "ability",
    key: "EvolveMutaliskRapidRegeneration",
    unit: "Spire",
  },
  co_EvolveKerriganViciousGlaive_Spire: {
    name: "Vicious Glaive",
    category: "ability",
    key: "EvolveKerriganViciousGlaive",
    unit: "Spire",
  },
  co_EvolveSeveringGlave_Spire: {
    name: "Severing Glaive",
    category: "ability",
    key: "EvolveSeveringGlave",
    unit: "Spire",
  },
  co_EvolveGuardianAttackRangeIncrease_Spire: {
    name: "Prolonged Dispersion",
    category: "ability",
    key: "EvolveGuardianAttackRangeIncrease",
    unit: "Spire",
  },
  co_GreaterSpireBroodlord_Spire: {
    name: "Greater Spire",
    category: "unit",
    key: "GreaterSpireBroodlord",
    unit: "Spire",
  },
  co_ZagaraVoidCoopNydusWorm_NydusNetwork: {
    name: "Summon Omega Worm",
    category: "unit",
    key: "ZagaraVoidCoopNydusWorm",
    unit: "NydusNetwork",
  },
  co_EvolveBurrowCharge_UltraliskCavern: {
    name: "Burrow Charge",
    category: "ability",
    key: "EvolveBurrowCharge",
    unit: "UltraliskCavern",
  },
  co_EvolveTissueAssimilation_UltraliskCavern: {
    name: "Tissue Assimilation",
    category: "ability",
    key: "EvolveTissueAssimilation",
    unit: "UltraliskCavern",
  },
  co_ZagaraVoidCoopBanelingBarrage_ZagaraVoidCoop: {
    name: "Baneling Barrage",
    category: "ability",
    key: "ZagaraVoidCoopBanelingBarrage",
    unit: "ZagaraVoidCoop",
  },
  co_ZagaraVoidCoopSpawnHunterKillers_ZagaraVoidCoop: {
    name: "Spawn Hunter Killers",
    category: "ability",
    key: "ZagaraVoidCoopSpawnHunterKillers",
    unit: "ZagaraVoidCoop",
  },
  co_ZagaraVoidCoopMassFrenzy_ZagaraVoidCoop: {
    name: "Mass Frenzy",
    category: "ability",
    key: "ZagaraVoidCoopMassFrenzy",
    unit: "ZagaraVoidCoop",
  },
  co_MassRoachDrop_ZagaraVoidCoop: {
    name: "Infested Drop",
    category: "ability",
    key: "MassRoachDrop",
    unit: "ZagaraVoidCoop",
  },
  co_CommanderPrestigeZagaraZagaraDeepTunnel_ZagaraVoidCoop: {
    name: "Deep Tunnel",
    category: "ability",
    key: "CommanderPrestigeZagaraZagaraDeepTunnel",
    unit: "ZagaraVoidCoop",
  },
  co_BurrowDown_zagaraburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "zagara_burrowed",
  },
  co_ZagaraVoidCoopBanelingBarrage_ZagaraVoidCoopBurrowed: {
    name: "Baneling Barrage",
    category: "ability",
    key: "ZagaraVoidCoopBanelingBarrage",
    unit: "ZagaraVoidCoopBurrowed",
  },
  co_ZagaraVoidCoopSpawnHunterKillers_ZagaraVoidCoopBurrowed: {
    name: "Spawn Hunter Killers",
    category: "ability",
    key: "ZagaraVoidCoopSpawnHunterKillers",
    unit: "ZagaraVoidCoopBurrowed",
  },
  co_ZagaraVoidCoopMassFrenzy_ZagaraVoidCoopBurrowed: {
    name: "Mass Frenzy",
    category: "ability",
    key: "ZagaraVoidCoopMassFrenzy",
    unit: "ZagaraVoidCoopBurrowed",
  },
  co_MassRoachDrop_ZagaraVoidCoopBurrowed: {
    name: "Infested Drop",
    category: "ability",
    key: "MassRoachDrop",
    unit: "ZagaraVoidCoopBurrowed",
  },
  co_Aberration_Larva: {
    name: "Aberration",
    category: "ability",
    key: "Aberration",
    unit: "Larva",
  },
  co_ZergBuild_Drone_Zagara: {
    name: "Build Basic",
    category: "command",
    key: "ZergBuild",
    unit: "Drone",
    opens: "drone_build0",
  },
  co_ZergBuildAdvanced_Drone_Zagara: {
    name: "Build Advanced",
    category: "command",
    key: "ZergBuildAdvanced",
    unit: "Drone",
    opens: "drone_build1",
  },
  co_SpawningPool_Drone_2: {
    name: "Spawning Pool",
    category: "structure",
    key: "SpawningPool",
    unit: "Drone",
  },
  co_ZagaraBileLauncher_Drone: {
    name: "Bile Launcher",
    category: "structure",
    key: "ZagaraBileLauncher",
    unit: "Drone",
  },
  co_ScourgeNest_Drone: {
    name: "Scourge Nest",
    category: "structure",
    key: "ScourgeNest",
    unit: "Drone",
  },
  co_BuildCreepTumor_QueenCoop_queencreeptumor_2: {
    name: "Spawn Creep Tumor",
    category: "command",
    key: "BuildCreepTumor",
    unit: "QueenCoop",
    opens: "queen_creeptumor",
  },
  co_MorphMorphalisk_QueenCoop_2: {
    name: "Spawn Larvae",
    category: "ability",
    key: "MorphMorphalisk",
    unit: "QueenCoop",
  },
  co_Transfusion_QueenCoop_2: {
    name: "Transfusion",
    category: "ability",
    key: "Transfusion",
    unit: "QueenCoop",
  },
  co_BurrowDown_queenburrowed_2: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "queen_burrowed",
  },
  co_GenerateCreep_Overlord_overlordgeneratingcreep_2: {
    name: "Generate Creep",
    category: "command",
    key: "GenerateCreep",
    unit: "Overlord",
    opens: "overlord_generatingcreep",
  },
  co_BurrowDown_zerglingburrowed_2: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "zergling_burrowed",
  },
  co_Explode_HotSSplitterlingBig: {
    name: "Explode",
    category: "ability",
    key: "Explode",
    unit: "HotSSplitterlingBig",
  },
  co_EnableBuildingAttack_HotSSplitterlingBig: {
    name: "Enable Structure Attack",
    category: "ability",
    key: "EnableBuildingAttack",
    unit: "HotSSplitterlingBig",
  },
  co_DisableBuildingAttack_HotSSplitterlingBig: {
    name: "Disable Structure Attack",
    category: "ability",
    key: "DisableBuildingAttack",
    unit: "HotSSplitterlingBig",
  },
  co_BurrowDown_banelingburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "baneling_burrowed",
  },
  co_Explode_HotSSplitterlingBigBurrowed: {
    name: "Explode",
    category: "ability",
    key: "Explode",
    unit: "HotSSplitterlingBigBurrowed",
  },
  co_BurrowDown_aberrationburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "aberration_burrowed",
  },
  co_DetonateScourge_Scourge: {
    name: "Explode",
    category: "ability",
    key: "DetonateScourge",
    unit: "Scourge",
  },
  co_EnableBuildingAttackScourge_Scourge: {
    name: "Enable Structure Attack",
    category: "ability",
    key: "EnableBuildingAttackScourge",
    unit: "Scourge",
  },
  co_DisableBuildingAttackScourge_Scourge: {
    name: "Disable Structure Attack",
    category: "ability",
    key: "DisableBuildingAttackScourge",
    unit: "Scourge",
  },
  co_CorruptionAbility_ZagaraCorruptor: {
    name: "Corruption",
    category: "ability",
    key: "CorruptionAbility",
    unit: "ZagaraCorruptor",
  },
  co_BurrowDown_hunterkillerburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "hunterkiller_burrowed",
  },
  co_BurrowDown_roachburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "roach_burrowed",
  },
  co_EvolveVentralSacks_3: { name: "Ventral Sacs", category: "ability", key: "EvolveVentralSacks" },
  co_Lair_Hatchery_hatcherylair_2: {
    name: "Lair",
    category: "command",
    key: "Lair",
    unit: "Hatchery",
    opens: "hatchery_lair",
  },
  co_EvolveVentralSacks_4: { name: "Ventral Sacs", category: "ability", key: "EvolveVentralSacks" },
  co_EvolveHardenedCarapace_SpawningPool_2: {
    name: "Hardened Carapace",
    category: "ability",
    key: "EvolveHardenedCarapace",
    unit: "SpawningPool",
  },
  co_EvolveZerglingArmorShred_SpawningPool_2: {
    name: "Shredding Claws",
    category: "ability",
    key: "EvolveZerglingArmorShred",
    unit: "SpawningPool",
  },
  co_EvolveBileLauncherIncreasedRange_SpawningPool: {
    name: "Artillery Ducts",
    category: "ability",
    key: "EvolveBileLauncherIncreasedRange",
    unit: "SpawningPool",
  },
  co_EvolveBileLauncherBombardmentCooldown_SpawningPool: {
    name: "Rapid Bombardment",
    category: "ability",
    key: "EvolveBileLauncherBombardmentCooldown",
    unit: "SpawningPool",
  },
  co_EvolveKerriganHeroicFortitude_EvolutionChamber_2: {
    name: "Heroic Fortitude",
    category: "ability",
    key: "EvolveKerriganHeroicFortitude",
    unit: "EvolutionChamber",
  },
  co_EvolveK5ChainLightning_EvolutionChamber_2: {
    name: "Chain Reaction",
    category: "ability",
    key: "EvolveK5ChainLightning",
    unit: "EvolutionChamber",
  },
  co_EvolveK5Cooldowns_EvolutionChamber_2: {
    name: "Ability Efficiency",
    category: "ability",
    key: "EvolveK5Cooldowns",
    unit: "EvolutionChamber",
  },
  co_EvolveBanelingCorrosiveBile_BanelingNest: {
    name: "Corrosive Acid",
    category: "ability",
    key: "EvolveBanelingCorrosiveBile",
    unit: "BanelingNest",
  },
  co_EvolveBanelingRupture_BanelingNest: {
    name: "Rupture",
    category: "ability",
    key: "EvolveBanelingRupture",
    unit: "BanelingNest",
  },
  co_EvolveBanelingHeal_BanelingNest: {
    name: "Regenerative Acid",
    category: "ability",
    key: "EvolveBanelingHeal",
    unit: "BanelingNest",
  },
  co_ZagaraVoidCoopBanelingSpawner_BanelingNest: {
    name: "Birthing Chamber",
    category: "unit",
    key: "ZagaraVoidCoopBanelingSpawner",
    unit: "BanelingNest",
  },
  co_SpineCrawlerUproot_SpineCrawler_spinecrawleruprooted_2: {
    name: "Uproot",
    category: "command",
    key: "SpineCrawlerUproot",
    unit: "SpineCrawler",
    opens: "spinecrawler_uprooted",
  },
  co_SporeCrawlerUproot_SporeCrawler_sporecrawleruprooted_2: {
    name: "Uproot",
    category: "command",
    key: "SporeCrawlerUproot",
    unit: "SporeCrawler",
    opens: "sporecrawler_uprooted",
  },
  co_BileLauncherBombardment_BileLauncherZagara: {
    name: "Bombardment",
    category: "ability",
    key: "BileLauncherBombardment",
    unit: "BileLauncherZagara",
  },
  co_EvolveScourgeSplashDamage_ScourgeNest: {
    name: "Virulent Spores",
    category: "ability",
    key: "EvolveScourgeSplashDamage",
    unit: "ScourgeNest",
  },
  co_EvolveScourgeGasCostReduction_ScourgeNest: {
    name: "Simplified Genome",
    category: "ability",
    key: "EvolveScourgeGasCostReduction",
    unit: "ScourgeNest",
  },
  co_CommanderPrestigeZagaraMaxSupplyScourgeSpawn_ScourgeNest: {
    name: "Birthing Roost",
    category: "unit",
    key: "CommanderPrestigeZagaraMaxSupplyScourgeSpawn",
    unit: "ScourgeNest",
  },
  co_ZergBuild_Drone_Abathur: {
    name: "Build Basic",
    category: "command",
    key: "ZergBuild",
    unit: "Drone",
    opens: "drone_build0",
  },
  co_ZergBuildAdvanced_Drone_Abathur: {
    name: "Build Advanced",
    category: "command",
    key: "ZergBuildAdvanced",
    unit: "Drone",
    opens: "drone_build1",
  },
  co_BuildCreepTumor_Queen_queencreeptumor: {
    name: "Spawn Creep Tumor",
    category: "command",
    key: "BuildCreepTumor",
    unit: "Queen",
    opens: "queen_creeptumor",
  },
  co_EvolveToBrutalisk_Queen: {
    name: "Brutalisk",
    category: "ability",
    key: "EvolveToBrutalisk",
    unit: "Queen",
  },
  co_BurrowDown_queenburrowed_3: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "queen_burrowed",
  },
  co_GenerateCreep_Overlord_overlordgeneratingcreep_3: {
    name: "Generate Creep",
    category: "command",
    key: "GenerateCreep",
    unit: "Overlord",
    opens: "overlord_generatingcreep",
  },
  co_Ravager_RoachVile: { name: "Ravager", category: "ability", key: "Ravager", unit: "RoachVile" },
  co_BrutaliskDeepTunnel_RoachVile: {
    name: "Deep Tunnel",
    category: "ability",
    key: "BrutaliskDeepTunnel",
    unit: "RoachVile",
  },
  co_EvolveToBrutalisk_RoachVile: {
    name: "Brutalisk",
    category: "ability",
    key: "EvolveToBrutalisk",
    unit: "RoachVile",
  },
  co_BurrowDown_roachburrowed_2: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "roach_burrowed",
  },
  co_BrutaliskDeepTunnel_RoachVileBurrowed: {
    name: "Deep Tunnel",
    category: "ability",
    key: "BrutaliskDeepTunnel",
    unit: "RoachVileBurrowed",
  },
  co_EvolveToBrutalisk_RoachVileBurrowed: {
    name: "Brutalisk",
    category: "ability",
    key: "EvolveToBrutalisk",
    unit: "RoachVileBurrowed",
  },
  co_BrutaliskDeepTunnel_RoachBurrowed: {
    name: "Deep Tunnel",
    category: "ability",
    key: "BrutaliskDeepTunnel",
    unit: "RoachBurrowed",
  },
  co_EvolveToBrutalisk_RoachBurrowed: {
    name: "Brutalisk",
    category: "ability",
    key: "EvolveToBrutalisk",
    unit: "RoachBurrowed",
  },
  co_RavagerAbathurCorrosiveBile_RavagerAbathur: {
    name: "Corrosive Bile",
    category: "ability",
    key: "RavagerAbathurCorrosiveBile",
    unit: "RavagerAbathur",
  },
  co_BrutaliskDeepTunnel_RavagerAbathur: {
    name: "Deep Tunnel",
    category: "ability",
    key: "BrutaliskDeepTunnel",
    unit: "RavagerAbathur",
  },
  co_EvolveToBrutalisk_RavagerAbathur: {
    name: "Brutalisk",
    category: "ability",
    key: "EvolveToBrutalisk",
    unit: "RavagerAbathur",
  },
  co_BurrowDown_ravagerburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "ravager_burrowed",
  },
  co_BrutaliskDeepTunnel_RavagerAbathur_2: {
    name: "Deep Tunnel",
    category: "ability",
    key: "BrutaliskDeepTunnel",
    unit: "RavagerAbathur",
  },
  co_LocustLaunch_SwarmHost: {
    name: "Spawn Locusts",
    category: "ability",
    key: "LocustLaunch",
    unit: "SwarmHost",
  },
  co_AbathurDeepTunnel: { name: "Deep Tunnel", category: "ability", key: "AbathurDeepTunnel" },
  co_EvolveToBrutalisk_SwarmHost: {
    name: "Brutalisk",
    category: "ability",
    key: "EvolveToBrutalisk",
    unit: "SwarmHost",
  },
  co_SwarmHostRootBurrow_swarmhostburrowed: {
    name: "Burrow",
    category: "ability",
    key: "SwarmHostRootBurrow",
    opens: "swarmhost_burrowed",
  },
  co_LocustLaunch_SwarmHostBurrowed: {
    name: "Spawn Locusts",
    category: "ability",
    key: "LocustLaunch",
    unit: "SwarmHostBurrowed",
  },
  co_AbathurDeepTunnel_2: { name: "Deep Tunnel", category: "ability", key: "AbathurDeepTunnel" },
  co_EvolveToBrutalisk_SwarmHostBurrowed: {
    name: "Brutalisk",
    category: "ability",
    key: "EvolveToBrutalisk",
    unit: "SwarmHostBurrowed",
  },
  co_SwarmHostUprootUnburrow: {
    name: "Unburrow",
    category: "ability",
    key: "SwarmHostUprootUnburrow",
  },
  co_LocustLaunch_SwarmHostBurrowed_2: {
    name: "Spawn Locusts",
    category: "ability",
    key: "LocustLaunch",
    unit: "SwarmHostBurrowed",
  },
  co_BrutaliskDeepTunnel_SwarmHostBurrowed: {
    name: "Deep Tunnel",
    category: "ability",
    key: "BrutaliskDeepTunnel",
    unit: "SwarmHostBurrowed",
  },
  co_EvolveToBrutalisk_SwarmHostBurrowed_2: {
    name: "Brutalisk",
    category: "ability",
    key: "EvolveToBrutalisk",
    unit: "SwarmHostBurrowed",
  },
  co_SwarmHostUprootUnburrow_2: {
    name: "Unburrow",
    category: "ability",
    key: "SwarmHostUprootUnburrow",
  },
  co_LocustLaunch_SwarmHost_2: {
    name: "Spawn Locusts",
    category: "ability",
    key: "LocustLaunch",
    unit: "SwarmHost",
  },
  co_BrutaliskDeepTunnel_SwarmHost: {
    name: "Deep Tunnel",
    category: "ability",
    key: "BrutaliskDeepTunnel",
    unit: "SwarmHost",
  },
  co_EvolveToBrutalisk_SwarmHost_2: {
    name: "Brutalisk",
    category: "ability",
    key: "EvolveToBrutalisk",
    unit: "SwarmHost",
  },
  co_SwarmHostRootBurrow_swarmhostprestigeburrowed: {
    name: "Burrow",
    category: "ability",
    key: "SwarmHostRootBurrow",
    opens: "swarmhost_prestigeburrowed",
  },
  co_MorphToGuardian_Mutalisk: {
    name: "Guardian",
    category: "ability",
    key: "MorphToGuardian",
    unit: "Mutalisk",
  },
  co_MorphtoDevourer_Mutalisk: {
    name: "Devourer",
    category: "ability",
    key: "MorphtoDevourer",
    unit: "Mutalisk",
  },
  co_EvolveToLeviathan_Mutalisk: {
    name: "Leviathan",
    category: "ability",
    key: "EvolveToLeviathan",
    unit: "Mutalisk",
  },
  co_EvolveToLeviathan_GuardianMP: {
    name: "Leviathan",
    category: "ability",
    key: "EvolveToLeviathan",
    unit: "GuardianMP",
  },
  co_CorrosiveAcidDevourer_Devourer: {
    name: "Corrosive Acid",
    category: "ability",
    key: "CorrosiveAcidDevourer",
    unit: "Devourer",
  },
  co_EvolveToLeviathan_Devourer: {
    name: "Leviathan",
    category: "ability",
    key: "EvolveToLeviathan",
    unit: "Devourer",
  },
  co_DisablingCloud_Viper: {
    name: "Disabling Cloud",
    category: "ability",
    key: "DisablingCloud",
    unit: "Viper",
  },
  co_ViperConsumption_Viper: {
    name: "Consumption",
    category: "ability",
    key: "ViperConsumption",
    unit: "Viper",
  },
  co_EvolveToLeviathan_Viper: {
    name: "Leviathan",
    category: "ability",
    key: "EvolveToLeviathan",
    unit: "Viper",
  },
  co_BrutaliskDeepTunnel_Brutalisk: {
    name: "Deep Tunnel",
    category: "ability",
    key: "BrutaliskDeepTunnel",
    unit: "Brutalisk",
  },
  co_BurrowDown_brutaliskburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "brutalisk_burrowed",
  },
  co_EvolveVentralSacks_5: { name: "Ventral Sacs", category: "ability", key: "EvolveVentralSacks" },
  co_Lair_Hatchery_hatcherylair_3: {
    name: "Lair",
    category: "command",
    key: "Lair",
    unit: "Hatchery",
    opens: "hatchery_lair",
  },
  co_EvolveVentralSacks_6: { name: "Ventral Sacs", category: "ability", key: "EvolveVentralSacks" },
  co_EvolveHydriodicBile_RoachWarren: {
    name: "Hydriodic Bile",
    category: "ability",
    key: "EvolveHydriodicBile",
    unit: "RoachWarren",
  },
  co_EvolveAdaptivePlating_RoachWarren: {
    name: "Adaptive Plating",
    category: "ability",
    key: "EvolveAdaptivePlating",
    unit: "RoachWarren",
  },
  co_EvolveCorrosiveBileRadiusIncrease_RoachWarren: {
    name: "Bloated Bile Ducts",
    category: "ability",
    key: "EvolveCorrosiveBileRadiusIncrease",
    unit: "RoachWarren",
  },
  co_EvolveCorrosiveBileDamageIncrease_RoachWarren: {
    name: "Potent Bile",
    category: "ability",
    key: "EvolveCorrosiveBileDamageIncrease",
    unit: "RoachWarren",
  },
  co_Transfusion_EvolutionChamber: {
    name: "Bio-Mechanical Transfusion",
    category: "ability",
    key: "Transfusion",
    unit: "EvolutionChamber",
  },
  co_EvolveHatcheryDoubleQueue_EvolutionChamber: {
    name: "Incubation Chamber",
    category: "ability",
    key: "EvolveHatcheryDoubleQueue",
    unit: "EvolutionChamber",
  },
  co_SpineCrawlerUproot_SpineCrawler_spinecrawleruprooted_3: {
    name: "Uproot",
    category: "command",
    key: "SpineCrawlerUproot",
    unit: "SpineCrawler",
    opens: "spinecrawler_uprooted",
  },
  co_SporeCrawlerUproot_SporeCrawler_sporecrawleruprooted_3: {
    name: "Uproot",
    category: "command",
    key: "SporeCrawlerUproot",
    unit: "SporeCrawler",
    opens: "sporecrawler_uprooted",
  },
  co_HotSPressurizedGlands_InfestationPit: {
    name: "Pressurized Glands",
    category: "ability",
    key: "HotSPressurizedGlands",
    unit: "InfestationPit",
  },
  co_EvolveViperImprovedCastRange_InfestationPit: {
    name: "Virulent Microbes",
    category: "ability",
    key: "EvolveViperImprovedCastRange",
    unit: "InfestationPit",
  },
  co_EvolveInfestorEnergyUpgrade_InfestationPit: {
    name: "Pathogen Glands",
    category: "ability",
    key: "EvolveInfestorEnergyUpgrade",
    unit: "InfestationPit",
  },
  co_EvolveMutaliskRapidRegeneration_Spire_2: {
    name: "Rapid Regeneration",
    category: "ability",
    key: "EvolveMutaliskRapidRegeneration",
    unit: "Spire",
  },
  co_EvolveSunderingGlave_Spire: {
    name: "Sundering Glaive",
    category: "ability",
    key: "EvolveSunderingGlave",
    unit: "Spire",
  },
  co_EvolveGuardianAttackRangeIncrease_Spire_2: {
    name: "Prolonged Dispersion",
    category: "ability",
    key: "EvolveGuardianAttackRangeIncrease",
    unit: "Spire",
  },
  co_EvolveDevourerAoEDamage_Spire: {
    name: "Corrosive Spray",
    category: "ability",
    key: "EvolveDevourerAoEDamage",
    unit: "Spire",
  },
  co_GreaterSpireBroodlord_Spire_2: {
    name: "Greater Spire",
    category: "unit",
    key: "GreaterSpireBroodlord",
    unit: "Spire",
  },
  co_ZagaraVoidCoopNydusWorm_NydusNetwork_2: {
    name: "Summon Omega Worm",
    category: "unit",
    key: "ZagaraVoidCoopNydusWorm",
    unit: "NydusNetwork",
  },
  co_ToxicNestExplode_ToxicNest: {
    name: "Explode",
    category: "unit",
    key: "ToxicNestExplode",
    unit: "ToxicNest",
  },
  co_TerranBuild_SISCV_Stukov: {
    name: "Build Basic",
    category: "command",
    key: "TerranBuild",
    unit: "SISCV",
    opens: "scv_build0",
  },
  co_TerranBuildAdvanced_SISCV_Stukov: {
    name: "Build Advanced",
    category: "command",
    key: "TerranBuildAdvanced",
    unit: "SISCV",
    opens: "scv_build1",
  },
  co_SICommandCenter_SISCV: {
    name: "Infested Command Center",
    category: "structure",
    key: "SICommandCenter",
    unit: "SISCV",
  },
  co_SIRefinery_SISCV: {
    name: "Infested Refinery",
    category: "structure",
    key: "SIRefinery",
    unit: "SISCV",
  },
  co_SICivilianStructure_SISCV: {
    name: "Infested Colonist Compound",
    category: "structure",
    key: "SICivilianStructure",
    unit: "SISCV",
  },
  co_SIBarracks_SISCV: {
    name: "Infested Barracks",
    category: "structure",
    key: "SIBarracks",
    unit: "SISCV",
  },
  co_SIEngineeringBay_SISCV: {
    name: "Infested Engineering Bay",
    category: "structure",
    key: "SIEngineeringBay",
    unit: "SISCV",
  },
  co_SIInfestedBunker_SISCV: {
    name: "Infested Bunker",
    category: "structure",
    key: "SIInfestedBunker",
    unit: "SISCV",
  },
  co_SIMissileTurret_SISCV: {
    name: "Infested Missile Turret",
    category: "structure",
    key: "SIMissileTurret",
    unit: "SISCV",
  },
  co_SIFactory_SISCV: {
    name: "Infested Factory",
    category: "structure",
    key: "SIFactory",
    unit: "SISCV",
  },
  co_SIArmory_SISCV: {
    name: "Infested Armory",
    category: "structure",
    key: "SIArmory",
    unit: "SISCV",
  },
  co_SIStarport_SISCV: {
    name: "Infested Starport",
    category: "structure",
    key: "SIStarport",
    unit: "SISCV",
  },
  co_BurrowDown_civilianburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "civilian_burrowed",
  },
  co_MorphToOverseer_SIOverlord: {
    name: "Overseer",
    category: "ability",
    key: "MorphToOverseer",
    unit: "SIOverlord",
  },
  co_GenerateCreep_SIOverlord_overlordgeneratingcreep: {
    name: "Generate Creep",
    category: "command",
    key: "GenerateCreep",
    unit: "SIOverlord",
    opens: "overlord_generatingcreep",
  },
  co_ExplodeVolatileInfested_SIVolatileInfested: {
    name: "Explode",
    category: "ability",
    key: "ExplodeVolatileInfested",
    unit: "SIVolatileInfested",
  },
  co_EnableBuildingAttackVolatileInfested_SIVolatileInfested: {
    name: "Enable Structure Attack",
    category: "ability",
    key: "EnableBuildingAttackVolatileInfested",
    unit: "SIVolatileInfested",
  },
  co_BurrowDown_volatileburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "volatile_burrowed",
  },
  co_BurrowDown_marineburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "marine_burrowed",
  },
  co_StukovInfestedDiamondbackSnare_StukovInfestedDiamondBack: {
    name: "Fungal Snare",
    category: "ability",
    key: "StukovInfestedDiamondbackSnare",
    unit: "StukovInfestedDiamondBack",
  },
  co_StukovInfestedSiegeTankRoot_StukovInfestedSiegeTank: {
    name: "Root",
    category: "ability",
    key: "StukovInfestedSiegeTankRoot",
    unit: "StukovInfestedSiegeTank",
  },
  co_StukovInfestedSiegeTankUproot_StukovInfestedSiegeTank: {
    name: "Uproot",
    category: "ability",
    key: "StukovInfestedSiegeTankUproot",
    unit: "StukovInfestedSiegeTank",
  },
  co_StukovInfestedSiegeTankDeepTunnel_StukovInfestedSiegeTank: {
    name: "Deep Tunnel",
    category: "ability",
    key: "StukovInfestedSiegeTankDeepTunnel",
    unit: "StukovInfestedSiegeTank",
  },
  co_CommanderPrestigeStukovBansheesDeploy_StukovInfestedBanshee: {
    name: "Remote Deployment",
    category: "ability",
    key: "CommanderPrestigeStukovBansheesDeploy",
    unit: "StukovInfestedBanshee",
  },
  co_SIBansheeUnloadAll: { name: "Unload All", category: "ability", key: "SIBansheeUnloadAll" },
  co_QueenClassicParasite_SIQueen: {
    name: "Ocular Symbiote",
    category: "ability",
    key: "QueenClassicParasite",
    unit: "SIQueen",
  },
  co_QueenMPSpawnBroodlings_SIQueen: {
    name: "Spawn Broodlings",
    category: "ability",
    key: "QueenMPSpawnBroodlings",
    unit: "SIQueen",
  },
  co_SIQueenFungalGrowth_SIQueen: {
    name: "Fungal Growth",
    category: "ability",
    key: "SIQueenFungalGrowth",
    unit: "SIQueen",
  },
  co_SIClusterRockets_StukovApocalisk: {
    name: "Cluster Rockets",
    category: "ability",
    key: "SIClusterRockets",
    unit: "StukovApocalisk",
  },
  co_ApocaliskBurrowCharge_StukovApocalisk: {
    name: "Burrow Charge",
    category: "ability",
    key: "ApocaliskBurrowCharge",
    unit: "StukovApocalisk",
  },
  co_SISCV: { name: "Spawn Infested SCV", category: "unit", key: "SISCV" },
  co_SIOverlord_SICommandCenter: {
    name: "Spawn Overlord",
    category: "unit",
    key: "SIOverlord",
    unit: "SICommandCenter",
  },
  co_ResearchHeavyInfestation_SICommandCenter: {
    name: "Aggressive Incubation",
    category: "ability",
    key: "ResearchHeavyInfestation",
    unit: "SICommandCenter",
  },
  co_SIUproot_SICommandCenter_commandcenteruprooted: {
    name: "Uproot",
    category: "command",
    key: "SIUproot",
    unit: "SICommandCenter",
    opens: "commandcenter_uprooted",
  },
  co_SIRoot_SICommandCenterFlying: {
    name: "Root",
    category: "unit",
    key: "SIRoot",
    unit: "SICommandCenterFlying",
  },
  co_ResearchSIBarracksTrainInfestedCivilianLevel2_SICivilianStructure: {
    name: "Infestation",
    category: "ability",
    key: "ResearchSIBarracksTrainInfestedCivilianLevel2",
    unit: "SICivilianStructure",
  },
  co_EvolveStukovInfestedInfestedCivilianLeap_SICivilianStructure: {
    name: "Anaerobic Enhancement",
    category: "ability",
    key: "EvolveStukovInfestedInfestedCivilianLeap",
    unit: "SICivilianStructure",
  },
  co_EvolveStukovInfestedCivilianSpawnBroodlingsOnDeath_SICivilianStructure: {
    name: "Broodling Gestation",
    category: "ability",
    key: "EvolveStukovInfestedCivilianSpawnBroodlingsOnDeath",
    unit: "SICivilianStructure",
  },
  co_SIInfestedCivilian_SICivilianStructure: {
    name: "Spawn Infested Civilian",
    category: "unit",
    key: "SIInfestedCivilian",
    unit: "SICivilianStructure",
  },
  co_SIStukovPlaceHordeRally_SICivilianStructure: {
    name: "Deploy Psi Emitter",
    category: "unit",
    key: "SIStukovPlaceHordeRally",
    unit: "SICivilianStructure",
  },
  co_SIUproot_SICivilianStructure_colonistcompounduprooted: {
    name: "Uproot",
    category: "command",
    key: "SIUproot",
    unit: "SICivilianStructure",
    opens: "colonistcompound_uprooted",
  },
  co_SIInfestedCivilian_SICivilianStructureFlying: {
    name: "Spawn Infested Civilian",
    category: "unit",
    key: "SIInfestedCivilian",
    unit: "SICivilianStructureFlying",
  },
  co_SIRoot_SICivilianStructureFlying: {
    name: "Root",
    category: "unit",
    key: "SIRoot",
    unit: "SICivilianStructureFlying",
  },
  co_SIInfestedMarine_SIBarracks: {
    name: "Spawn Infested Marine",
    category: "unit",
    key: "SIInfestedMarine",
    unit: "SIBarracks",
  },
  co_SIStukovPlaceHordeRally_SIBarracks: {
    name: "Deploy Psi Emitter",
    category: "unit",
    key: "SIStukovPlaceHordeRally",
    unit: "SIBarracks",
  },
  co_SITechLabBarracks_SIBarracks: {
    name: "Infested Tech Lab",
    category: "unit",
    key: "SITechLabBarracks",
    unit: "SIBarracks",
  },
  co_SIUproot_SIBarracks_barracksuprooted: {
    name: "Uproot",
    category: "command",
    key: "SIUproot",
    unit: "SIBarracks",
    opens: "barracks_uprooted",
  },
  co_EvolveSIMarineTrooperImprovedRange_SIBarracksTechLab: {
    name: "Retinal Augmentation",
    category: "ability",
    key: "EvolveSIMarineTrooperImprovedRange",
    unit: "SIBarracksTechLab",
  },
  co_EvolvePlaguedMunitions_SIBarracksTechLab: {
    name: "Plagued Munitions",
    category: "ability",
    key: "EvolvePlaguedMunitions",
    unit: "SIBarracksTechLab",
  },
  co_SITechLabBarracks_SIBarracks_2: {
    name: "Infested Tech Lab",
    category: "unit",
    key: "SITechLabBarracks",
    unit: "SIBarracks",
  },
  co_SIRoot_SIBarracksFlying: {
    name: "Root",
    category: "unit",
    key: "SIRoot",
    unit: "SIBarracksFlying",
  },
  co_TerranInfantryWeaponsLevel1_SIEngineeringBay: {
    name: "Infantry Weapons",
    category: "ability",
    key: "TerranInfantryWeaponsLevel1",
    unit: "SIEngineeringBay",
  },
  co_TerranInfantryArmorLevel1_SIEngineeringBay: {
    name: "Infantry Armor",
    category: "ability",
    key: "TerranInfantryArmorLevel1",
    unit: "SIEngineeringBay",
  },
  co_ResearchInfestedBunkerLifeRegen_SIEngineeringBay: {
    name: "Regenerative Plating",
    category: "ability",
    key: "ResearchInfestedBunkerLifeRegen",
    unit: "SIEngineeringBay",
  },
  co_ResearchInfestedBunkerArmor_SIEngineeringBay: {
    name: "Calcified Armor",
    category: "ability",
    key: "ResearchInfestedBunkerArmor",
    unit: "SIEngineeringBay",
  },
  co_SIInfestedBunkerSpawnInfestedMarine_SIInfestedBunker: {
    name: "Spawn Infested Trooper",
    category: "unit",
    key: "SIInfestedBunkerSpawnInfestedMarine",
    unit: "SIInfestedBunker",
  },
  co_SIStukovPlaceHordeRally_SIInfestedBunker: {
    name: "Deploy Psi Emitter",
    category: "unit",
    key: "SIStukovPlaceHordeRally",
    unit: "SIInfestedBunker",
  },
  co_SIInfestedBunkerUproot_SIInfestedBunker_bunkeruprooted: {
    name: "Uproot",
    category: "command",
    key: "SIInfestedBunkerUproot",
    unit: "SIInfestedBunker",
    opens: "bunker_uprooted",
  },
  co_SIInfestedBunkerRoot_SIInfestedBunkerUprooted: {
    name: "Root",
    category: "unit",
    key: "SIInfestedBunkerRoot",
    unit: "SIInfestedBunkerUprooted",
  },
  co_Salvage_SIMissileTurret: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "SIMissileTurret",
  },
  co_SIUproot_SIMissileTurret_missileturretuprooted: {
    name: "Uproot",
    category: "command",
    key: "SIUproot",
    unit: "SIMissileTurret",
    opens: "missileturret_uprooted",
  },
  co_Salvage_SIMissileTurret_2: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "SIMissileTurret",
  },
  co_SIRoot_SIMissileTurretFlying: {
    name: "Root",
    category: "unit",
    key: "SIRoot",
    unit: "SIMissileTurretFlying",
  },
  co_SIDiamondBack_SIFactory: {
    name: "Spawn Infested Diamondback",
    category: "unit",
    key: "SIDiamondBack",
    unit: "SIFactory",
  },
  co_SISiegeTank_SIFactory: {
    name: "Spawn Infested Siege Tank",
    category: "unit",
    key: "SISiegeTank",
    unit: "SIFactory",
  },
  co_SITechLabFactory_SIFactory: {
    name: "Infested Tech Lab",
    category: "unit",
    key: "SITechLabFactory",
    unit: "SIFactory",
  },
  co_SIUproot_SIFactory_factoryuprooted: {
    name: "Uproot",
    category: "command",
    key: "SIUproot",
    unit: "SIFactory",
    opens: "factory_uprooted",
  },
  co_EvolveSIDiamondbackImprovedEnsnare_SIFactoryTechLab: {
    name: "Saturated Cultures",
    category: "ability",
    key: "EvolveSIDiamondbackImprovedEnsnare",
    unit: "SIFactoryTechLab",
  },
  co_EvolveSIDiamondbackSnailTrail_SIFactoryTechLab: {
    name: "Caustic Mucus",
    category: "ability",
    key: "EvolveSIDiamondbackSnailTrail",
    unit: "SIFactoryTechLab",
  },
  co_ResearchAutoCreateInfestedCivilianAmmo_SIFactoryTechLab: {
    name: "Automated Mitosis",
    category: "ability",
    key: "ResearchAutoCreateInfestedCivilianAmmo",
    unit: "SIFactoryTechLab",
  },
  co_ResearchInfestedSiegeTankArmoredDamage_SIFactoryTechLab: {
    name: "Acidic Enzymes",
    category: "ability",
    key: "ResearchInfestedSiegeTankArmoredDamage",
    unit: "SIFactoryTechLab",
  },
  co_SITechLabFactory_SIFactory_2: {
    name: "Infested Tech Lab",
    category: "unit",
    key: "SITechLabFactory",
    unit: "SIFactory",
  },
  co_SIRoot_SIFactoryFlying: {
    name: "Root",
    category: "unit",
    key: "SIRoot",
    unit: "SIFactoryFlying",
  },
  co_TerranVehicleAndShipWeaponsLevel1_SIArmory: {
    name: "Vehicle and Ship Weapons",
    category: "ability",
    key: "TerranVehicleAndShipWeaponsLevel1",
    unit: "SIArmory",
  },
  co_TerranVehicleAndShipPlatingLevel1_SIArmory: {
    name: "Vehicle and Ship Armor",
    category: "ability",
    key: "TerranVehicleAndShipPlatingLevel1",
    unit: "SIArmory",
  },
  co_SILiberator_SIStarport: {
    name: "Spawn Infested Liberator",
    category: "unit",
    key: "SILiberator",
    unit: "SIStarport",
  },
  co_SIBanshee_SIStarport: {
    name: "Spawn Infested Banshee",
    category: "unit",
    key: "SIBanshee",
    unit: "SIStarport",
  },
  co_SIQueen: { name: "Spawn Brood Queen", category: "unit", key: "SIQueen" },
  co_SITechLabStarport_SIStarport: {
    name: "Infested Tech Lab",
    category: "unit",
    key: "SITechLabStarport",
    unit: "SIStarport",
  },
  co_SIUproot_SIStarport_starportuprooted: {
    name: "Uproot",
    category: "command",
    key: "SIUproot",
    unit: "SIStarport",
    opens: "starport_uprooted",
  },
  co_ResearchSILiberatorImprovedAoeAttack_SIStarportTechLab: {
    name: "Viral Contamination",
    category: "ability",
    key: "ResearchSILiberatorImprovedAoeAttack",
    unit: "SIStarportTechLab",
  },
  co_ResearchSILiberatorBecometheSwarm_SIStarportTechLab: {
    name: "Cloud Dispersal",
    category: "ability",
    key: "ResearchSILiberatorBecometheSwarm",
    unit: "SIStarportTechLab",
  },
  co_ResearchStukovInfestedBansheeBurrowRegeneration_SIStarportTechLab: {
    name: "Rapid Hibernation",
    category: "ability",
    key: "ResearchStukovInfestedBansheeBurrowRegeneration",
    unit: "SIStarportTechLab",
  },
  co_ResearchStukovInfestedBansheeInfestedLife_SIStarportTechLab: {
    name: "Braced Exoskeleton",
    category: "ability",
    key: "ResearchStukovInfestedBansheeInfestedLife",
    unit: "SIStarportTechLab",
  },
  co_ResearchSIQueenFungalGrowth_SIStarportTechLab: {
    name: "Fungal Growth",
    category: "ability",
    key: "ResearchSIQueenFungalGrowth",
    unit: "SIStarportTechLab",
  },
  co_ResearchSIQueenEnergy_SIStarportTechLab: {
    name: "Enhanced Mitochondria",
    category: "ability",
    key: "ResearchSIQueenEnergy",
    unit: "SIStarportTechLab",
  },
  co_SITechLabStarport_SIStarport_2: {
    name: "Infested Tech Lab",
    category: "unit",
    key: "SITechLabStarport",
    unit: "SIStarport",
  },
  co_SIRoot_SIStarportFlying: {
    name: "Root",
    category: "unit",
    key: "SIRoot",
    unit: "SIStarportFlying",
  },
  co_DehakaLeapStomp_DehakaCoop: {
    name: "Leap",
    category: "ability",
    key: "DehakaLeapStomp",
    unit: "DehakaCoop",
  },
  co_DehakaIntimidatingRoar_DehakaCoop: {
    name: "Intimidating Roar",
    category: "ability",
    key: "DehakaIntimidatingRoar",
    unit: "DehakaCoop",
  },
  co_DehakaConsume_DehakaCoop: {
    name: "Devour",
    category: "ability",
    key: "DehakaConsume",
    unit: "DehakaCoop",
  },
  co_MammothBreath_DehakaCoop: {
    name: "Scorching Breath",
    category: "ability",
    key: "MammothBreath",
    unit: "DehakaCoop",
  },
  co_DehakaDeepTunnel_DehakaCoop: {
    name: "Deep Tunnel",
    category: "ability",
    key: "DehakaDeepTunnel",
    unit: "DehakaCoop",
  },
  co_DehakaLearnAbilities_DehakaCoop_dehakalearn: {
    name: "Mutations",
    category: "command",
    key: "DehakaLearnAbilities",
    unit: "DehakaCoop",
    opens: "dehaka_learn",
  },
  co_LearnDehakaMendingAura_DehakaCoop: {
    name: "Primal Regeneration",
    category: "ability",
    key: "LearnDehakaMendingAura",
    unit: "DehakaCoop",
  },
  co_LearnDehakaDetector_DehakaCoop: {
    name: "Keen Senses",
    category: "ability",
    key: "LearnDehakaDetector",
    unit: "DehakaCoop",
  },
  co_LearnDehakaArmorUpgrade_DehakaCoop: {
    name: "Chitinous Plating",
    category: "ability",
    key: "LearnDehakaArmorUpgrade",
    unit: "DehakaCoop",
  },
  co_DehakaAirAttackUpgrade_DehakaCoop: {
    name: "Deadly Reach",
    category: "ability",
    key: "DehakaAirAttackUpgrade",
    unit: "DehakaCoop",
  },
  co_LearnDehakaLeapStomp_DehakaCoop: {
    name: "Leap",
    category: "ability",
    key: "LearnDehakaLeapStomp",
    unit: "DehakaCoop",
  },
  co_LearnDehakaIntimidatingRoar_DehakaCoop: {
    name: "Intimidating Roar",
    category: "ability",
    key: "LearnDehakaIntimidatingRoar",
    unit: "DehakaCoop",
  },
  co_LearnDehakaConsume_DehakaCoop: {
    name: "Devour",
    category: "ability",
    key: "LearnDehakaConsume",
    unit: "DehakaCoop",
  },
  co_LearnDehakaMammothBreath_DehakaCoop: {
    name: "Scorching Breath",
    category: "ability",
    key: "LearnDehakaMammothBreath",
    unit: "DehakaCoop",
  },
  co_DehakaLeapStomp_DehakaCoopClone: {
    name: "Leap",
    category: "ability",
    key: "DehakaLeapStomp",
    unit: "DehakaCoopClone",
  },
  co_DehakaIntimidatingRoar_DehakaCoopClone: {
    name: "Intimidating Roar",
    category: "ability",
    key: "DehakaIntimidatingRoar",
    unit: "DehakaCoopClone",
  },
  co_DehakaConsume_DehakaCoopClone: {
    name: "Devour",
    category: "ability",
    key: "DehakaConsume",
    unit: "DehakaCoopClone",
  },
  co_MammothBreath_DehakaCoopClone: {
    name: "Scorching Breath",
    category: "ability",
    key: "MammothBreath",
    unit: "DehakaCoopClone",
  },
  co_DehakaDeepTunnel_DehakaCoopClone: {
    name: "Deep Tunnel",
    category: "ability",
    key: "DehakaDeepTunnel",
    unit: "DehakaCoopClone",
  },
  co_DehakaLearnAbilities_DehakaCoopClone_zweihakalearn: {
    name: "Mutations",
    category: "command",
    key: "DehakaLearnAbilities",
    unit: "DehakaCoopClone",
    opens: "zweihaka_learn",
  },
  co_LearnDehakaMendingAura_DehakaCoopClone: {
    name: "Primal Regeneration",
    category: "ability",
    key: "LearnDehakaMendingAura",
    unit: "DehakaCoopClone",
  },
  co_LearnDehakaDetector_DehakaCoopClone: {
    name: "Keen Senses",
    category: "ability",
    key: "LearnDehakaDetector",
    unit: "DehakaCoopClone",
  },
  co_LearnDehakaArmorUpgrade_DehakaCoopClone: {
    name: "Chitinous Plating",
    category: "ability",
    key: "LearnDehakaArmorUpgrade",
    unit: "DehakaCoopClone",
  },
  co_DehakaAirAttackUpgrade_DehakaCoopClone: {
    name: "Deadly Reach",
    category: "ability",
    key: "DehakaAirAttackUpgrade",
    unit: "DehakaCoopClone",
  },
  co_LearnDehakaLeapStomp_DehakaCoopClone: {
    name: "Leap",
    category: "ability",
    key: "LearnDehakaLeapStomp",
    unit: "DehakaCoopClone",
  },
  co_LearnDehakaIntimidatingRoar_DehakaCoopClone: {
    name: "Intimidating Roar",
    category: "ability",
    key: "LearnDehakaIntimidatingRoar",
    unit: "DehakaCoopClone",
  },
  co_LearnDehakaConsume_DehakaCoopClone: {
    name: "Devour",
    category: "ability",
    key: "LearnDehakaConsume",
    unit: "DehakaCoopClone",
  },
  co_LearnDehakaMammothBreath_DehakaCoopClone: {
    name: "Scorching Breath",
    category: "ability",
    key: "LearnDehakaMammothBreath",
    unit: "DehakaCoopClone",
  },
  co_DehakaBuild_DehakaDrone_Dehaka: {
    name: "Build Basic",
    category: "command",
    key: "DehakaBuild",
    unit: "DehakaDrone",
    opens: "drone_build0",
  },
  co_DehakaHatchery_DehakaDrone: {
    name: "Summon Primal Hive",
    category: "structure",
    key: "DehakaHatchery",
    unit: "DehakaDrone",
  },
  co_DehakaBarracks_DehakaDrone: {
    name: "Summon Primal Warden",
    category: "structure",
    key: "DehakaBarracks",
    unit: "DehakaDrone",
  },
  co_DehakaGlevigStructure_DehakaDrone: {
    name: "Summon Glevig’s Den",
    category: "structure",
    key: "DehakaGlevigStructure",
    unit: "DehakaDrone",
  },
  co_DehakaMurvarStructure_DehakaDrone: {
    name: "Summon Murvar’s Den",
    category: "structure",
    key: "DehakaMurvarStructure",
    unit: "DehakaDrone",
  },
  co_DehakaDakrunStructure_DehakaDrone: {
    name: "Summon Dakrun’s Den",
    category: "structure",
    key: "DehakaDakrunStructure",
    unit: "DehakaDrone",
  },
  co_DehakaNydusDestroyer_DehakaDrone: {
    name: "Summon Primal Wurm",
    category: "structure",
    key: "DehakaNydusDestroyer",
    unit: "DehakaDrone",
  },
  co_DehakaRavasaurMerge_DehakaZerglingLevel2: {
    name: "Primal Combat",
    category: "ability",
    key: "DehakaRavasaurMerge",
    unit: "DehakaZerglingLevel2",
  },
  co_BurrowDown_zerglingburrowed_3: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "zergling_burrowed",
  },
  co_BurrowDown_ravasaurburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "ravasaur_burrowed",
  },
  co_DehakaRoachLevel2Merge_DehakaRoachLevel2: {
    name: "Primal Combat",
    category: "ability",
    key: "DehakaRoachLevel2Merge",
    unit: "DehakaRoachLevel2",
  },
  co_DehakaRoachGuardianMerge_DehakaRoachLevel2: {
    name: "Primal Combat",
    category: "ability",
    key: "DehakaRoachGuardianMerge",
    unit: "DehakaRoachLevel2",
  },
  co_BurrowDown_roachburrowed_3: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "roach_burrowed",
  },
  co_BurrowDown_igniterburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "igniter_burrowed",
  },
  co_DehakaGuardianMineCharge_DehakaGuardian: {
    name: "Explosive Spores",
    category: "ability",
    key: "DehakaGuardianMineCharge",
    unit: "DehakaGuardian",
  },
  co_DehakaHydraliskToMutalisk_DehakaHydraliskLevel2: {
    name: "Primal Combat",
    category: "ability",
    key: "DehakaHydraliskToMutalisk",
    unit: "DehakaHydraliskLevel2",
  },
  co_DehakaHydraliskImpalerMerge_DehakaHydraliskLevel2: {
    name: "Primal Combat",
    category: "ability",
    key: "DehakaHydraliskImpalerMerge",
    unit: "DehakaHydraliskLevel2",
  },
  co_BurrowDown_hydraliskburrowed_2: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "hydralisk_burrowed",
  },
  co_ImpalerBurrowDown_lurkerburrowed: {
    name: "Burrow",
    category: "ability",
    key: "ImpalerBurrowDown",
    opens: "lurker_burrowed",
  },
  co_ImpalerBurrowUp: { name: "Unburrow", category: "ability", key: "ImpalerBurrowUp" },
  co_DehakaSpawnLocusts_DehakaSwarmHost: {
    name: "Spawn Primal Locusts",
    category: "ability",
    key: "DehakaSpawnLocusts",
    unit: "DehakaSwarmHost",
  },
  co_DehakaSwarmHostMerge_DehakaSwarmHost: {
    name: "Primal Combat",
    category: "ability",
    key: "DehakaSwarmHostMerge",
    unit: "DehakaSwarmHost",
  },
  co_SwarmHostBurrowDown_swarmhostburrowed: {
    name: "Burrow",
    category: "ability",
    key: "SwarmHostBurrowDown",
    opens: "swarmhost_burrowed",
  },
  co_DehakaSpawnLocusts_DehakaSwarmHostBurrowed: {
    name: "Spawn Primal Locusts",
    category: "ability",
    key: "DehakaSpawnLocusts",
    unit: "DehakaSwarmHostBurrowed",
  },
  co_SwarmHostBurrowUp: { name: "Unburrow", category: "ability", key: "SwarmHostBurrowUp" },
  co_DehakaSpawnLocustsBomb_DehakaPrimalSwarmHost: {
    name: "Spawn Volatile Creeper",
    category: "ability",
    key: "DehakaSpawnLocustsBomb",
    unit: "DehakaPrimalSwarmHost",
  },
  co_SwarmHostBurrowDown_creeperhostburrowed: {
    name: "Burrow",
    category: "ability",
    key: "SwarmHostBurrowDown",
    opens: "creeperhost_burrowed",
  },
  co_DehakaSpawnLocustsBomb_DehakaPrimalSwarmHostBurrowed: {
    name: "Spawn Volatile Creeper",
    category: "ability",
    key: "DehakaSpawnLocustsBomb",
    unit: "DehakaPrimalSwarmHostBurrowed",
  },
  co_SwarmHostBurrowUp_2: { name: "Unburrow", category: "ability", key: "SwarmHostBurrowUp" },
  co_DehakaUltraliskCrashingCharge_DehakaUltraliskLevel2: {
    name: "Brutal Charge",
    category: "ability",
    key: "DehakaUltraliskCrashingCharge",
    unit: "DehakaUltraliskLevel2",
  },
  co_DehakaUltraliskLevel2Merge_DehakaUltraliskLevel2: {
    name: "Primal Combat",
    category: "ability",
    key: "DehakaUltraliskLevel2Merge",
    unit: "DehakaUltraliskLevel2",
  },
  co_BurrowDown_ultraliskburrowed_2: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "ultralisk_burrowed",
  },
  co_DehakaTyrannozorFanOfKnives_DehakaUltraliskLevel3: {
    name: "Barrage of Spikes",
    category: "ability",
    key: "DehakaTyrannozorFanOfKnives",
    unit: "DehakaUltraliskLevel3",
  },
  co_BurrowDown_tyrannozorburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "tyrannozor_burrowed",
  },
  co_CoopMurvarSpawnCreepers_DehakaMurvar: {
    name: "Spawn Swarm",
    category: "ability",
    key: "CoopMurvarSpawnCreepers",
    unit: "DehakaMurvar",
  },
  co_MurvarPukeCoop_DehakaMurvar: {
    name: "Oppressive Stench",
    category: "ability",
    key: "MurvarPukeCoop",
    unit: "DehakaMurvar",
  },
  co_DakrunCrashingCharge_DehakaDakrun: {
    name: "Brutal Charge",
    category: "ability",
    key: "DakrunCrashingCharge",
    unit: "DehakaDakrun",
  },
  co_DehakaDrone_DehakaHatchery: {
    name: "Spawn Primal Drone",
    category: "unit",
    key: "DehakaDrone",
    unit: "DehakaHatchery",
  },
  co_BuildDehakaExtractor_DehakaHatchery: {
    name: "Extractor",
    category: "unit",
    key: "BuildDehakaExtractor",
    unit: "DehakaHatchery",
  },
  co_RallySCV: { name: "Set Worker Rally Point", category: "ability", key: "RallySCV" },
  co_DehakaLearnPrimalWeaponsLevel1_DehakaHatchery: {
    name: "Primal Attacks",
    category: "ability",
    key: "DehakaLearnPrimalWeaponsLevel1",
    unit: "DehakaHatchery",
  },
  co_DehakaLearnPrimalArmorLevel1_DehakaHatchery: {
    name: "Primal Carapace",
    category: "ability",
    key: "DehakaLearnPrimalArmorLevel1",
    unit: "DehakaHatchery",
  },
  co_PrimalBuildingUproot_DehakaHatchery_hatcheryuprooted: {
    name: "Uproot",
    category: "command",
    key: "PrimalBuildingUproot",
    unit: "DehakaHatchery",
    opens: "hatchery_uprooted",
  },
  co_PrimalBuildingRoot_DehakaHatcheryUprooted: {
    name: "Root",
    category: "unit",
    key: "PrimalBuildingRoot",
    unit: "DehakaHatcheryUprooted",
  },
  co_DehakaZergling_DehakaBarracks: {
    name: "Spawn Primal Zergling",
    category: "unit",
    key: "DehakaZergling",
    unit: "DehakaBarracks",
  },
  co_DehakaRoach_DehakaBarracks: {
    name: "Spawn Primal Roach",
    category: "unit",
    key: "DehakaRoach",
    unit: "DehakaBarracks",
  },
  co_DehakaHydralisk_DehakaBarracks: {
    name: "Spawn Primal Hydralisk",
    category: "unit",
    key: "DehakaHydralisk",
    unit: "DehakaBarracks",
  },
  co_DehakaSwarmHost_DehakaBarracks: {
    name: "Spawn Primal Host",
    category: "unit",
    key: "DehakaSwarmHost",
    unit: "DehakaBarracks",
  },
  co_DehakaUltralisk_DehakaBarracks: {
    name: "Spawn Primal Ultralisk",
    category: "unit",
    key: "DehakaUltralisk",
    unit: "DehakaBarracks",
  },
  co_PrimalBuildingUproot_DehakaBarracks_barracksuprooted: {
    name: "Uproot",
    category: "command",
    key: "PrimalBuildingUproot",
    unit: "DehakaBarracks",
    opens: "barracks_uprooted",
  },
  co_PrimalBuildingRoot_DehakaBarracksUprooted: {
    name: "Root",
    category: "unit",
    key: "PrimalBuildingRoot",
    unit: "DehakaBarracksUprooted",
  },
  co_ConsumeDrone_DehakaCoopReviveCocoon: {
    name: "Devour Drone",
    category: "unit",
    key: "ConsumeDrone",
    unit: "DehakaCoopReviveCocoon",
  },
  co_ResearchDehakaRavasaurVSArmor_DehakaGlevigStructure: {
    name: "Dissolving Acid",
    category: "ability",
    key: "ResearchDehakaRavasaurVSArmor",
    unit: "DehakaGlevigStructure",
  },
  co_ResearchDehakaRavasaurRange_DehakaGlevigStructure: {
    name: "Enlarged Parotid Glands",
    category: "ability",
    key: "ResearchDehakaRavasaurRange",
    unit: "DehakaGlevigStructure",
  },
  co_DehakaRoachMoveSpeed_DehakaGlevigStructure: {
    name: "Glial Reconstitution",
    category: "unit",
    key: "DehakaRoachMoveSpeed",
    unit: "DehakaGlevigStructure",
  },
  co_DehakaGlevigRoachFireBreath_DehakaGlevigStructure: {
    name: "Concentrated Fire",
    category: "unit",
    key: "DehakaGlevigRoachFireBreath",
    unit: "DehakaGlevigStructure",
  },
  co_ResearchDehakaHydraliskSpeed_DehakaGlevigStructure: {
    name: "Muscular Augments",
    category: "ability",
    key: "ResearchDehakaHydraliskSpeed",
    unit: "DehakaGlevigStructure",
  },
  co_ResearchDehakaImpalerTenderize_DehakaGlevigStructure: {
    name: "Tenderize",
    category: "ability",
    key: "ResearchDehakaImpalerTenderize",
    unit: "DehakaGlevigStructure",
  },
  co_ResearchSlicingGlave_DehakaMurvarStructure: {
    name: "Slicing Glaive",
    category: "ability",
    key: "ResearchSlicingGlave",
    unit: "DehakaMurvarStructure",
  },
  co_ResearchDehakaMutaliskDamageReduction_DehakaMurvarStructure: {
    name: "Shifting Carapace",
    category: "ability",
    key: "ResearchDehakaMutaliskDamageReduction",
    unit: "DehakaMurvarStructure",
  },
  co_ResearchDehakaMutaliskRespawnOnDeath_DehakaMurvarStructure: {
    name: "Primal Reconstitution",
    category: "ability",
    key: "ResearchDehakaMutaliskRespawnOnDeath",
    unit: "DehakaMurvarStructure",
  },
  co_ResearchDehakaGuardianExplosiveBomb_DehakaMurvarStructure: {
    name: "Explosive Spores",
    category: "ability",
    key: "ResearchDehakaGuardianExplosiveBomb",
    unit: "DehakaMurvarStructure",
  },
  co_ResearchDehakaGuardianFury_DehakaMurvarStructure: {
    name: "Primordial Fury",
    category: "ability",
    key: "ResearchDehakaGuardianFury",
    unit: "DehakaMurvarStructure",
  },
  co_DehakaMurvarCreeperAir_DehakaMurvarStructure: {
    name: "Aerial Burst Sacs",
    category: "unit",
    key: "DehakaMurvarCreeperAir",
    unit: "DehakaMurvarStructure",
  },
  co_ResearchDehakaUltraliskCrashingCharge_DehakaDakrunStructure: {
    name: "Brutal Charge",
    category: "ability",
    key: "ResearchDehakaUltraliskCrashingCharge",
    unit: "DehakaDakrunStructure",
  },
  co_ResearchDehakaUltraliskRegen_DehakaDakrunStructure: {
    name: "Healing Adaptation",
    category: "ability",
    key: "ResearchDehakaUltraliskRegen",
    unit: "DehakaDakrunStructure",
  },
  co_ResearchDehakaUltraliskBash_DehakaDakrunStructure: {
    name: "Impaling Strike",
    category: "ability",
    key: "ResearchDehakaUltraliskBash",
    unit: "DehakaDakrunStructure",
  },
  co_ResearchDehakaTyrannozorFanOfKnives_DehakaDakrunStructure: {
    name: "Barrage of Spikes",
    category: "ability",
    key: "ResearchDehakaTyrannozorFanOfKnives",
    unit: "DehakaDakrunStructure",
  },
  co_ResearchDehakaTyrannozorArmorAura_DehakaDakrunStructure: {
    name: "Tyrant’s Protection",
    category: "ability",
    key: "ResearchDehakaTyrannozorArmorAura",
    unit: "DehakaDakrunStructure",
  },
  co_NydusDestroyerBeam_DehakaNydusDestroyer: {
    name: "Bile Stream",
    category: "unit",
    key: "NydusDestroyerBeam",
    unit: "DehakaNydusDestroyer",
  },
  co_NydusDestroyerDeepTunnel_DehakaNydusDestroyer: {
    name: "Deep Tunnel",
    category: "unit",
    key: "NydusDestroyerDeepTunnel",
    unit: "DehakaNydusDestroyer",
  },
  co_DehakaNydusDestroyerTimedNoFoodBeam_DehakaNydusDestroyerTimedNoFood: {
    name: "Bile Stream",
    category: "unit",
    key: "DehakaNydusDestroyerTimedNoFoodBeam",
    unit: "DehakaNydusDestroyerTimedNoFood",
  },
  co_GreaterNydusDestroyerDeepTunnel_DehakaNydusDestroyerTimedNoFood: {
    name: "Deep Tunnel",
    category: "unit",
    key: "GreaterNydusDestroyerDeepTunnel",
    unit: "DehakaNydusDestroyerTimedNoFood",
  },
  co_GlevigFirebreath_DehakaGlevig: {
    name: "Incendiary Acid",
    category: "unit",
    key: "GlevigFirebreath",
    unit: "DehakaGlevig",
  },
  co_GlevigTunnel_DehakaGlevig: {
    name: "Deep Tunnel",
    category: "unit",
    key: "GlevigTunnel",
    unit: "DehakaGlevig",
  },
  co_GaryStetmannOrb_GaryStetmann: {
    name: "E-Gorb",
    category: "ability",
    key: "GaryStetmannOrb",
    unit: "GaryStetmann",
  },
  co_PowerTowerOverchargeStetmannSpeed_GaryStetmann: {
    name: "Stetellite Overcharge",
    category: "ability",
    key: "PowerTowerOverchargeStetmannSpeed",
    unit: "GaryStetmann",
  },
  co_GaryStetmannRecall_GaryStetmann: {
    name: "Semi-Stable Mass Transportation",
    category: "ability",
    key: "GaryStetmannRecall",
    unit: "GaryStetmann",
  },
  co_MorphToSuperGaryStetmann_GaryStetmann_garysupergary: {
    name: "Super Gary Transformation Sequence",
    category: "command",
    key: "MorphToSuperGaryStetmann",
    unit: "GaryStetmann",
    opens: "gary_supergary",
  },
  co_GaryStetmannOrb_SuperGaryStetmann: {
    name: "E-Gorb",
    category: "ability",
    key: "GaryStetmannOrb",
    unit: "SuperGaryStetmann",
  },
  co_PowerTowerOverchargeStetmannSpeed_SuperGaryStetmann: {
    name: "Stetellite Overcharge",
    category: "ability",
    key: "PowerTowerOverchargeStetmannSpeed",
    unit: "SuperGaryStetmann",
  },
  co_GaryStetmannRecall_SuperGaryStetmann: {
    name: "Semi-Stable Mass Transportation",
    category: "ability",
    key: "GaryStetmannRecall",
    unit: "SuperGaryStetmann",
  },
  co_PowerFieldSuperGaryStetmannSpeed_SuperGaryStetmann: {
    name: "Gary-zone",
    category: "ability",
    key: "PowerFieldSuperGaryStetmannSpeed",
    unit: "SuperGaryStetmann",
  },
  co_DroneStetmann_LarvaStetmann: {
    name: "Mecha Drone",
    category: "ability",
    key: "DroneStetmann",
    unit: "LarvaStetmann",
  },
  co_OverlordStetmann_LarvaStetmann: {
    name: "Mecha Overlord",
    category: "ability",
    key: "OverlordStetmann",
    unit: "LarvaStetmann",
  },
  co_ZerglingStetmann_LarvaStetmann: {
    name: "Mecha Zergling",
    category: "ability",
    key: "ZerglingStetmann",
    unit: "LarvaStetmann",
  },
  co_HydraliskStetmann_LarvaStetmann: {
    name: "Mecha Hydralisk",
    category: "ability",
    key: "HydraliskStetmann",
    unit: "LarvaStetmann",
  },
  co_CorruptorStetmann_LarvaStetmann: {
    name: "Mecha Corruptor",
    category: "ability",
    key: "CorruptorStetmann",
    unit: "LarvaStetmann",
  },
  co_InfestorStetmann_LarvaStetmann: {
    name: "Mecha Infestor",
    category: "ability",
    key: "InfestorStetmann",
    unit: "LarvaStetmann",
  },
  co_UltraliskStetmann_LarvaStetmann: {
    name: "Mecha Ultralisk",
    category: "ability",
    key: "UltraliskStetmann",
    unit: "LarvaStetmann",
  },
  co_ZergBuild_DroneStetmann_Stetmann: {
    name: "Build Basic",
    category: "command",
    key: "ZergBuild",
    unit: "DroneStetmann",
    opens: "drone_build0",
  },
  co_ZergBuildAdvanced_DroneStetmann_Stetmann: {
    name: "Build Advanced",
    category: "command",
    key: "ZergBuildAdvanced",
    unit: "DroneStetmann",
    opens: "drone_build1",
  },
  co_RepairStetmann: { name: "Repair", category: "ability", key: "RepairStetmann" },
  co_HatcheryStetmann_DroneStetmann: {
    name: "Mecha Hatchery",
    category: "structure",
    key: "HatcheryStetmann",
    unit: "DroneStetmann",
  },
  co_ExtractorStetmann_DroneStetmann: {
    name: "Mecha Extractor",
    category: "structure",
    key: "ExtractorStetmann",
    unit: "DroneStetmann",
  },
  co_SpawningPoolStetmann_DroneStetmann: {
    name: "Mecha Spawning Pool",
    category: "structure",
    key: "SpawningPoolStetmann",
    unit: "DroneStetmann",
  },
  co_EvolutionChamberStetmann_DroneStetmann: {
    name: "Mecha Evolution Chamber",
    category: "structure",
    key: "EvolutionChamberStetmann",
    unit: "DroneStetmann",
  },
  co_BanelingNestStetmann_DroneStetmann: {
    name: "Mecha Baneling Nest",
    category: "structure",
    key: "BanelingNestStetmann",
    unit: "DroneStetmann",
  },
  co_SpineCrawlerStetmann_DroneStetmann: {
    name: "Mecha Spine Crawler",
    category: "structure",
    key: "SpineCrawlerStetmann",
    unit: "DroneStetmann",
  },
  co_SporeCrawlerStetmann_DroneStetmann: {
    name: "Mecha Spore Crawler",
    category: "structure",
    key: "SporeCrawlerStetmann",
    unit: "DroneStetmann",
  },
  co_HydraliskDenStetmann_DroneStetmann: {
    name: "Mecha Hydralisk Den",
    category: "structure",
    key: "HydraliskDenStetmann",
    unit: "DroneStetmann",
  },
  co_InfestationPitStetmann_DroneStetmann: {
    name: "Mecha Infestation Pit",
    category: "structure",
    key: "InfestationPitStetmann",
    unit: "DroneStetmann",
  },
  co_SpireStetmann_DroneStetmann: {
    name: "Mecha Spire",
    category: "structure",
    key: "SpireStetmann",
    unit: "DroneStetmann",
  },
  co_UltraliskCavernStetmann_DroneStetmann: {
    name: "Mecha Ultralisk Cavern",
    category: "structure",
    key: "UltraliskCavernStetmann",
    unit: "DroneStetmann",
  },
  co_MorphToOverseerStetmann_OverlordStetmann: {
    name: "Mecha Overseer",
    category: "ability",
    key: "MorphToOverseerStetmann",
    unit: "OverlordStetmann",
  },
  co_MorphtoOverseerNormalStetmann_OverseerStetmann: {
    name: "Cancel Oversight",
    category: "ability",
    key: "MorphtoOverseerNormalStetmann",
    unit: "OverseerStetmann",
  },
  co_BanelingStetmann_ZerglingStetmann: {
    name: "Mecha Baneling",
    category: "ability",
    key: "BanelingStetmann",
    unit: "ZerglingStetmann",
  },
  co_BurrowDown_zerglingburrowed_4: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "zergling_burrowed",
  },
  co_ExplodeStetmann_BanelingStetmann: {
    name: "Explode",
    category: "ability",
    key: "ExplodeStetmann",
    unit: "BanelingStetmann",
  },
  co_EnableBuildingAttack_BanelingStetmann: {
    name: "Enable Structure Attack",
    category: "ability",
    key: "EnableBuildingAttack",
    unit: "BanelingStetmann",
  },
  co_BanelingStetmannMovementSpeed_BanelingStetmann: {
    name: "Anti-Centripetal Rocket Servos",
    category: "ability",
    key: "BanelingStetmannMovementSpeed",
    unit: "BanelingStetmann",
  },
  co_BurrowDown_banelingburrowed_2: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "baneling_burrowed",
  },
  co_ExplodeStetmann_BanelingStetmannBurrowed: {
    name: "Explode",
    category: "ability",
    key: "ExplodeStetmann",
    unit: "BanelingStetmannBurrowed",
  },
  co_ExplodeStetmann_BanelingStetmann_2: {
    name: "Explode",
    category: "ability",
    key: "ExplodeStetmann",
    unit: "BanelingStetmann",
  },
  co_DisableBuildingAttack_BanelingStetmann: {
    name: "Disable Structure Attack",
    category: "ability",
    key: "DisableBuildingAttack",
    unit: "BanelingStetmann",
  },
  co_BurrowDown_roachburrowed_4: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "roach_burrowed",
  },
  co_RavagerStetmannCorrosiveBile_RavagerStetmann: {
    name: "Environmentally Unfriendly Eruption",
    category: "ability",
    key: "RavagerStetmannCorrosiveBile",
    unit: "RavagerStetmann",
  },
  co_BurrowDown_ravagerburrowed_2: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "ravager_burrowed",
  },
  co_HydraliskStetmannMissilePowerOn: {
    name: "Juiced Up Payload: On",
    category: "ability",
    key: "HydraliskStetmannMissilePowerOn",
  },
  co_HydraliskStetmannMissilePowerOff_HydraliskStetmann: {
    name: "Juiced Up Payload: Off",
    category: "ability",
    key: "HydraliskStetmannMissilePowerOff",
    unit: "HydraliskStetmann",
  },
  co_LurkerStetmann_HydraliskStetmann: {
    name: "Mecha Lurker",
    category: "ability",
    key: "LurkerStetmann",
    unit: "HydraliskStetmann",
  },
  co_BurrowDown_hydraliskburrowed_3: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "hydralisk_burrowed",
  },
  co_LurkerStetmannTunnelingBurst_LurkerStetmann: {
    name: "Tunnel of TERROR Algorithm",
    category: "ability",
    key: "LurkerStetmannTunnelingBurst",
    unit: "LurkerStetmann",
  },
  co_LurkerStetmannChannelingSpines_LurkerStetmann: {
    name: "Focused Strike Algorithm",
    category: "ability",
    key: "LurkerStetmannChannelingSpines",
    unit: "LurkerStetmann",
  },
  co_LurkerBurrowDown_lurkerburrowed: {
    name: "Burrow",
    category: "ability",
    key: "LurkerBurrowDown",
    opens: "lurker_burrowed",
  },
  co_LurkerStetmannTunnelingBurst_LurkerStetmannBurrowed: {
    name: "Tunnel of TERROR Algorithm",
    category: "ability",
    key: "LurkerStetmannTunnelingBurst",
    unit: "LurkerStetmannBurrowed",
  },
  co_LurkerStetmannChannelingSpines_LurkerStetmannBurrowed: {
    name: "Focused Strike Algorithm",
    category: "ability",
    key: "LurkerStetmannChannelingSpines",
    unit: "LurkerStetmannBurrowed",
  },
  co_LurkerCancelHoldFire_LurkerStetmannBurrowed: {
    name: "Hold Fire",
    category: "ability",
    key: "LurkerCancelHoldFire",
    unit: "LurkerStetmannBurrowed",
  },
  co_LurkerHoldFire_LurkerStetmannBurrowed: {
    name: "Cancel Hold Fire",
    category: "ability",
    key: "LurkerHoldFire",
    unit: "LurkerStetmannBurrowed",
  },
  co_LurkerBurrowUp_2: { name: "Unburrow", category: "ability", key: "LurkerBurrowUp" },
  co_CorruptorStetmannMissilePods_CorruptorStetmann: {
    name: "Cluster Busters",
    category: "ability",
    key: "CorruptorStetmannMissilePods",
    unit: "CorruptorStetmann",
  },
  co_CausticSprayStetmann_CorruptorStetmann: {
    name: "Terraclean Solvent",
    category: "ability",
    key: "CausticSprayStetmann",
    unit: "CorruptorStetmann",
  },
  co_BroodLordStetmann_CorruptorStetmann: {
    name: "Mecha Battlecarrier Lord",
    category: "ability",
    key: "BroodLordStetmann",
    unit: "CorruptorStetmann",
  },
  co_BroodLordStetmannBroodlings_BroodLordStetmann: {
    name: "Ready Mecha Broodling",
    category: "ability",
    key: "BroodLordStetmannBroodlings",
    unit: "BroodLordStetmann",
  },
  co_BroodLordStetmannBombers_BroodLordStetmann: {
    name: "Mecha Locusceptor",
    category: "ability",
    key: "BroodLordStetmannBombers",
    unit: "BroodLordStetmann",
  },
  co_BroodLordStetmannYamatoCannon: {
    name: "Stetmato Cannon",
    category: "ability",
    key: "BroodLordStetmannYamatoCannon",
  },
  co_InfestorStetmannEggLaunch_InfestorStetmann: {
    name: "Roaches Away!",
    category: "ability",
    key: "InfestorStetmannEggLaunch",
    unit: "InfestorStetmann",
  },
  co_InfestorStetmannHealingTentacle_InfestorStetmann: {
    name: "UMI-C Charging Protocol",
    category: "ability",
    key: "InfestorStetmannHealingTentacle",
    unit: "InfestorStetmann",
  },
  co_InfestorStetmannInfestBuilding_InfestorStetmann: {
    name: "Deconstructive Roach-nites",
    category: "ability",
    key: "InfestorStetmannInfestBuilding",
    unit: "InfestorStetmann",
  },
  co_BurrowDown_infestorburrowed: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "infestor_burrowed",
  },
  co_InfestorStetmannEggLaunch_InfestorStetmannBurrowed: {
    name: "Roaches Away!",
    category: "ability",
    key: "InfestorStetmannEggLaunch",
    unit: "InfestorStetmannBurrowed",
  },
  co_InfestorStetmannHealingTentacle_InfestorStetmannBurrowed: {
    name: "UMI-C Charging Protocol",
    category: "ability",
    key: "InfestorStetmannHealingTentacle",
    unit: "InfestorStetmannBurrowed",
  },
  co_InfestorStetmannInfestBuilding_InfestorStetmannBurrowed: {
    name: "Deconstructive Roach-nites",
    category: "ability",
    key: "InfestorStetmannInfestBuilding",
    unit: "InfestorStetmannBurrowed",
  },
  co_UltraliskStetmannBurrowCharge_UltraliskStetmann: {
    name: "Vectored Burrow Charge",
    category: "ability",
    key: "UltraliskStetmannBurrowCharge",
    unit: "UltraliskStetmann",
  },
  co_UltraliskStetmannMechanicalLifeLeech_UltraliskStetmann: {
    name: "Mecha Mooch Module",
    category: "ability",
    key: "UltraliskStetmannMechanicalLifeLeech",
    unit: "UltraliskStetmann",
  },
  co_BurrowDown_ultraliskburrowed_3: {
    name: "Burrow",
    category: "ability",
    key: "BurrowDown",
    opens: "ultralisk_burrowed",
  },
  co_LarvaStetmann: { name: "Select Mecha Larva", category: "unit", key: "LarvaStetmann" },
  co_ResearchOverlordStetmannSpeed: {
    name: "Pneumatized Fuselage",
    category: "ability",
    key: "ResearchOverlordStetmannSpeed",
  },
  co_ResearchOverlordStetmannVentralSacks: {
    name: "Ventral Pods",
    category: "ability",
    key: "ResearchOverlordStetmannVentralSacks",
  },
  co_RallyEggStetmann: {
    name: "Set Worker Rally Point",
    category: "ability",
    key: "RallyEggStetmann",
  },
  co_LairStetmann_HatcheryStetmann_hatcherymechalair: {
    name: "Mecha Lair",
    category: "command",
    key: "LairStetmann",
    unit: "HatcheryStetmann",
    opens: "hatchery_mechalair",
  },
  co_LarvaStetmann_2: { name: "Select Mecha Larva", category: "unit", key: "LarvaStetmann" },
  co_ResearchOverlordStetmannSpeed_2: {
    name: "Pneumatized Fuselage",
    category: "ability",
    key: "ResearchOverlordStetmannSpeed",
  },
  co_ResearchOverlordStetmannVentralSacks_2: {
    name: "Ventral Pods",
    category: "ability",
    key: "ResearchOverlordStetmannVentralSacks",
  },
  co_RallyEggStetmann_2: {
    name: "Set Worker Rally Point",
    category: "ability",
    key: "RallyEggStetmann",
  },
  co_HiveStetmann_LairStetmann: {
    name: "Mecha Hive",
    category: "unit",
    key: "HiveStetmann",
    unit: "LairStetmann",
  },
  co_ResearchZerglingStetmannMovementSpeed_SpawningPoolStetmann: {
    name: "Metal-bolic Boost",
    category: "ability",
    key: "ResearchZerglingStetmannMovementSpeed",
    unit: "SpawningPoolStetmann",
  },
  co_ResearchZerglingStetmannHardenedShield_SpawningPoolStetmann: {
    name: "Hardened Egonergy Shield",
    category: "ability",
    key: "ResearchZerglingStetmannHardenedShield",
    unit: "SpawningPoolStetmann",
  },
  co_ResearchZerglingStetmannAttackSpeed_SpawningPoolStetmann: {
    name: "Synthetic Adrenal Pumps",
    category: "ability",
    key: "ResearchZerglingStetmannAttackSpeed",
    unit: "SpawningPoolStetmann",
  },
  co_ZerglingStetmannRespawn_SpawningPoolStetmann: {
    name: "Recycle Mecha Zergling",
    category: "unit",
    key: "ZerglingStetmannRespawn",
    unit: "SpawningPoolStetmann",
  },
  co_ZergMeleeWeaponsStetmann1_EvolutionChamberStetmann: {
    name: "Mecha Melee Attacks",
    category: "unit",
    key: "ZergMeleeWeaponsStetmann1",
    unit: "EvolutionChamberStetmann",
  },
  co_ZergMissileWeaponsStetmann1_EvolutionChamberStetmann: {
    name: "Mecha Missile Attacks",
    category: "unit",
    key: "ZergMissileWeaponsStetmann1",
    unit: "EvolutionChamberStetmann",
  },
  co_ZergGroundArmorStetmann1_EvolutionChamberStetmann: {
    name: "Mecha Ground Carapace",
    category: "unit",
    key: "ZergGroundArmorStetmann1",
    unit: "EvolutionChamberStetmann",
  },
  co_ResearchBanelingStetmannMovementSpeed_BanelingNestStetmann: {
    name: "Anti-Centripetal Rocket Servos",
    category: "ability",
    key: "ResearchBanelingStetmannMovementSpeed",
    unit: "BanelingNestStetmann",
  },
  co_ResearchBanelingStetmannExtraDamage_BanelingNestStetmann: {
    name: "Egonergy Enhanced Explosives",
    category: "ability",
    key: "ResearchBanelingStetmannExtraDamage",
    unit: "BanelingNestStetmann",
  },
  co_ResearchBanelingStetmannManaShieldBonus_BanelingNestStetmann: {
    name: "Egonergy Efficient Barrier",
    category: "ability",
    key: "ResearchBanelingStetmannManaShieldBonus",
    unit: "BanelingNestStetmann",
  },
  co_SpineCrawlerUprootStetmann_SpineCrawlerStetmann_spinecrawleruprooted: {
    name: "Uproot",
    category: "command",
    key: "SpineCrawlerUprootStetmann",
    unit: "SpineCrawlerStetmann",
    opens: "spinecrawler_uprooted",
  },
  co_SpineCrawlerRootStetmann_SpineCrawlerUprootedStetmann: {
    name: "Root",
    category: "unit",
    key: "SpineCrawlerRootStetmann",
    unit: "SpineCrawlerUprootedStetmann",
  },
  co_SporeCrawlerUprootStetmann_SporeCrawlerStetmann_sporecrawleruprooted: {
    name: "Uproot",
    category: "command",
    key: "SporeCrawlerUprootStetmann",
    unit: "SporeCrawlerStetmann",
    opens: "sporecrawler_uprooted",
  },
  co_SporeCrawlerRootStetmann_SporeCrawlerUprootedStetmann: {
    name: "Root",
    category: "unit",
    key: "SporeCrawlerRootStetmann",
    unit: "SporeCrawlerUprootedStetmann",
  },
  co_ResearchHydraliskStetmannMovementSpeed_HydraliskDenStetmann: {
    name: "Hydra-lic Augments",
    category: "ability",
    key: "ResearchHydraliskStetmannMovementSpeed",
    unit: "HydraliskDenStetmann",
  },
  co_ResearchHydraliskStetmannDamage_HydraliskDenStetmann: {
    name: "Erudition Missile Launchers",
    category: "ability",
    key: "ResearchHydraliskStetmannDamage",
    unit: "HydraliskDenStetmann",
  },
  co_ResearchHydraliskStetmannRange_HydraliskDenStetmann: {
    name: "Tyr-Class Targeting System",
    category: "ability",
    key: "ResearchHydraliskStetmannRange",
    unit: "HydraliskDenStetmann",
  },
  co_ResearchLurkerStetmannTunnelingBurstRange_HydraliskDenStetmann: {
    name: "Extended Tunnel of TERROR Algorithm",
    category: "ability",
    key: "ResearchLurkerStetmannTunnelingBurstRange",
    unit: "HydraliskDenStetmann",
  },
  co_ReserachLurkerStetmannChannelingSpines_HydraliskDenStetmann: {
    name: "Focused Strike Algorithm",
    category: "unit",
    key: "ReserachLurkerStetmannChannelingSpines",
    unit: "HydraliskDenStetmann",
  },
  co_LurkerDenStetmann_HydraliskDenStetmann: {
    name: "Mecha Lurker Den",
    category: "unit",
    key: "LurkerDenStetmann",
    unit: "HydraliskDenStetmann",
  },
  co_HydraliskStetmannRespawn_HydraliskDenStetmann: {
    name: "Recycle Mecha Hydralisk",
    category: "unit",
    key: "HydraliskStetmannRespawn",
    unit: "HydraliskDenStetmann",
  },
  co_InfestorStetmannBonusRavager_InfestationPitStetmann: {
    name: "BONUS Ravager!",
    category: "unit",
    key: "InfestorStetmannBonusRavager",
    unit: "InfestationPitStetmann",
  },
  co_InfestorStetmannRespawn_InfestationPitStetmann: {
    name: "Recycle Mecha Infestor",
    category: "unit",
    key: "InfestorStetmannRespawn",
    unit: "InfestationPitStetmann",
  },
  co_ZergFlyerAttackStetmann1: {
    name: "Mecha Flyer Attacks",
    category: "ability",
    key: "ZergFlyerAttackStetmann1",
  },
  co_ZergFlyerArmorStetmann1: {
    name: "Mecha Flyer Plating",
    category: "ability",
    key: "ZergFlyerArmorStetmann1",
  },
  co_CorruptorStetmannBiggerAoE_SpireStetmann: {
    name: "Wide Area Cluster Busters",
    category: "unit",
    key: "CorruptorStetmannBiggerAoE",
    unit: "SpireStetmann",
  },
  co_ResearchCorruptorCausticSprayStetmann_SpireStetmann: {
    name: "Terraclean Solvent",
    category: "ability",
    key: "ResearchCorruptorCausticSprayStetmann",
    unit: "SpireStetmann",
  },
  co_BroodLordStetmannBombersLearn_SpireStetmann: {
    name: "Locusceptor Bay",
    category: "unit",
    key: "BroodLordStetmannBombersLearn",
    unit: "SpireStetmann",
  },
  co_BroodLordStetmannYamato_SpireStetmann: {
    name: "Stetmato Cannon",
    category: "unit",
    key: "BroodLordStetmannYamato",
    unit: "SpireStetmann",
  },
  co_GreaterSpireStetmann_SpireStetmann: {
    name: "Mecha Greater Spire",
    category: "unit",
    key: "GreaterSpireStetmann",
    unit: "SpireStetmann",
  },
  co_CorruptorStetmannRespawn_SpireStetmann: {
    name: "Recycle Mecha Corruptor",
    category: "unit",
    key: "CorruptorStetmannRespawn",
    unit: "SpireStetmann",
  },
  co_ResearchUltraliskStetmannBurrowChargeMechanicalStun_UltraliskCavernStetmann: {
    name: "Electrostatic Surprise!",
    category: "ability",
    key: "ResearchUltraliskStetmannBurrowChargeMechanicalStun",
    unit: "UltraliskCavernStetmann",
  },
  co_ReserachUltraliskStetmannMechanicalLifeLeech_UltraliskCavernStetmann: {
    name: "Mecha Mooch Module",
    category: "unit",
    key: "ReserachUltraliskStetmannMechanicalLifeLeech",
    unit: "UltraliskCavernStetmann",
  },
  co_ReserachUltraliskStetmannArmor_UltraliskCavernStetmann: {
    name: "Chitanium Plating",
    category: "unit",
    key: "ReserachUltraliskStetmannArmor",
    unit: "UltraliskCavernStetmann",
  },
  co_UltraliskStetmannRespawn_UltraliskCavernStetmann: {
    name: "Recycle Mecha Ultralisk",
    category: "unit",
    key: "UltraliskStetmannRespawn",
    unit: "UltraliskCavernStetmann",
  },
  co_FASTOverloadStetmann_PowerTowerStetmann: {
    name: "F.A.S.T. Overload",
    category: "unit",
    key: "FASTOverloadStetmann",
    unit: "PowerTowerStetmann",
  },
  co_ProtossBuild_Probe_Artanis: {
    name: "Warp In",
    category: "command",
    key: "ProtossBuild",
    unit: "Probe",
    opens: "probe_build0",
  },
  co_ProtossBuildAdvanced_Probe_Artanis: {
    name: "Warp In Adv.",
    category: "command",
    key: "ProtossBuildAdvanced",
    unit: "Probe",
    opens: "probe_build1",
  },
  co_Charge_ZealotAiur: { name: "Charge", category: "ability", key: "Charge", unit: "ZealotAiur" },
  co_VoidZealotWhirlwind_ZealotAiur: {
    name: "Whirlwind",
    category: "ability",
    key: "VoidZealotWhirlwind",
    unit: "ZealotAiur",
  },
  co_Feedback_Archon: { name: "Feedback", category: "ability", key: "Feedback", unit: "Archon" },
  co_PsiStorm_Archon: {
    name: "Psionic Storm",
    category: "ability",
    key: "PsiStorm",
    unit: "Archon",
  },
  co_ImmortalOverload_Immortal: {
    name: "Barrier",
    category: "ability",
    key: "ImmortalOverload",
    unit: "Immortal",
  },
  co_ReaverScarabs_Reaver: {
    name: "Create Scarab",
    category: "ability",
    key: "ReaverScarabs",
    unit: "Reaver",
  },
  co_LightningBomb_Tempest: {
    name: "Disintegration",
    category: "ability",
    key: "LightningBomb",
    unit: "Tempest",
  },
  co_TimeWarp_Nexus: { name: "Chrono Boost", category: "ability", key: "TimeWarp", unit: "Nexus" },
  co_ResearchDragoonRange_TwilightCouncil: {
    name: "Singularity Charge",
    category: "ability",
    key: "ResearchDragoonRange",
    unit: "TwilightCouncil",
  },
  co_ResearchWhirlwind_TwilightCouncil: {
    name: "Whirlwind",
    category: "ability",
    key: "ResearchWhirlwind",
    unit: "TwilightCouncil",
  },
  co_ResearchDragoonChassis_TwilightCouncil: {
    name: "Trillic Compression Systems",
    category: "ability",
    key: "ResearchDragoonChassis",
    unit: "TwilightCouncil",
  },
  co_ResearchHighTemplarEnergyUpgrade_TemplarArchive: {
    name: "Khaydarin Amulet",
    category: "ability",
    key: "ResearchHighTemplarEnergyUpgrade",
    unit: "TemplarArchive",
  },
  co_ResearchHealingPsionicStorm_TemplarArchive: {
    name: "Plasma Surge",
    category: "ability",
    key: "ResearchHealingPsionicStorm",
    unit: "TemplarArchive",
  },
  co_ResearchReaverIncreasedScarabCount_RoboticsBay: {
    name: "Scarab Housing",
    category: "ability",
    key: "ResearchReaverIncreasedScarabCount",
    unit: "RoboticsBay",
  },
  co_ResearchReaverIncreasedScarabSplashRadius_RoboticsBay: {
    name: "Solarite Payload",
    category: "ability",
    key: "ResearchReaverIncreasedScarabSplashRadius",
    unit: "RoboticsBay",
  },
  co_ResearchDoubleGravitonBeam_FleetBeacon: {
    name: "Double Graviton Beam",
    category: "ability",
    key: "ResearchDoubleGravitonBeam",
    unit: "FleetBeacon",
  },
  co_ResearchTempestDisintegration_FleetBeacon: {
    name: "Disintegration",
    category: "ability",
    key: "ResearchTempestDisintegration",
    unit: "FleetBeacon",
  },
  co_ProtossBuild_Probe_Vorazun: {
    name: "Warp In",
    category: "command",
    key: "ProtossBuild",
    unit: "Probe",
    opens: "probe_build0",
  },
  co_ProtossBuildAdvanced_Probe_Vorazun: {
    name: "Warp In Adv.",
    category: "command",
    key: "ProtossBuildAdvanced",
    unit: "Probe",
    opens: "probe_build1",
  },
  co_VoidZealotShadowCharge_ZealotShakuras: {
    name: "Shadow Charge",
    category: "ability",
    key: "VoidZealotShadowCharge",
    unit: "ZealotShakuras",
  },
  co_VoidZealotShadowChargeStun_ZealotShakuras: {
    name: "Darkcoil",
    category: "ability",
    key: "VoidZealotShadowChargeStun",
    unit: "ZealotShakuras",
  },
  co_StalkerBlinkShieldRestoreBase_StalkerShakuras: {
    name: "Blink",
    category: "ability",
    key: "StalkerBlinkShieldRestoreBase",
    unit: "StalkerShakuras",
  },
  co_VoidDarkTemplarShadowFury_DarkTemplarShakuras: {
    name: "Shadow Fury",
    category: "ability",
    key: "VoidDarkTemplarShadowFury",
    unit: "DarkTemplarShakuras",
  },
  co_DarkTemplarShadowDash_DarkTemplarShakuras: {
    name: "Blink",
    category: "ability",
    key: "DarkTemplarShadowDash",
    unit: "DarkTemplarShakuras",
  },
  co_VoidStasis_DarkTemplarShakuras: {
    name: "Void Stasis",
    category: "ability",
    key: "VoidStasis",
    unit: "DarkTemplarShakuras",
  },
  co_DarkArchonConfusion_DarkArchon: {
    name: "Confusion",
    category: "ability",
    key: "DarkArchonConfusion",
    unit: "DarkArchon",
  },
  co_DarkArchonMindControl_DarkArchon: {
    name: "Mind Control",
    category: "ability",
    key: "DarkArchonMindControl",
    unit: "DarkArchon",
  },
  co_CorsairMPDisruptionWeb_CorsairMP: {
    name: "Disruption Web",
    category: "ability",
    key: "CorsairMPDisruptionWeb",
    unit: "CorsairMP",
  },
  co_VoidShadowGuardShadowFury_VorazunShadowGuard: {
    name: "Shadow Fury",
    category: "ability",
    key: "VoidShadowGuardShadowFury",
    unit: "VorazunShadowGuard",
  },
  co_ShadowGuardBlink_VorazunShadowGuard: {
    name: "Blink",
    category: "ability",
    key: "ShadowGuardBlink",
    unit: "VorazunShadowGuard",
  },
  co_VoidStasis_VorazunShadowGuard: {
    name: "Void Stasis",
    category: "ability",
    key: "VoidStasis",
    unit: "VorazunShadowGuard",
  },
  co_TimeWarp_Nexus_2: {
    name: "Chrono Boost",
    category: "ability",
    key: "TimeWarp",
    unit: "Nexus",
  },
  co_DarkArchon_Gateway: {
    name: "Dark Archon",
    category: "unit",
    key: "DarkArchon",
    unit: "Gateway",
  },
  co_UpgradeToWarpGate_Gateway_gatewaywarpgate: {
    name: "Transform to Warp Gate",
    category: "command",
    key: "UpgradeToWarpGate",
    unit: "Gateway",
    opens: "gateway_warpgate",
  },
  co_DarkArchon_WarpGate: {
    name: "Dark Archon",
    category: "unit",
    key: "DarkArchon",
    unit: "WarpGate",
  },
  co_ResearchDragoonRange_TwilightCouncil_2: {
    name: "Singularity Charge",
    category: "ability",
    key: "ResearchDragoonRange",
    unit: "TwilightCouncil",
  },
  co_ResearchWhirlwind_TwilightCouncil_2: {
    name: "Whirlwind",
    category: "ability",
    key: "ResearchWhirlwind",
    unit: "TwilightCouncil",
  },
  co_ResearchDragoonChassis_TwilightCouncil_2: {
    name: "Trillic Compression Systems",
    category: "ability",
    key: "ResearchDragoonChassis",
    unit: "TwilightCouncil",
  },
  co_ResearchShadowFury_DarkShrine: {
    name: "Shadow Fury",
    category: "ability",
    key: "ResearchShadowFury",
    unit: "DarkShrine",
  },
  co_ResearchShadowDash_DarkShrine: {
    name: "Blink",
    category: "ability",
    key: "ResearchShadowDash",
    unit: "DarkShrine",
  },
  co_ResearchVoidStasis_DarkShrine: {
    name: "Void Stasis",
    category: "ability",
    key: "ResearchVoidStasis",
    unit: "DarkShrine",
  },
  co_ResearchDarkArchonFullStartingEnergy_DarkShrine: {
    name: "Argus Crystal",
    category: "ability",
    key: "ResearchDarkArchonFullStartingEnergy",
    unit: "DarkShrine",
  },
  co_ResearchDarkArchonMindControl_DarkShrine: {
    name: "Mind Control",
    category: "ability",
    key: "ResearchDarkArchonMindControl",
    unit: "DarkShrine",
  },
  co_ResearchDoubleGravitonBeam_FleetBeacon_2: {
    name: "Double Graviton Beam",
    category: "ability",
    key: "ResearchDoubleGravitonBeam",
    unit: "FleetBeacon",
  },
  co_ResearchTempestDisintegration_FleetBeacon_2: {
    name: "Disintegration",
    category: "ability",
    key: "ResearchTempestDisintegration",
    unit: "FleetBeacon",
  },
  co_ResearchOracleStasisWardUpgrade_FleetBeacon: {
    name: "Stasis Calibration",
    category: "ability",
    key: "ResearchOracleStasisWardUpgrade",
    unit: "FleetBeacon",
  },
  co_DarkPylonRecall_DarkPylon: {
    name: "Recall",
    category: "unit",
    key: "DarkPylonRecall",
    unit: "DarkPylon",
  },
  co_ProtossBuild_Probe_Karax: {
    name: "Warp In",
    category: "command",
    key: "ProtossBuild",
    unit: "Probe",
    opens: "probe_build0",
  },
  co_ProtossBuildAdvanced_Probe_Karax: {
    name: "Warp In Adv.",
    category: "command",
    key: "ProtossBuildAdvanced",
    unit: "Probe",
    opens: "probe_build1",
  },
  co_KhaydarinMonolith_Probe: {
    name: "Khaydarin Monolith",
    category: "structure",
    key: "KhaydarinMonolith",
    unit: "Probe",
  },
  co_Charge_ZealotPurifier: {
    name: "Charge",
    category: "ability",
    key: "Charge",
    unit: "ZealotPurifier",
  },
  co_VoidSentryChronoBeam_SentryPurifier: {
    name: "Chrono Beam",
    category: "ability",
    key: "VoidSentryChronoBeam",
    unit: "SentryPurifier",
  },
  co_EnergizerReclamation_SentryPurifier: {
    name: "Reclamation",
    category: "ability",
    key: "EnergizerReclamation",
    unit: "SentryPurifier",
  },
  co_VoidSentryPhasingMode_SentryPurifier: {
    name: "Phasing Mode",
    category: "ability",
    key: "VoidSentryPhasingMode",
    unit: "SentryPurifier",
  },
  co_VoidSentryMobileMode_SentryPurifier: {
    name: "Mobile Mode",
    category: "ability",
    key: "VoidSentryMobileMode",
    unit: "SentryPurifier",
  },
  co_ImmortalOverload_Immortal_2: {
    name: "Barrier",
    category: "ability",
    key: "ImmortalOverload",
    unit: "Immortal",
  },
  co_ImmortalShakurasShadowCannon_Immortal: {
    name: "Shadow Cannon",
    category: "ability",
    key: "ImmortalShakurasShadowCannon",
    unit: "Immortal",
  },
  co_GravitonBeam_PhoenixPurifier: {
    name: "Graviton Beam",
    category: "ability",
    key: "GravitonBeam",
    unit: "PhoenixPurifier",
  },
  co_RepairDrones_Carrier: {
    name: "Repair Drones",
    category: "ability",
    key: "RepairDrones",
    unit: "Carrier",
  },
  co_TimeWarp_Nexus_3: {
    name: "Chrono Boost",
    category: "ability",
    key: "TimeWarp",
    unit: "Nexus",
  },
  co_UpgradeToWarpGate_Gateway_gatewaywarpgate_2: {
    name: "Transform to Warp Gate",
    category: "command",
    key: "UpgradeToWarpGate",
    unit: "Gateway",
    opens: "gateway_warpgate",
  },
  co_ShieldBatteryStructureBarrier_ShieldBattery: {
    name: "Fortification Barrier",
    category: "ability",
    key: "ShieldBatteryStructureBarrier",
    unit: "ShieldBattery",
  },
  co_ResearchKaraxTurretRange_Forge: {
    name: "Enhanced Targeting",
    category: "ability",
    key: "ResearchKaraxTurretRange",
    unit: "Forge",
  },
  co_ResearchKaraxTurretAttackSpeed_Forge: {
    name: "Optimized Ordnance",
    category: "ability",
    key: "ResearchKaraxTurretAttackSpeed",
    unit: "Forge",
  },
  co_ResearchStructureBarrier_Forge: {
    name: "Fortification Barrier",
    category: "ability",
    key: "ResearchStructureBarrier",
    unit: "Forge",
  },
  co_ResearchDragoonRange_TwilightCouncil_3: {
    name: "Singularity Charge",
    category: "ability",
    key: "ResearchDragoonRange",
    unit: "TwilightCouncil",
  },
  co_ResearchWhirlwind_TwilightCouncil_3: {
    name: "Whirlwind",
    category: "ability",
    key: "ResearchWhirlwind",
    unit: "TwilightCouncil",
  },
  co_ResearchDragoonChassis_TwilightCouncil_3: {
    name: "Trillic Compression Systems",
    category: "ability",
    key: "ResearchDragoonChassis",
    unit: "TwilightCouncil",
  },
  co_ResearchReaverIncreasedScarabCount_RoboticsBay_2: {
    name: "Scarab Housing",
    category: "ability",
    key: "ResearchReaverIncreasedScarabCount",
    unit: "RoboticsBay",
  },
  co_ResearchReaverIncreasedScarabSplashRadius_RoboticsBay_2: {
    name: "Solarite Payload",
    category: "ability",
    key: "ResearchReaverIncreasedScarabSplashRadius",
    unit: "RoboticsBay",
  },
  co_ResearchDoubleGravitonBeam_FleetBeacon_3: {
    name: "Double Graviton Beam",
    category: "ability",
    key: "ResearchDoubleGravitonBeam",
    unit: "FleetBeacon",
  },
  co_ResearchTempestDisintegration_FleetBeacon_3: {
    name: "Disintegration",
    category: "ability",
    key: "ResearchTempestDisintegration",
    unit: "FleetBeacon",
  },
  co_ResearchInterceptorLaunchSpeedUpgrade_FleetBeacon: {
    name: "Graviton Warp Catapult",
    category: "ability",
    key: "ResearchInterceptorLaunchSpeedUpgrade",
    unit: "FleetBeacon",
  },
  co_ResearchSolarEfficiencyLevel1_SolarForge: {
    name: "Solar Efficiency",
    category: "ability",
    key: "ResearchSolarEfficiencyLevel1",
    unit: "SolarForge",
  },
  co_ResearchSOARepairBeamExtraTarget_SolarForge: {
    name: "Advanced Repair Systems",
    category: "ability",
    key: "ResearchSOARepairBeamExtraTarget",
    unit: "SolarForge",
  },
  co_ResearchSOAOrbitalStrikeUpgrade_SolarForge: {
    name: "Phase Detonation",
    category: "ability",
    key: "ResearchSOAOrbitalStrikeUpgrade",
    unit: "SolarForge",
  },
  co_ResearchSOASolarLanceUpgrade_SolarForge: {
    name: "Solar Flare",
    category: "ability",
    key: "ResearchSOASolarLanceUpgrade",
    unit: "SolarForge",
  },
  co_BrokenSolarForge_SolarForge: {
    name: "Repair",
    category: "unit",
    key: "BrokenSolarForge",
    unit: "SolarForge",
  },
  co_AlarakDeadlyCharge: { name: "Deadly Charge", category: "ability", key: "AlarakDeadlyCharge" },
  co_AlarakKnockback: { name: "Destruction Wave", category: "ability", key: "AlarakKnockback" },
  co_AlarakEmpower: { name: "Empower Me", category: "ability", key: "AlarakEmpower" },
  co_AlarakDeadlyCharge_2: {
    name: "Deadly Charge",
    category: "ability",
    key: "AlarakDeadlyCharge",
  },
  co_AlarakKnockback_2: { name: "Destruction Wave", category: "ability", key: "AlarakKnockback" },
  co_AlarakEmpower_2: { name: "Empower Me", category: "ability", key: "AlarakEmpower" },
  co_ProtossBuild_Probe_Alarak: {
    name: "Warp In",
    category: "command",
    key: "ProtossBuild",
    unit: "Probe",
    opens: "probe_build0",
  },
  co_ProtossBuildAdvanced_Probe_Alarak: {
    name: "Warp In Adv.",
    category: "command",
    key: "ProtossBuildAdvanced",
    unit: "Probe",
    opens: "probe_build1",
  },
  co_TargetLock_Monitor: {
    name: "Target Lock",
    category: "ability",
    key: "TargetLock",
    unit: "Monitor",
  },
  co_SentryTaldarimForceField_Monitor: {
    name: "Force Field",
    category: "ability",
    key: "SentryTaldarimForceField",
    unit: "Monitor",
  },
  co_VoidHighTemplarPsiOrb_HighTemplarTaldarim: {
    name: "Psionic Orb",
    category: "ability",
    key: "VoidHighTemplarPsiOrb",
    unit: "HighTemplarTaldarim",
  },
  co_VoidHighTemplarMindBlast_HighTemplarTaldarim: {
    name: "Mind Blast",
    category: "ability",
    key: "VoidHighTemplarMindBlast",
    unit: "HighTemplarTaldarim",
  },
  co_AscendantSacrifice_HighTemplarTaldarim: {
    name: "Sacrifice",
    category: "ability",
    key: "AscendantSacrifice",
    unit: "HighTemplarTaldarim",
  },
  co_ACAlarakPhasingMode_WarpPrismTaldarim: {
    name: "Phasing Mode",
    category: "ability",
    key: "ACAlarakPhasingMode",
    unit: "WarpPrismTaldarim",
  },
  co_ACAlarakTransportMode_WarpPrismTaldarim: {
    name: "Transport Mode",
    category: "ability",
    key: "ACAlarakTransportMode",
    unit: "WarpPrismTaldarim",
  },
  co_SOAMothershipLineAttack_SOAMothershipv4: {
    name: "Thermal Lance",
    category: "ability",
    key: "SOAMothershipLineAttack",
    unit: "SOAMothershipv4",
  },
  co_AlarakMothershipMassTeleport_SOAMothershipv4: {
    name: "Mass Teleport",
    category: "ability",
    key: "AlarakMothershipMassTeleport",
    unit: "SOAMothershipv4",
  },
  co_VoidRay_SOAMothershipv4: {
    name: "Destroyer",
    category: "ability",
    key: "VoidRay",
    unit: "SOAMothershipv4",
  },
  co_TimeWarp_Nexus_4: {
    name: "Chrono Boost",
    category: "ability",
    key: "TimeWarp",
    unit: "Nexus",
  },
  co_UpgradeToWarpGate_Gateway_gatewaywarpgate_3: {
    name: "Transform to Warp Gate",
    category: "command",
    key: "UpgradeToWarpGate",
    unit: "Gateway",
    opens: "gateway_warpgate",
  },
  co_ResearchKaraxTurretRange_Forge_2: {
    name: "Enhanced Targeting",
    category: "ability",
    key: "ResearchKaraxTurretRange",
    unit: "Forge",
  },
  co_ResearchKaraxTurretAttackSpeed_Forge_2: {
    name: "Optimized Ordnance",
    category: "ability",
    key: "ResearchKaraxTurretAttackSpeed",
    unit: "Forge",
  },
  co_ResearchAlarakTargetLockBuff_CyberneticsCore: {
    name: "Detect Weakness",
    category: "ability",
    key: "ResearchAlarakTargetLockBuff",
    unit: "CyberneticsCore",
  },
  co_ResearchDragoonRange_TwilightCouncil_4: {
    name: "Singularity Charge",
    category: "ability",
    key: "ResearchDragoonRange",
    unit: "TwilightCouncil",
  },
  co_ResearchWhirlwind_TwilightCouncil_4: {
    name: "Whirlwind",
    category: "ability",
    key: "ResearchWhirlwind",
    unit: "TwilightCouncil",
  },
  co_ResearchDragoonChassis_TwilightCouncil_4: {
    name: "Trillic Compression Systems",
    category: "ability",
    key: "ResearchDragoonChassis",
    unit: "TwilightCouncil",
  },
  co_ResearchHighTemplarEnergyUpgrade_TemplarArchive_2: {
    name: "Khaydarin Amulet",
    category: "ability",
    key: "ResearchHighTemplarEnergyUpgrade",
    unit: "TemplarArchive",
  },
  co_ResearchHealingPsionicStorm_TemplarArchive_2: {
    name: "Plasma Surge",
    category: "ability",
    key: "ResearchHealingPsionicStorm",
    unit: "TemplarArchive",
  },
  co_ResearchReaverIncreasedScarabCount_RoboticsBay_3: {
    name: "Scarab Housing",
    category: "ability",
    key: "ResearchReaverIncreasedScarabCount",
    unit: "RoboticsBay",
  },
  co_ResearchReaverIncreasedScarabSplashRadius_RoboticsBay_3: {
    name: "Solarite Payload",
    category: "ability",
    key: "ResearchReaverIncreasedScarabSplashRadius",
    unit: "RoboticsBay",
  },
  co_FenixThunderousChargeCoop_FenixCoop: {
    name: "Thunderous Charge",
    category: "ability",
    key: "FenixThunderousChargeCoop",
    unit: "FenixCoop",
  },
  co_FenixWhirlwind_FenixCoop: {
    name: "Whirlwind",
    category: "ability",
    key: "FenixWhirlwind",
    unit: "FenixCoop",
  },
  co_VoidShieldCapacitor_FenixCoop: {
    name: "Shield Capacitor",
    category: "ability",
    key: "VoidShieldCapacitor",
    unit: "FenixCoop",
  },
  co_FenixDragoonChargedBuster_FenixDragoon: {
    name: "Solar Cannon",
    category: "ability",
    key: "FenixDragoonChargedBuster",
    unit: "FenixDragoon",
  },
  co_FenixDragoonAirBomb_FenixDragoon: {
    name: "Solarite Flare",
    category: "ability",
    key: "FenixDragoonAirBomb",
    unit: "FenixDragoon",
  },
  co_FenixDragoonArsenalOvercharge_FenixDragoon: {
    name: "Arsenal Overcharge",
    category: "ability",
    key: "FenixDragoonArsenalOvercharge",
    unit: "FenixDragoon",
  },
  co_FenixArbiterStasisField_FenixArbiter: {
    name: "Stasis Field",
    category: "ability",
    key: "FenixArbiterStasisField",
    unit: "FenixArbiter",
  },
  co_FenixArbiterCloakField_FenixArbiter: {
    name: "Cloaking Field",
    category: "ability",
    key: "FenixArbiterCloakField",
    unit: "FenixArbiter",
  },
  co_ArbiterMPRecall_FenixArbiter: {
    name: "Recall",
    category: "ability",
    key: "ArbiterMPRecall",
    unit: "FenixArbiter",
  },
  co_ProtossBuild_Probe_Fenix: {
    name: "Warp In",
    category: "command",
    key: "ProtossBuild",
    unit: "Probe",
    opens: "probe_build0",
  },
  co_ProtossBuildAdvanced_Probe_Fenix: {
    name: "Warp In Adv.",
    category: "command",
    key: "ProtossBuildAdvanced",
    unit: "Probe",
    opens: "probe_build1",
  },
  co_Charge_ZealotPurifier_2: {
    name: "Charge",
    category: "ability",
    key: "Charge",
    unit: "ZealotPurifier",
  },
  co_FenixSentryGuardianZone_SentryFenix: {
    name: "Protective Field",
    category: "ability",
    key: "FenixSentryGuardianZone",
    unit: "SentryFenix",
  },
  co_VoidSentryPhasingMode_SentryFenix: {
    name: "Phasing Mode",
    category: "ability",
    key: "VoidSentryPhasingMode",
    unit: "SentryFenix",
  },
  co_VoidSentryMobileMode_SentryFenix: {
    name: "Mobile Mode",
    category: "ability",
    key: "VoidSentryMobileMode",
    unit: "SentryFenix",
  },
  co_ImmortalOverload_Immortal_3: {
    name: "Barrier",
    category: "ability",
    key: "ImmortalOverload",
    unit: "Immortal",
  },
  co_FenixPurificationNova_Disruptor: {
    name: "Purification Nova",
    category: "ability",
    key: "FenixPurificationNova",
    unit: "Disruptor",
  },
  co_FenixKaldalisZealotCharge_FenixKaldalisZealot: {
    name: "Engage",
    category: "ability",
    key: "FenixKaldalisZealotCharge",
    unit: "FenixKaldalisZealot",
  },
  co_FenixTalisAdeptBounceShot_FenixTalisAdept: {
    name: "Ricochet Glaive",
    category: "ability",
    key: "FenixTalisAdeptBounceShot",
    unit: "FenixTalisAdept",
  },
  co_ImmortalOverload_FenixTaldarinImmortal: {
    name: "Barrier",
    category: "ability",
    key: "ImmortalOverload",
    unit: "FenixTaldarinImmortal",
  },
  co_FenixWarbringerColossusPowerShot_FenixWarbringerColossus: {
    name: "Purification Blast",
    category: "ability",
    key: "FenixWarbringerColossusPowerShot",
    unit: "FenixWarbringerColossus",
  },
  co_FenixMojoMissiles_FenixMojoScout: {
    name: "Suppression Procedure",
    category: "ability",
    key: "FenixMojoMissiles",
    unit: "FenixMojoScout",
  },
  co_FenixClolarionInterceptor_FenixClolarionCarrier: {
    name: "Interceptor",
    category: "ability",
    key: "FenixClolarionInterceptor",
    unit: "FenixClolarionCarrier",
  },
  co_TimeWarp_Nexus_5: {
    name: "Chrono Boost",
    category: "ability",
    key: "TimeWarp",
    unit: "Nexus",
  },
  co_UpgradeToWarpGate_Gateway_gatewaywarpgate_4: {
    name: "Transform to Warp Gate",
    category: "command",
    key: "UpgradeToWarpGate",
    unit: "Gateway",
    opens: "gateway_warpgate",
  },
  co_ResearchKaraxTurretRange_Forge_3: {
    name: "Enhanced Targeting",
    category: "ability",
    key: "ResearchKaraxTurretRange",
    unit: "Forge",
  },
  co_ResearchKaraxTurretAttackSpeed_Forge_3: {
    name: "Optimized Ordnance",
    category: "ability",
    key: "ResearchKaraxTurretAttackSpeed",
    unit: "Forge",
  },
  co_ResearchStructureBarrier_Forge_2: {
    name: "Fortification Barrier",
    category: "ability",
    key: "ResearchStructureBarrier",
    unit: "Forge",
  },
  co_ResearchAlarakTargetLockBuff_CyberneticsCore_2: {
    name: "Detect Weakness",
    category: "ability",
    key: "ResearchAlarakTargetLockBuff",
    unit: "CyberneticsCore",
  },
  co_ResearchDragoonRange_TwilightCouncil_5: {
    name: "Singularity Charge",
    category: "ability",
    key: "ResearchDragoonRange",
    unit: "TwilightCouncil",
  },
  co_ResearchWhirlwind_TwilightCouncil_5: {
    name: "Whirlwind",
    category: "ability",
    key: "ResearchWhirlwind",
    unit: "TwilightCouncil",
  },
  co_ResearchDragoonChassis_TwilightCouncil_5: {
    name: "Trillic Compression Systems",
    category: "ability",
    key: "ResearchDragoonChassis",
    unit: "TwilightCouncil",
  },
  co_ResearchReaverIncreasedScarabCount_RoboticsBay_4: {
    name: "Scarab Housing",
    category: "ability",
    key: "ResearchReaverIncreasedScarabCount",
    unit: "RoboticsBay",
  },
  co_ResearchReaverIncreasedScarabSplashRadius_RoboticsBay_4: {
    name: "Solarite Payload",
    category: "ability",
    key: "ResearchReaverIncreasedScarabSplashRadius",
    unit: "RoboticsBay",
  },
  co_FenixImmortalResearchDetonationShot_RoboticsBay: {
    name: "Gravimetric Overload",
    category: "command",
    key: "FenixImmortalResearchDetonationShot",
    unit: "RoboticsBay",
  },
  co_ResearchFenixWarbringerColossusPowerShot_RoboticsBay: {
    name: "Purification Blast",
    category: "ability",
    key: "ResearchFenixWarbringerColossusPowerShot",
    unit: "RoboticsBay",
  },
  co_ResearchDoubleGravitonBeam_FleetBeacon_4: {
    name: "Double Graviton Beam",
    category: "ability",
    key: "ResearchDoubleGravitonBeam",
    unit: "FleetBeacon",
  },
  co_ResearchTempestDisintegration_FleetBeacon_4: {
    name: "Disintegration",
    category: "ability",
    key: "ResearchTempestDisintegration",
    unit: "FleetBeacon",
  },
  co_ResearchOracleStasisWardUpgrade_FleetBeacon_2: {
    name: "Stasis Calibration",
    category: "ability",
    key: "ResearchOracleStasisWardUpgrade",
    unit: "FleetBeacon",
  },
  co_FenixKaldalisZealotDownloadUpgrade: {
    name: "Download Kaldalis’ A.I. Personality",
    category: "unit",
    key: "FenixKaldalisZealotDownloadUpgrade",
  },
  co_FenixTalisAdeptDownloadUpgrade: {
    name: "Download Talis’ A.I. Personality",
    category: "unit",
    key: "FenixTalisAdeptDownloadUpgrade",
  },
  co_FenixTaldarinImmortalDownloadUpgrade: {
    name: "Download Taldarin’s A.I. Personality",
    category: "unit",
    key: "FenixTaldarinImmortalDownloadUpgrade",
  },
  co_FenixWarbringerColossusDownloadUpgrade: {
    name: "Download Warbringer’s A.I. Personality",
    category: "unit",
    key: "FenixWarbringerColossusDownloadUpgrade",
  },
  co_FenixMojoScoutDownloadUpgrade: {
    name: "Download Mojo’s A.I. Personality",
    category: "unit",
    key: "FenixMojoScoutDownloadUpgrade",
  },
  co_FenixClolarionCarrierDownloadUpgrade: {
    name: "Download Clolarion’s A.I. Personality",
    category: "unit",
    key: "FenixClolarionCarrierDownloadUpgrade",
  },
  co_BrokenFenixAltarOfPsiStorms_FenixAltarOfPsiStorms: {
    name: "Repairing",
    category: "unit",
    key: "BrokenFenixAltarOfPsiStorms",
    unit: "FenixAltarOfPsiStorms",
  },
  co_ZeratulBlink_ZeratulCoop: {
    name: "Blink",
    category: "ability",
    key: "ZeratulBlink",
    unit: "ZeratulCoop",
  },
  co_ZeratulSummonVoidSeeker_ZeratulCoop: {
    name: "Summon Void Seeker",
    category: "ability",
    key: "ZeratulSummonVoidSeeker",
    unit: "ZeratulCoop",
  },
  co_ZeratulShadowCleave_ZeratulCoop: {
    name: "Shadow Cleave",
    category: "ability",
    key: "ZeratulShadowCleave",
    unit: "ZeratulCoop",
  },
  co_ProphecyVision_ZeratulCoop: {
    name: "Prophetic Vision",
    category: "ability",
    key: "ProphecyVision",
    unit: "ZeratulCoop",
  },
  co_ProtossBuild_Probe_Zeratul: {
    name: "Warp In",
    category: "command",
    key: "ProtossBuild",
    unit: "Probe",
    opens: "probe_build0",
  },
  co_ProtossBuildAdvanced_Probe_Zeratul: {
    name: "Warp In Adv.",
    category: "command",
    key: "ProtossBuildAdvanced",
    unit: "Probe",
    opens: "probe_build1",
  },
  co_Blink_ZeratulStalker: {
    name: "Predictive Blink",
    category: "ability",
    key: "Blink",
    unit: "ZeratulStalker",
  },
  co_VoidSentryShieldRepair_ZeratulSentry: {
    name: "Shield Recharge",
    category: "ability",
    key: "VoidSentryShieldRepair",
    unit: "ZeratulSentry",
  },
  co_ZeratulReflectionShield_ZeratulSentry: {
    name: "Reflection Shield",
    category: "ability",
    key: "ZeratulReflectionShield",
    unit: "ZeratulSentry",
  },
  co_Blink_ZeratulDarkTemplar: {
    name: "Blink",
    category: "ability",
    key: "Blink",
    unit: "ZeratulDarkTemplar",
  },
  co_ImmortalOverload_ZeratulImmortal: {
    name: "Barrier",
    category: "ability",
    key: "ImmortalOverload",
    unit: "ZeratulImmortal",
  },
  co_MorphtoObserverSiege_ZeratulObserver: {
    name: "Surveillance Mode",
    category: "ability",
    key: "MorphtoObserverSiege",
    unit: "ZeratulObserver",
  },
  co_MorphtoObserver_ZeratulObserver: {
    name: "Observer Mode",
    category: "ability",
    key: "MorphtoObserver",
    unit: "ZeratulObserver",
  },
  co_ZeratulPurificationNovaTargeted_ZeratulDisruptor: {
    name: "Purification Nova",
    category: "ability",
    key: "ZeratulPurificationNovaTargeted",
    unit: "ZeratulDisruptor",
  },
  co_PhasingMode_ZeratulWarpPrism: {
    name: "Wormhole Mode",
    category: "ability",
    key: "PhasingMode",
    unit: "ZeratulWarpPrism",
  },
  co_ZeratulWarpPrismSelectVoidRift: {
    name: "Select Wormhole Exit",
    category: "ability",
    key: "ZeratulWarpPrismSelectVoidRift",
  },
  co_TransportMode_ZeratulWarpPrismPhasing: {
    name: "Flight Mode",
    category: "ability",
    key: "TransportMode",
    unit: "ZeratulWarpPrismPhasing",
  },
  co_ZeratulWarpPrismSelectVoidRift_2: {
    name: "Select Wormhole Exit",
    category: "ability",
    key: "ZeratulWarpPrismSelectVoidRift",
  },
  co_WarpPrismLoad: { name: "Load", category: "ability", key: "WarpPrismLoad" },
  co_ZeratulWarpPrismUnload_ZeratulWarpPrismPhasing: {
    name: "Unload",
    category: "ability",
    key: "ZeratulWarpPrismUnload",
    unit: "ZeratulWarpPrismPhasing",
  },
  co_ZeratulWarpPrismAutoUnloadOn_ZeratulWarpPrismPhasing: {
    name: "Auto-Unload On",
    category: "ability",
    key: "ZeratulWarpPrismAutoUnloadOn",
    unit: "ZeratulWarpPrismPhasing",
  },
  co_ZeratulWarpPrismAutoUnloadOff_ZeratulWarpPrismPhasing: {
    name: "Auto-Unload Off",
    category: "ability",
    key: "ZeratulWarpPrismAutoUnloadOff",
    unit: "ZeratulWarpPrismPhasing",
  },
  co_EntropicBlast_ZeratulXelNagaConstructCyan: {
    name: "Entropic Blast",
    category: "ability",
    key: "EntropicBlast",
    unit: "ZeratulXelNagaConstructCyan",
  },
  co_ZeratulXelNagaConstructPsiStorm_ZeratulXelNagaConstructCyan: {
    name: "Psionic Gale",
    category: "ability",
    key: "ZeratulXelNagaConstructPsiStorm",
    unit: "ZeratulXelNagaConstructCyan",
  },
  co_ZeratulXelNagaConstructPsiBlast_ZeratulXelNagaConstructCyan: {
    name: "Psionic Blast",
    category: "ability",
    key: "ZeratulXelNagaConstructPsiBlast",
    unit: "ZeratulXelNagaConstructCyan",
  },
  co_ZeratulXelNagaConstructDevolve_ZeratulXelNagaConstruct: {
    name: "Devolution Wave",
    category: "ability",
    key: "ZeratulXelNagaConstructDevolve",
    unit: "ZeratulXelNagaConstruct",
  },
  co_Charge_ZeratulSummonZealot: {
    name: "Charge",
    category: "ability",
    key: "Charge",
    unit: "ZeratulSummonZealot",
  },
  co_VoidZealotWhirlwind_ZeratulSummonZealot: {
    name: "Whirlwind",
    category: "ability",
    key: "VoidZealotWhirlwind",
    unit: "ZeratulSummonZealot",
  },
  co_Feedback_ZeratulSummonKarass: {
    name: "Feedback",
    category: "ability",
    key: "Feedback",
    unit: "ZeratulSummonKarass",
  },
  co_PsiStormTelbrus_ZeratulSummonKarass: {
    name: "Psionic Storm",
    category: "ability",
    key: "PsiStormTelbrus",
    unit: "ZeratulSummonKarass",
  },
  co_ZeratulDarkArchonMaelstrom_ZeratulDarkArchon: {
    name: "Maelstrom",
    category: "ability",
    key: "ZeratulDarkArchonMaelstrom",
    unit: "ZeratulDarkArchon",
  },
  co_ZeratulDarkArchonMindControl_ZeratulDarkArchon: {
    name: "Mind Control",
    category: "ability",
    key: "ZeratulDarkArchonMindControl",
    unit: "ZeratulDarkArchon",
  },
  co_ZeratulDarkArchonMaelstrom_ZeratulHeroDarkArchon: {
    name: "Maelstrom",
    category: "ability",
    key: "ZeratulDarkArchonMaelstrom",
    unit: "ZeratulHeroDarkArchon",
  },
  co_ZeratulDarkArchonMindControl_ZeratulHeroDarkArchon: {
    name: "Mind Control",
    category: "ability",
    key: "ZeratulDarkArchonMindControl",
    unit: "ZeratulHeroDarkArchon",
  },
  co_TimeWarp_Nexus_6: {
    name: "Chrono Boost",
    category: "ability",
    key: "TimeWarp",
    unit: "Nexus",
  },
  co_StalkerZeratul_ZeratulGateway: {
    name: "Xel’Naga Ambusher",
    category: "unit",
    key: "StalkerZeratul",
    unit: "ZeratulGateway",
  },
  co_SentryZeratul_ZeratulGateway: {
    name: "Xel’Naga Shieldguard",
    category: "unit",
    key: "SentryZeratul",
    unit: "ZeratulGateway",
  },
  co_DarkTemplarZeratul_ZeratulGateway: {
    name: "Void Templar",
    category: "unit",
    key: "DarkTemplarZeratul",
    unit: "ZeratulGateway",
  },
  co_ZeratulPhaseCannonProjectionPassive_ZeratulPhotonCannon: {
    name: "Shade Projection",
    category: "unit",
    key: "ZeratulPhaseCannonProjectionPassive",
    unit: "ZeratulPhotonCannon",
  },
  co_ZeratulStructureBarrier_ZeratulPhotonCannon: {
    name: "Shade Barrier",
    category: "unit",
    key: "ZeratulStructureBarrier",
    unit: "ZeratulPhotonCannon",
  },
  co_ZeratulKhaydarinMonolithWarp_ZeratulKhaydarinMonolith: {
    name: "Shade Projection",
    category: "unit",
    key: "ZeratulKhaydarinMonolithWarp",
    unit: "ZeratulKhaydarinMonolith",
  },
  co_ZeratulStructureBarrier_ZeratulKhaydarinMonolith: {
    name: "Shade Barrier",
    category: "unit",
    key: "ZeratulStructureBarrier",
    unit: "ZeratulKhaydarinMonolith",
  },
  co_ImmortalZeratul_ZeratulRoboticsFacility: {
    name: "Xel’Naga Enforcer",
    category: "unit",
    key: "ImmortalZeratul",
    unit: "ZeratulRoboticsFacility",
  },
  co_ZeratulWarpinDisruptor_ZeratulRoboticsFacility: {
    name: "Xel’Naga Abrogator",
    category: "unit",
    key: "ZeratulWarpinDisruptor",
    unit: "ZeratulRoboticsFacility",
  },
  co_WarpInZeratulWarpPrism_ZeratulRoboticsFacility: {
    name: "Xel’Naga Void Array",
    category: "unit",
    key: "WarpInZeratulWarpPrism",
    unit: "ZeratulRoboticsFacility",
  },
  co_ZeratulObserver_ZeratulRoboticsFacility: {
    name: "Xel’Naga Watcher",
    category: "unit",
    key: "ZeratulObserver",
    unit: "ZeratulRoboticsFacility",
  },
};

export const COOP_ROSTERS: Record<string, SC2Roster> = {
  raynor: {
    label: "Raynor",
    race: "terran",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "scv",
        cluster: "basic",
        cancel: true,
        label: "SCV",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_TerranBuild_SCV_Raynor",
          "co_TerranBuildAdvanced_SCV_Raynor",
          "repair",
          "spray",
          "tHalt",
        ],
      },
      {
        id: "scv_build0",
        cancel: true,
        label: "Build Structure",
        kind: "building",
        parent: "scv",
        card: ["bCmdCtr", "bRef", "co_SupplyDepot_SCV", "bRax", "bEbay", "bBunker", "bMissile"],
      },
      {
        id: "scv_build1",
        cancel: true,
        label: "Build Advanced Structure",
        kind: "building",
        parent: "scv",
        card: ["bFactory", "bArmory", "bStarport", "bFusion"],
      },
      {
        id: "mule",
        cluster: "flying",
        label: "MULE",
        kind: "unit",
        card: ["gatherProt", "returnCargo", "repair"],
      },
      { id: "marine", cluster: "basic", label: "Marine", kind: "unit", card: ["tStim"] },
      { id: "firebat", cluster: "basic", label: "Firebat", kind: "unit", card: ["tStim"] },
      { id: "medic", cluster: "flying", label: "Medic", kind: "unit", card: ["heal"] },
      { id: "marauder", cluster: "basic", label: "Marauder", kind: "unit", card: ["tStim"] },
      {
        id: "vulture",
        cluster: "basic",
        cancel: true,
        label: "Vulture",
        kind: "unit",
        card: [
          "co_SpiderMine_Vulture",
          "co_SpiderMineReplenish_Vulture",
          "co_IgniteAfterburners_Vulture",
        ],
      },
      {
        id: "siegetank",
        cluster: "basic",
        label: "Siege Tank",
        kind: "unit",
        card: ["tSiegeMode", "tUnsiege", "co_IgniteAfterburners_SiegeTank"],
      },
      {
        id: "viking",
        cluster: "basic",
        label: "Viking",
        kind: "unit",
        card: ["tAssaultMode", "tFighterMode", "co_IgniteAfterburners_VikingAssault"],
      },
      {
        id: "banshee",
        cluster: "basic",
        label: "Banshee",
        kind: "unit",
        card: ["tCloakOnBanshee", "tCloakOff", "co_IgniteAfterburners_Banshee"],
      },
      {
        id: "battlecruiser",
        cluster: "basic",
        label: "Battlecruiser",
        kind: "unit",
        card: ["tYamatoGun", "tHyperjumpBattlecruiser", "co_IgniteAfterburners_Battlecruiser"],
      },
      {
        id: "hyperion",
        cluster: "basic",
        label: "Hyperion",
        kind: "unit",
        card: [
          "co_HyperionVoidCoopHyperjump_HyperionVoidCoop",
          "co_HyperionVoidCoopYamatoCannon_HyperionVoidCoop",
          "co_HyperionAdvancedPDD_HyperionVoidCoop",
        ],
      },
      {
        id: "duskwings",
        label: "Dusk Wings",
        kind: "unit",
        card: ["tCloakOnBanshee", "tCloakOff"],
      },
      {
        id: "commandcenter",
        cancel: true,
        label: "Command Center",
        kind: "building",
        card: [
          "tScv",
          "co_OrbitalCommand_CommandCenter_commandcenterorbitalcommand",
          "tSelectBuilder",
          "tRally",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "co_Lift_commandcenterflying",
        ],
      },
      {
        id: "commandcenter_orbitalcommand",
        cancel: true,
        label: "Orbital Command",
        kind: "building",
        parent: "commandcenter",
        card: ["tScv", "tRally", "tCalldownMULEOrbitalCommand", "tScanOrbitalCommand", "lift"],
      },
      {
        id: "commandcenter_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "commandcenter",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "co_Land",
        ],
      },
      {
        id: "refinery",
        cancel: true,
        label: "Refinery",
        kind: "building",
        card: ["tSelectBuilder", "tHalt"],
      },
      {
        id: "supplydepot",
        cancel: true,
        label: "Supply Depot",
        kind: "building",
        card: ["tSelectBuilder", "co_Lower_SupplyDepot_supplydepotlowered", "tHalt"],
      },
      {
        id: "supplydepot_lowered",
        cancel: true,
        label: "Lowered",
        kind: "building",
        parent: "supplydepot",
        card: ["co_Raise_SupplyDepotLowered"],
      },
      {
        id: "barracks",
        cancel: true,
        label: "Barracks",
        kind: "building",
        card: [
          "tMarine",
          "tMaraud",
          "co_Firebat_Barracks",
          "co_Medic_Barracks",
          "tSelectBuilder",
          "tRally",
          "tTechLabBarracks",
          "aReactor",
          "co_Lift_barracksflying",
        ],
      },
      {
        id: "barracks_techlab",
        cancel: true,
        label: "Barracks: Tech Lab",
        kind: "building",
        card: [
          "tResearchShieldWallBarracksTec",
          "tStimpackBarracksTechLab",
          "tResearchPunisherGrenadesBarra",
          "co_ResearchIncineratorGauntlets_BarracksTechLab",
          "co_ResearchJuggernautPlating_BarracksTechLab",
        ],
      },
      {
        id: "barracks_techreactor",
        cancel: true,
        label: "Barracks: Tech Reactor",
        kind: "building",
        card: [
          "co_ResearchShieldWall_BarracksTechReactor",
          "co_Stimpack_BarracksTechReactor",
          "co_ResearchPunisherGrenades_BarracksTechReactor",
          "co_ResearchIncineratorGauntlets_BarracksTechReactor",
          "co_ResearchJuggernautPlating_BarracksTechReactor",
        ],
      },
      {
        id: "barracks_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "barracks",
        card: ["move", "stop", "hold", "patrol", "tTechLabBarracks", "aReactor", "co_Land_2"],
      },
      {
        id: "engineeringbay",
        cancel: true,
        label: "Engineering Bay",
        kind: "building",
        card: [
          "tTerranInfantryWeaponsLevel1En",
          "tTerranInfantryArmorLevel1Engi",
          "co_ResearchNeosteelFrame_EngineeringBay",
          "tUpgradeBuildingArmorLevel1Eng",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "bunker",
        cancel: true,
        label: "Bunker",
        kind: "building",
        card: [
          "stop",
          "attack",
          "tSelectBuilder",
          "tRally",
          "tStim",
          "tBunkerLoad",
          "tBunkerUnloadAll",
          "tSalvageBunker",
        ],
      },
      {
        id: "missileturret",
        cluster: "tower",
        cancel: true,
        label: "Missile Turret",
        kind: "building",
        card: ["stop", "attack", "tSelectBuilder", "co_Salvage_MissileTurret", "tHalt"],
      },
      {
        id: "factory",
        cancel: true,
        label: "Factory",
        kind: "building",
        card: [
          "tHellionTankFactory",
          "tSiegeTankFactory",
          "tSelectBuilder",
          "tRally",
          "tTechLabFactory",
          "tReactorFactory",
          "co_Lift_factoryflying",
        ],
      },
      {
        id: "factory_techlab",
        cancel: true,
        label: "Factory: Tech Lab",
        kind: "building",
        card: [
          "tResearchHighCapacityBarrelsFa",
          "co_ResearchHellbatHellArmor_FactoryTechLab",
          "co_ResearchImprovedSiegeMode_FactoryTechLab",
        ],
      },
      {
        id: "factory_techreactor",
        cancel: true,
        label: "Factory: Tech Reactor",
        kind: "building",
        card: [
          "co_ResearchHighCapacityBarrels_FactoryTechReactor",
          "co_ResearchHellbatHellArmor_FactoryTechReactor",
          "co_ResearchImprovedSiegeMode_FactoryTechReactor",
        ],
      },
      {
        id: "factory_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "factory",
        card: ["move", "stop", "hold", "patrol", "tTechLabFactory", "tReactorFactory", "co_Land_3"],
      },
      {
        id: "armory",
        cancel: true,
        label: "Armory",
        kind: "building",
        card: [
          "co_TerranVehicleAndShipWeaponsLevel1_Armory",
          "tTerranVehicleAndShipPlatingLe",
          "co_ResearchVehicleWeaponRange_Armory",
          "co_ResearchRegenerativeBioSteel_Armory",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "starport",
        cancel: true,
        label: "Starport",
        kind: "building",
        card: [
          "tVikingFighterStarport",
          "tBansheeStarport",
          "tBattlecruiserStarport",
          "tSelectBuilder",
          "tRally",
          "tTechLabStarport",
          "tReactorStarport",
          "co_Lift_starportflying",
        ],
      },
      {
        id: "starport_techlab",
        cancel: true,
        label: "Starport: Tech Lab",
        kind: "building",
        card: [
          "tResearchBansheeCloakStarportT",
          "co_ResearchShockwaveMissileBattery_StarportTechLab",
          "co_ResearchPhobosClassWeaponsSystem_StarportTechLab",
          "co_ResearchRipwaveMissiles_StarportTechLab",
        ],
      },
      {
        id: "starport_techreactor",
        cancel: true,
        label: "Starport: Tech Reactor",
        kind: "building",
        card: [
          "co_ResearchBansheeCloak_StarportTechReactor",
          "co_ResearchShockwaveMissileBattery_StarportTechReactor",
          "co_ResearchPhobosClassWeaponsSystem_StarportTechReactor",
          "co_ResearchRipwaveMissiles_StarportTechReactor",
        ],
      },
      {
        id: "starport_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "starport",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "tTechLabStarport",
          "tReactorStarport",
          "co_Land_4",
        ],
      },
      {
        id: "fusioncore",
        cancel: true,
        label: "Fusion Core",
        kind: "building",
        card: ["tResearchBattlecruiserSpeciali", "tSelectBuilder", "tHalt"],
      },
    ],
  },
  swann: {
    label: "Swann",
    race: "terran",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "scv",
        cluster: "basic",
        cancel: true,
        label: "SCV",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_AdvancedConstructionAuto_SCV",
          "co_TerranBuild_SCV_Swann",
          "co_TerranBuildAdvanced_SCV_Swann",
          "repair",
          "spray",
          "tHalt",
        ],
      },
      {
        id: "scv_build0",
        cancel: true,
        label: "Build Structure",
        kind: "building",
        parent: "scv",
        card: [
          "bCmdCtr",
          "bRef",
          "co_SupplyDepot_SCV_2",
          "bEbay",
          "bBunker",
          "bMissile",
          "co_BuildKelMorianRocketTurret_SCV",
        ],
      },
      {
        id: "scv_build1",
        cancel: true,
        label: "Build Advanced Structure",
        kind: "building",
        parent: "scv",
        card: ["bFactory", "bArmory", "bStarport"],
      },
      {
        id: "hellbat",
        cluster: "basic",
        label: "Hellbat",
        kind: "unit",
        card: ["tMorphToHellion", "tMorphToHellionTank"],
      },
      {
        id: "siegetank",
        cluster: "basic",
        label: "Siege Tank",
        kind: "unit",
        card: ["tSiegeMode", "tUnsiege", "co_SwannCommanderRebuild"],
      },
      { id: "cyclone", cluster: "basic", label: "Cyclone", kind: "unit", card: ["tLockOnCyclone"] },
      {
        id: "thor",
        cluster: "basic",
        cancel: true,
        label: "Thor",
        kind: "unit",
        card: ["co_250mmStrikeCannons_Thor", "co_SwannCommanderRebuild_2"],
      },
      {
        id: "wraith",
        cluster: "basic",
        label: "Wraith",
        kind: "unit",
        card: ["co_WraithCloakOn_Wraith", "co_WraithCloakOff_Wraith"],
      },
      {
        id: "hercules",
        cluster: "flying",
        label: "Hercules",
        kind: "unit",
        card: [
          "co_HerculesLoad_Hercules",
          "co_HerculesUnloadAll_Hercules",
          "co_HyperjumpHercules_Hercules",
        ],
      },
      {
        id: "sciencevessel",
        cluster: "flying",
        label: "Science Vessel",
        kind: "unit",
        card: [
          "co_NanoRepair_ScienceVessel",
          "co_Irradiate_ScienceVessel",
          "co_DefensiveMatrixTarget_ScienceVessel",
          "co_FleetwideJump_ScienceVessel",
        ],
      },
      {
        id: "commandcenter",
        cancel: true,
        label: "Command Center",
        kind: "building",
        card: [
          "tScv",
          "co_VespeneDrone_CommandCenter",
          "tSelectBuilder",
          "tRally",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "co_Lift_commandcenterflying_2",
        ],
      },
      {
        id: "commandcenter_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "commandcenter",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "co_Land_5",
        ],
      },
      {
        id: "refinery",
        cancel: true,
        label: "Refinery",
        kind: "building",
        card: ["tSelectBuilder", "tHalt"],
      },
      {
        id: "supplydepot",
        cancel: true,
        label: "Supply Depot",
        kind: "building",
        card: ["tSelectBuilder", "co_Lower_SupplyDepot_supplydepotlowered_2", "tHalt"],
      },
      {
        id: "supplydepot_lowered",
        cancel: true,
        label: "Lowered",
        kind: "building",
        parent: "supplydepot",
        card: ["co_Raise_SupplyDepotLowered_2"],
      },
      {
        id: "engineeringbay",
        cancel: true,
        label: "Engineering Bay",
        kind: "building",
        card: [
          "co_ResearchNeosteelFrame_EngineeringBay_2",
          "tUpgradeBuildingArmorLevel1Eng",
          "co_ResearchFireSuppressionSystems_EngineeringBay",
          "co_ResearchImprovedTurretAttackSpeed_EngineeringBay",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "perditionturret",
        cluster: "tower",
        cancel: true,
        label: "Perdition Turret",
        kind: "building",
        card: ["stop", "attack", "tSelectBuilder", "co_Salvage_PerditionTurret", "tHalt"],
      },
      {
        id: "devastationturret",
        cluster: "tower",
        cancel: true,
        label: "Devastation Turret",
        kind: "building",
        card: ["stop", "attack", "tSelectBuilder", "co_Salvage_KelMorianGrenadeTurret", "tHalt"],
      },
      {
        id: "missileturret",
        cluster: "tower",
        cancel: true,
        label: "Missile Turret",
        kind: "building",
        card: ["stop", "attack", "tSelectBuilder", "co_Salvage_KelMorianMissileTurret", "tHalt"],
      },
      {
        id: "factory",
        cancel: true,
        label: "Factory",
        kind: "building",
        card: [
          "tHellionTankFactory",
          "co_Goliath_Factory",
          "tSiegeTankFactory",
          "tBuildCycloneFactory",
          "tThorFactory",
          "tHellionFactory",
          "tSelectBuilder",
          "tRally",
          "tTechLabFactory",
          "co_Lift_factoryflying_2",
        ],
      },
      {
        id: "factory_techlab",
        cancel: true,
        label: "Factory: Tech Lab",
        kind: "building",
        card: [
          "tResearchHighCapacityBarrelsFa",
          "co_ResearchHellbatHellArmor_FactoryTechLab_2",
          "co_ResearchImprovedSiegeMode_FactoryTechLab_2",
          "co_ResearchMultiLockWeaponsSystem_FactoryTechLab",
          "co_ResearchMaelstromRounds_FactoryTechLab",
          "co_ResearchLockOnRangeUpgrade_FactoryTechLab",
          "co_ResearchCycloneLockOnDamageUpgrade_FactoryTechLab",
          "co_Research330mmBarrageCannon_FactoryTechLab",
        ],
      },
      {
        id: "factory_techreactor",
        cancel: true,
        label: "Factory: Tech Reactor",
        kind: "building",
        card: [
          "co_ResearchHighCapacityBarrels_FactoryTechReactor_2",
          "co_ResearchHellbatHellArmor_FactoryTechReactor_2",
          "co_ResearchImprovedSiegeMode_FactoryTechReactor_2",
          "co_ResearchMultiLockWeaponsSystem_FactoryTechReactor",
          "co_ResearchMaelstromRounds_FactoryTechReactor",
          "co_ResearchLockOnRangeUpgrade_FactoryTechReactor",
          "co_ResearchCycloneLockOnDamageUpgrade_FactoryTechReactor",
          "co_Research330mmBarrageCannon_FactoryTechReactor",
        ],
      },
      {
        id: "factory_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "factory",
        card: ["move", "stop", "hold", "patrol", "tTechLabFactory", "co_Land_6"],
      },
      {
        id: "armory",
        cancel: true,
        label: "Armory",
        kind: "building",
        card: [
          "co_TerranVehicleAndShipWeaponsLevel1_Armory_2",
          "tTerranVehicleAndShipPlatingLe",
          "co_ResearchVehicleWeaponRange_Armory_2",
          "co_ResearchRegenerativeBioSteel_Armory_2",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "starport",
        cancel: true,
        label: "Starport",
        kind: "building",
        card: [
          "co_Wraith_Starport",
          "co_BuildHercules_Starport",
          "co_BuildScienceVessel_Starport",
          "tSelectBuilder",
          "tRally",
          "tTechLabStarport",
          "co_Lift_starportflying_2",
        ],
      },
      {
        id: "starport_techlab",
        cancel: true,
        label: "Starport: Tech Lab",
        kind: "building",
        card: [
          "tResearchBansheeCloakStarportT",
          "co_ResearchShockwaveMissileBattery_StarportTechLab_2",
          "co_ResearchPhobosClassWeaponsSystem_StarportTechLab_2",
          "co_ResearchRipwaveMissiles_StarportTechLab_2",
        ],
      },
      {
        id: "starport_techreactor",
        cancel: true,
        label: "Starport: Tech Reactor",
        kind: "building",
        card: [
          "co_ResearchBansheeCloak_StarportTechReactor_2",
          "co_ResearchShockwaveMissileBattery_StarportTechReactor_2",
          "co_ResearchPhobosClassWeaponsSystem_StarportTechReactor_2",
          "co_ResearchRipwaveMissiles_StarportTechReactor_2",
        ],
      },
      {
        id: "starport_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "starport",
        card: ["move", "stop", "hold", "patrol", "tTechLabStarport", "co_Land_7"],
      },
      {
        id: "laserdrill",
        cancel: true,
        label: "Drakken Laser Drill",
        kind: "building",
        card: ["attack", "co_ResearchDrakkenLaserDrillBFG_DrakkenLaserDrillCoop"],
      },
    ],
  },
  nova: {
    label: "Nova",
    race: "terran",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "nova",
        cluster: "basic",
        cancel: true,
        label: "Nova",
        kind: "unit",
        card: [
          "co_GhostHoldFire_NovaCoop",
          "co_WeaponsFree_NovaCoop",
          "co_NovaWeaponImprovedCanisterRifleSnipe",
          "co_NovaGadgetBoombots",
          "co_NovaUnitNuke",
          "co_NovaSwitchAssaultMode",
        ],
      },
      {
        id: "nova_novasstasisshell",
        cluster: "basic",
        cancel: true,
        label: "Nova: Nova’s Stasis Shell",
        kind: "unit",
        card: [
          "co_NovaWeaponImprovedCanisterRifleSnipe_2",
          "co_NovaGadgetBoombots_2",
          "co_NovaUnitNuke_2",
          "co_NovaSwitchAssaultMode_2",
          "tRally",
        ],
      },
      {
        id: "scv",
        cluster: "basic",
        cancel: true,
        label: "SCV",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_TerranBuild_SCV_Nova",
          "co_TerranBuildAdvanced_SCV_Nova",
          "repair",
          "spray",
          "tHalt",
        ],
      },
      {
        id: "scv_build0",
        cancel: true,
        label: "Build Structure",
        kind: "building",
        parent: "scv",
        card: ["bCmdCtr", "bRef", "bRax", "bEbay", "bBunker", "bMissile"],
      },
      {
        id: "scv_build1",
        cancel: true,
        label: "Build Advanced Structure",
        kind: "building",
        parent: "scv",
        card: ["bGhostAcad", "bFactory", "bArmory", "bStarport"],
      },
      {
        id: "marine",
        cluster: "basic",
        label: "Elite Marine",
        kind: "unit",
        card: ["co_MarineSuperStimpack_MarineBlackOps"],
      },
      {
        id: "marauder",
        cluster: "basic",
        label: "Marauder Commando",
        kind: "unit",
        card: ["co_MagrailMunitions_MarauderBlackOps"],
      },
      {
        id: "ghost",
        cluster: "basic",
        cancel: true,
        label: "Spec Ops Ghost",
        kind: "unit",
        card: [
          "co_GhostHoldFire_GhostBlackOps",
          "co_WeaponsFree_GhostBlackOps",
          "co_SnipeBlackOps_GhostBlackOps",
          "co_EMP_GhostBlackOps",
        ],
      },
      {
        id: "hellbat",
        cluster: "basic",
        label: "Hellbat Ranger",
        kind: "unit",
        card: [
          "co_MorphToHellion_HellionBlackOps",
          "co_MorphToHellbatBlackOps_HellionBlackOps",
          "co_HellbatJumpJetAssault_HellionBlackOps",
        ],
      },
      {
        id: "siegetank",
        cluster: "basic",
        label: "Heavy Siege Tank",
        kind: "unit",
        card: [
          "co_SiegeTankBlackOpsSiege",
          "co_SiegeTankBlackOpsUnsiege",
          "co_DeploySpiderMines_SiegeTankBlackOps",
        ],
      },
      {
        id: "liberator",
        cluster: "basic",
        label: "Raid Liberator",
        kind: "unit",
        card: [
          "co_LiberatorBlackOpsMorphtoAG_LiberatorBlackOps",
          "co_LiberatorBlackOpsMorphtoAA_LiberatorBlackOps",
        ],
      },
      {
        id: "raven",
        cluster: "flying",
        label: "Raven Type-II",
        kind: "unit",
        card: [
          "co_AutoTurret_RavenBlackOps",
          "co_PointDefenseDrone_RavenBlackOps",
          "co_InstantHunterSeekerMissile_RavenBlackOps",
        ],
      },
      {
        id: "banshee",
        cluster: "basic",
        label: "Covert Banshee",
        kind: "unit",
        card: ["co_BansheeBlackOpsAirstrike_BansheeBlackOps"],
      },
      {
        id: "defensivedrone",
        label: "Defensive Drone",
        kind: "unit",
        card: ["co_DefensiveMatrixTarget_NovaDefensiveMatrixDrone"],
      },
      {
        id: "sabotagedrone",
        label: "Sabotage Drone",
        kind: "unit",
        card: ["co_NovaBoombotBurrow_NovaBoombot"],
      },
      {
        id: "repairdrone",
        label: "Bio-Mechanical Repair Drone",
        kind: "unit",
        card: ["co_BioMechanicalHeal_HealingDrone"],
      },
      {
        id: "commandcenter",
        cancel: true,
        label: "Command Center",
        kind: "building",
        card: [
          "tScv",
          "tSelectBuilder",
          "tRally",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "co_Lift_commandcenterflying_3",
        ],
      },
      {
        id: "commandcenter_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "commandcenter",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "co_Land_8",
        ],
      },
      {
        id: "refinery",
        cancel: true,
        label: "Automated Refinery",
        kind: "building",
        card: ["tSelectBuilder", "tHalt"],
      },
      {
        id: "barracks",
        cancel: true,
        label: "Barracks",
        kind: "building",
        card: [
          "tMarine",
          "tMaraud",
          "co_Firebat_Barracks_2",
          "tSelectBuilder",
          "tTechLabBarracks",
          "co_Lift_barracksflying_2",
        ],
      },
      {
        id: "barracks_techlab",
        cancel: true,
        label: "Barracks: Tech Lab",
        kind: "building",
        card: [
          "tResearchShieldWallBarracksTec",
          "tStimpackBarracksTechLab",
          "tResearchPunisherGrenadesBarra",
          "co_ResearchMarauderMagrailMunitions_BarracksTechLab",
          "co_ResearchIncineratorGauntlets_BarracksTechLab_2",
          "co_ResearchJuggernautPlating_BarracksTechLab_2",
        ],
      },
      {
        id: "barracks_techreactor",
        cancel: true,
        label: "Barracks: Tech Reactor",
        kind: "building",
        card: [
          "co_ResearchShieldWall_BarracksTechReactor_2",
          "co_Stimpack_BarracksTechReactor_2",
          "co_ResearchPunisherGrenades_BarracksTechReactor_2",
          "co_ResearchMarauderMagrailMunitions_BarracksTechReactor",
          "co_ResearchIncineratorGauntlets_BarracksTechReactor_2",
          "co_ResearchJuggernautPlating_BarracksTechReactor_2",
        ],
      },
      {
        id: "barracks_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "barracks",
        card: ["move", "stop", "hold", "patrol", "tTechLabBarracks", "co_Land_9"],
      },
      {
        id: "engineeringbay",
        cancel: true,
        label: "Engineering Bay",
        kind: "building",
        card: [
          "tTerranInfantryWeaponsLevel1En",
          "tTerranInfantryArmorLevel1Engi",
          "tUpgradeBuildingArmorLevel1Eng",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "railgunturret",
        cluster: "tower",
        cancel: true,
        label: "Railgun Turret",
        kind: "building",
        card: ["stop", "attack", "tSelectBuilder", "co_Salvage_NovaACLaserTurret", "tHalt"],
      },
      {
        id: "missileturret",
        cluster: "tower",
        cancel: true,
        label: "Missile Turret",
        kind: "building",
        card: ["stop", "attack", "tSelectBuilder", "co_Salvage_MissileTurret_2", "tHalt"],
      },
      {
        id: "factory",
        cancel: true,
        label: "Factory",
        kind: "building",
        card: [
          "tHellionTankFactory",
          "co_Goliath_Factory_2",
          "tSiegeTankFactory",
          "tSelectBuilder",
          "tTechLabFactory",
          "co_Lift_factoryflying_3",
        ],
      },
      {
        id: "factory_techlab",
        cancel: true,
        label: "Factory: Tech Lab",
        kind: "building",
        card: [
          "tResearchHighCapacityBarrelsFa",
          "co_ResearchHellbatHellArmor_FactoryTechLab_3",
          "co_ResearchImprovedSiegeMode_FactoryTechLab_3",
          "co_ResearchMultiLockWeaponsSystem_FactoryTechLab_2",
          "co_ResearchMaelstromRounds_FactoryTechLab_2",
          "co_ResearchLockOnRangeUpgrade_FactoryTechLab_2",
        ],
      },
      {
        id: "factory_techreactor",
        cancel: true,
        label: "Factory: Tech Reactor",
        kind: "building",
        card: [
          "co_ResearchHighCapacityBarrels_FactoryTechReactor_3",
          "co_ResearchHellbatHellArmor_FactoryTechReactor_3",
          "co_ResearchImprovedSiegeMode_FactoryTechReactor_3",
          "co_ResearchMultiLockWeaponsSystem_FactoryTechReactor_2",
          "co_ResearchMaelstromRounds_FactoryTechReactor_2",
          "co_ResearchLockOnRangeUpgrade_FactoryTechReactor_2",
        ],
      },
      {
        id: "factory_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "factory",
        card: ["move", "stop", "hold", "patrol", "tTechLabFactory", "co_Land_10"],
      },
      {
        id: "armory",
        cancel: true,
        label: "Armory",
        kind: "building",
        card: [
          "co_TerranVehicleAndShipWeaponsLevel1_Armory_3",
          "tTerranVehicleAndShipPlatingLe",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "starport",
        cancel: true,
        label: "Starport",
        kind: "building",
        card: [
          "tLiberatorStarport",
          "tBansheeStarport",
          "tRavenStarport",
          "tSelectBuilder",
          "tTechLabStarport",
          "co_Lift_starportflying_3",
        ],
      },
      {
        id: "starport_techlab",
        cancel: true,
        label: "Starport: Tech Lab",
        kind: "building",
        card: [
          "tResearchBansheeCloakStarportT",
          "co_ResearchShockwaveMissileBattery_StarportTechLab_3",
          "co_ResearchPhobosClassWeaponsSystem_StarportTechLab_3",
          "co_ResearchRipwaveMissiles_StarportTechLab_3",
          "co_ResearchMedivacCloakedHealBeam_StarportTechLab",
        ],
      },
      {
        id: "starport_techreactor",
        cancel: true,
        label: "Starport: Tech Reactor",
        kind: "building",
        card: [
          "co_ResearchBansheeCloak_StarportTechReactor_3",
          "co_ResearchShockwaveMissileBattery_StarportTechReactor_3",
          "co_ResearchPhobosClassWeaponsSystem_StarportTechReactor_3",
          "co_ResearchRipwaveMissiles_StarportTechReactor_3",
          "co_ResearchMedivacCloakedHealBeam_StarportTechReactor",
          "co_ResearchSuperScience_StarportTechReactor",
        ],
      },
      {
        id: "starport_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "starport",
        card: ["move", "stop", "hold", "patrol", "tTechLabStarport", "co_Land_11"],
      },
      {
        id: "ghostacademy",
        cancel: true,
        label: "Ghost Academy",
        kind: "building",
        card: [
          "co_ResearchNovaDetector_GhostAcademyNova",
          "co_ResearchNovaLifeRegen_GhostAcademyNova",
          "co_ResearchNovaShotgunBlastRange_GhostAcademyNova",
          "co_ResearchNovaSnipeRefund_GhostAcademyNova",
          "tSelectBuilder",
          "tHalt",
        ],
      },
    ],
  },
  horner: {
    label: "Han & Horner",
    race: "terran",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "scv",
        cluster: "basic",
        cancel: true,
        label: "SCV",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_TerranBuild_HHSCV_Han",
          "co_TerranBuildAdvanced_HHSCV_Han",
          "repair",
          "spray",
          "tHalt",
        ],
      },
      {
        id: "scv_build0",
        cancel: true,
        label: "Build Structure",
        kind: "building",
        parent: "scv",
        card: [
          "co_CommandCenter_HHSCV",
          "co_Refinery_HHSCV",
          "co_SupplyDepot_HHSCV",
          "co_BuildHHMercStarport_HHSCV",
          "co_HHMercCompound_HHSCV",
          "co_MissileTurret_HHSCV",
        ],
      },
      {
        id: "scv_build1",
        cancel: true,
        label: "Build Advanced Structure",
        kind: "building",
        parent: "scv",
        card: ["co_BuildHHBomberPlatform_HHSCV", "co_HHArmory_HHSCV", "co_FusionCore_HHSCV"],
      },
      {
        id: "reaper",
        cluster: "basic",
        label: "Reaper",
        kind: "unit",
        card: ["co_HHKD8Charge_HHReaper", "co_HHReaperFly_HHReaper"],
      },
      {
        id: "widowmine",
        cluster: "flying",
        label: "Widow Mine",
        kind: "unit",
        card: ["co_WidowMineBurrow_HHWidowMine", "co_WidowMineUnburrow_HHWidowMine"],
      },
      {
        id: "hellbat",
        cluster: "basic",
        label: "Hellbat",
        kind: "unit",
        card: ["co_MorphToHHHellion_HHHellionTank_hellbathellion"],
      },
      {
        id: "hellbat_hellion",
        cluster: "basic",
        label: "Hellion",
        kind: "unit",
        parent: "hellbat",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "co_MorphToHellionTank_HHHellion",
          "co_HHHellionBomb_HHHellion",
        ],
      },
      {
        id: "wraith",
        cluster: "basic",
        label: "Asteria Wraith",
        kind: "unit",
        card: [
          "co_FleetwideJump_HHWraith",
          "co_WraithCloakOn_HHWraith",
          "co_WraithCloakOff_HHWraith",
        ],
      },
      {
        id: "viking",
        cluster: "basic",
        label: "Deimos Viking",
        kind: "unit",
        card: [
          "co_FleetwideJump_HHVikingFighter",
          "co_HHVikingRockets_HHVikingFighter",
          "co_AssaultMode_vikingassaultmode",
        ],
      },
      {
        id: "viking_assaultmode",
        cluster: "basic",
        label: "Assault Mode",
        kind: "unit",
        parent: "viking",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "co_FleetwideJump_HHVikingAssault",
          "tFighterMode",
        ],
      },
      {
        id: "raven",
        cluster: "flying",
        label: "Theia Raven",
        kind: "unit",
        card: [
          "co_FleetwideJump_HHRaven",
          "co_HHNomadTargetLock_HHRaven",
          "co_MorphtoHHRavenSiege_HHRaven",
          "co_MorphtoHHRaven_HHRaven",
        ],
      },
      {
        id: "battlecruiser",
        cluster: "basic",
        label: "Sovereign Battlecruiser",
        kind: "unit",
        card: [
          "co_Hyperjump_HHBattlecruiser",
          "co_HHYamatoShots_HHBattlecruiser",
          "co_HHBattlecruiserShots_HHBattlecruiser",
        ],
      },
      {
        id: "commandcenter",
        cancel: true,
        label: "Command Center",
        kind: "building",
        card: [
          "tScv",
          "tSelectBuilder",
          "tRally",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "co_Lift_commandcenterflying_4",
        ],
      },
      {
        id: "commandcenter_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "commandcenter",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "co_Land_12",
        ],
      },
      {
        id: "refinery",
        cancel: true,
        label: "Refinery",
        kind: "building",
        card: ["tSelectBuilder"],
      },
      {
        id: "supplydepot",
        cancel: true,
        label: "Supply Depot",
        kind: "building",
        card: ["tSelectBuilder", "co_Lower_SupplyDepot_supplydepotlowered_3"],
      },
      {
        id: "supplydepot_lowered",
        cancel: true,
        label: "Lowered",
        kind: "building",
        parent: "supplydepot",
        card: ["co_Raise_SupplyDepotLowered_3"],
      },
      {
        id: "assaultgalleon",
        cluster: "basic",
        cancel: true,
        label: "Assault Galleon",
        kind: "building",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "co_ResearchHHMercStarportHangarBay_HHMercStarportUpgraded",
          "co_HHReaper_HHMercStarportUpgraded",
          "co_HHWidowMine_HHMercStarportUpgraded",
          "co_HHHellion_HHMercStarportUpgraded",
          "co_HHHellionTank_HHMercStarportUpgraded",
          "tSelectBuilder",
        ],
      },
      {
        id: "engineeringbay",
        cancel: true,
        label: "Engineering Bay",
        kind: "building",
        card: [
          "co_ResearchHHReaperClusterBombs_HHMercCompound",
          "co_ResearchHHReaperFlight_HHMercCompound",
          "co_ResearchHHWidowMineDeathBlossom_HHMercCompound",
          "co_ResearchHHWidowMineRangeAttack_HHMercCompound",
          "co_ResearchHHHellionDeathStim_HHMercCompound",
          "co_ResearchHHHellionRocket_HHMercCompound",
          "co_ResearchHHHellionDeathFear_HHMercCompound",
          "co_ResearchHHHellionAttackDoT_HHMercCompound",
          "tSelectBuilder",
        ],
      },
      {
        id: "missileturret",
        cluster: "tower",
        cancel: true,
        label: "Missile Turret",
        kind: "building",
        card: ["stop", "attack", "tSelectBuilder", "co_Salvage_MissileTurret_3", "tHalt"],
      },
      {
        id: "strikefighterplatform",
        cancel: true,
        label: "Strike Fighter Platform",
        kind: "building",
        card: [
          "co_HHBomberAreaBomb_HHBomberPlatform",
          "co_TrainHHBomber_HHBomberPlatform",
          "tHalt",
        ],
      },
      {
        id: "armory",
        cancel: true,
        label: "Armory",
        kind: "building",
        card: [
          "co_TerranVehicleAndShipWeaponsLevel1_Armory_4",
          "tTerranVehicleAndShipPlatingLe",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "starport",
        cancel: true,
        label: "Dominion Starport",
        kind: "building",
        card: [
          "co_Wraith_HHStarport",
          "co_VikingFighter_HHStarport",
          "co_Battlecruiser_HHStarport",
          "co_HHRaven_HHStarport",
          "co_HHTechLabStarport_HHStarport",
        ],
      },
      {
        id: "starport_techlab",
        cancel: true,
        label: "Dominion Starport: Tech Lab",
        kind: "building",
        card: [
          "tResearchBansheeCloakStarportT",
          "co_ResearchShockwaveMissileBattery_StarportTechLab_4",
          "co_ResearchPhobosClassWeaponsSystem_StarportTechLab_4",
          "co_ResearchRipwaveMissiles_StarportTechLab_4",
          "co_ResearchMedivacCloakedHealBeam_StarportTechLab_2",
          "co_ResearchHHTacticalJumpCharges_StarportTechLab",
        ],
      },
      {
        id: "fusioncore",
        cancel: true,
        label: "Fusion Core",
        kind: "building",
        card: [
          "tResearchBattlecruiserSpeciali",
          "co_ResearchHHBomberNapalm_FusionCore",
          "tSelectBuilder",
          "tHalt",
        ],
      },
    ],
  },
  tychus: {
    label: "Tychus",
    race: "terran",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "tychus",
        label: "Tychus",
        kind: "unit",
        card: [
          "co_TychusHeroCommonAbil1",
          "co_TychusHeroCommonAbil2",
          "co_TychusHeroCommonAbil3",
          "co_TychusHeroCommonAbil4",
          "co_TychusHeroCommonAbil5",
        ],
      },
      {
        id: "odin",
        cluster: "basic",
        cancel: true,
        label: "Odin",
        kind: "unit",
        card: [
          "co_TychusOdinRedButton_TychusOdin",
          "co_TychusHeroCommonAbil2_2",
          "co_TychusHeroCommonAbil3_2",
          "co_TychusHeroCommonAbil4_2",
          "co_TychusHeroCommonAbil5_2",
        ],
      },
      {
        id: "crookedsam",
        label: "Crooked Sam",
        kind: "unit",
        card: [
          "co_TychusReaperEvasionBuff_TychusReaper",
          "co_TychusHeroCommonAbil1_2",
          "co_TychusHeroCommonAbil2_3",
          "co_TychusHeroCommonAbil3_3",
          "co_TychusHeroCommonAbil4_3",
          "co_TychusHeroCommonAbil5_3",
        ],
      },
      {
        id: "sirius",
        cluster: "tower",
        label: "James “Sirius” Sykes",
        kind: "unit",
        card: [
          "co_TychusWarhoundHaywireMissiles_TychusWarhound",
          "co_TychusHeroCommonAbil1_3",
          "co_TychusHeroCommonAbil2_4",
          "co_TychusHeroCommonAbil3_4",
          "co_TychusHeroCommonAbil4_4",
          "co_TychusHeroCommonAbil5_4",
        ],
      },
      {
        id: "sirius_warhoundturret",
        cluster: "tower",
        label: "James “Sirius” Sykes: Warhound Turret",
        kind: "unit",
        card: ["stop", "attack", "co_TychusWarhoundTurretHaywireMissiles_TychusWarhoundAutoTurret"],
      },
      {
        id: "blaze",
        label: "Miles “Blaze” Lewis",
        kind: "unit",
        card: [
          "co_TychusHeroCommonAbil1_4",
          "co_TychusHeroCommonAbil2_5",
          "co_TychusHeroCommonAbil3_5",
          "co_TychusHeroCommonAbil4_5",
          "co_TychusHeroCommonAbil5_5",
        ],
      },
      {
        id: "rattlesnake",
        label: "Kev “Rattlesnake” West",
        kind: "unit",
        card: [
          "co_TychusMarauderSuperStim_TychusMarauder",
          "co_TychusHeroCommonAbil1_5",
          "co_TychusHeroCommonAbil2_6",
          "co_TychusHeroCommonAbil3_6",
          "co_TychusHeroCommonAbil4_6",
          "co_TychusHeroCommonAbil5_6",
        ],
      },
      {
        id: "cannonball",
        label: "Rob “Cannonball” Boswell",
        kind: "unit",
        card: [
          "co_TychusHeroCommonAbil1_6",
          "co_TychusHeroCommonAbil2_7",
          "co_TychusHeroCommonAbil3_7",
          "co_TychusHeroCommonAbil4_7",
          "co_TychusHeroCommonAbil5_7",
        ],
      },
      {
        id: "vega",
        label: "Vega",
        kind: "unit",
        card: [
          "co_TychusGhostPsychicSnare_TychusGhost",
          "co_TychusHeroCommonAbil1_7",
          "co_TychusHeroCommonAbil2_8",
          "co_TychusHeroCommonAbil3_8",
          "co_TychusHeroCommonAbil4_8",
          "co_TychusHeroCommonAbil5_8",
        ],
      },
      {
        id: "nux",
        label: "Nux",
        kind: "unit",
        card: [
          "co_TychusHeroCommonAbil1_8",
          "co_TychusHeroCommonAbil2_9",
          "co_TychusHeroCommonAbil3_9",
          "co_TychusHeroCommonAbil4_9",
          "co_TychusHeroCommonAbil5_9",
        ],
      },
      {
        id: "nikara",
        label: "Lt. Layna Nikara",
        kind: "unit",
        card: [
          "co_TychusMedicDefensiveMatrix_TychusMedic",
          "co_TychusMedicHeal_TychusMedic",
          "co_TychusHeroCommonAbil1_9",
          "co_TychusHeroCommonAbil2_10",
          "co_TychusHeroCommonAbil3_10",
          "co_TychusHeroCommonAbil4_10",
          "co_TychusHeroCommonAbil5_10",
        ],
      },
      {
        id: "scv",
        cluster: "basic",
        cancel: true,
        label: "SCV",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_TerranBuild_TychusSCV_Tychus",
          "repair",
          "spray",
          "tHalt",
        ],
      },
      {
        id: "scv_build0",
        cancel: true,
        label: "Build Structure",
        kind: "building",
        parent: "scv",
        card: [
          "co_TychusCommandCenter_TychusSCV",
          "co_TychusRefinery_TychusSCV",
          "co_BuildTychusBar_TychusSCV",
          "co_TychusEngineeringBay_TychusSCV",
          "co_TychusSCVAutoTurret_TychusSCV",
          "co_TychusMercCompound_TychusSCV",
          "co_TychusArmory_TychusSCV",
          "co_TychusGhostAcademy_TychusSCV",
          "co_BuildTychusMedivacPlatform_TychusSCV",
        ],
      },
      {
        id: "commandcenter",
        cancel: true,
        label: "Command Center",
        kind: "building",
        card: [
          "co_TychusSCV_TychusCommandCenter",
          "tSelectBuilder",
          "tRally",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "co_Lift_commandcenterflying_5",
        ],
      },
      {
        id: "commandcenter_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "commandcenter",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "co_Land_13",
        ],
      },
      {
        id: "refinery",
        cancel: true,
        label: "Refinery",
        kind: "building",
        card: ["tSelectBuilder", "tHalt"],
      },
      {
        id: "bar",
        cancel: true,
        label: "Joeyray’s Bar",
        kind: "building",
        card: [
          "co_TychusACHero_TychusResearchCenter",
          "co_TychusReaper_TychusResearchCenter",
          "co_TychusWarhound_TychusResearchCenter",
          "co_TychusFirebat_TychusResearchCenter",
          "co_TychusHERC_TychusResearchCenter",
          "co_TychusMarauder_TychusResearchCenter",
          "co_TychusGhost_TychusResearchCenter",
          "co_TychusSpectre_TychusResearchCenter",
          "co_TychusMedic_TychusResearchCenter",
          "tHalt",
        ],
      },
      {
        id: "engineeringbay",
        cancel: true,
        label: "Engineering Bay",
        kind: "building",
        card: [
          "co_TychusOutlawWeaponsLevel1_TychusEngineeringBay",
          "co_TychusOutlawArmorLevel1_TychusEngineeringBay",
          "co_TychusSquadAttackSpeed_TychusEngineeringBay",
          "co_TychusSquadHealth_TychusEngineeringBay",
          "co_TychusSquadDetection_TychusEngineeringBay",
          "co_TychusUpgradeOdinRedButton_TychusEngineeringBay",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "autoturret",
        cluster: "tower",
        label: "Auto-Turret",
        kind: "building",
        card: ["stop", "attack", "tSelectBuilder", "co_Salvage_TychusSCVAutoTurret"],
      },
      {
        id: "guns",
        label: "Gunslingers’ Hideout",
        kind: "building",
        card: [
          "co_TychusACImplosionGrenadesLearn_TychusMercCompound",
          "co_TychusACRageGrenadesLearn_TychusMercCompound",
          "co_TychusACPiercingRoundsLearn_TychusMercCompound",
          "co_TychusACBandofBrothersLearn_TychusMercCompound",
          "co_TychusReaperBombDamageLearn_TychusMercCompound",
          "co_TychusReaperBombStunLearn_TychusMercCompound",
          "co_TychusReaperEvasionLearn_TychusMercCompound",
          "co_TychusReaperBombChargesLearn_TychusMercCompound",
          "co_TychusWarhoundHaywireMissilesUpgrade_TychusMercCompound",
          "co_TychusWarhoundFearUpgrade_TychusMercCompound",
          "co_TychusWarhoundDeathExplosionUpgrade_TychusMercCompound",
          "co_TychusWarhoundTurretUpgrade_TychusMercCompound",
        ],
      },
      {
        id: "muscle",
        label: "Muscle Armory",
        kind: "building",
        card: [
          "co_TychusFirebatPremiumPetroleumLearn_TychusArmory",
          "co_TychusFirebatBlueFlameOilLearn_TychusArmory",
          "co_TychusFirebatIncendiaryPetroleumLearn_TychusArmory",
          "co_TychusFirebatShieldLearn_TychusArmory",
          "co_TychusHercGrappleImpacts_TychusArmory",
          "co_TychusHercGrappleArmor_TychusArmory",
          "co_TychusHercRageLearn_TychusArmory",
          "co_TychusHercCrit_TychusArmory",
          "co_TychusMarauderHealingWardBuffLearn_TychusArmory",
          "co_TychusMarauderHealingWardSpeedBuffLearn_TychusArmory",
          "co_TychusMarauderSuperStimLearn_TychusArmory",
          "co_TychusMarauderAttackSplashLearn_TychusArmory",
        ],
      },
      {
        id: "fixers",
        label: "Fixers’ Safehouse",
        kind: "building",
        card: [
          "co_TychusGhostDominateBuffLearn_TychusGhostAcademy",
          "co_TychusGhostConfusingDominationLearn_TychusGhostAcademy",
          "co_TychusGhostPsychicSnareLearn_TychusGhostAcademy",
          "co_TychusGhostConcentrationHelmetLearn_TychusGhostAcademy",
          "co_TychusSpectreSuperUltrasonicPulseLearn_TychusGhostAcademy",
          "co_TychusSpectreVisionSuitLearn_TychusGhostAcademy",
          "co_TychusSpectreExtendedPulseGunLearn_TychusGhostAcademy",
          "co_TychusSpectreBrillianceAuraLearn_TychusGhostAcademy",
          "co_TychusMedicHealingSprayUpgrade_TychusGhostAcademy",
          "co_TychusMedicHealUpgrade_TychusGhostAcademy",
          "co_TychusMedicDoubleHealLearn_TychusGhostAcademy",
          "co_TychusMedicDefensiveMatrixLearn_TychusGhostAcademy",
        ],
      },
      {
        id: "medivacplatform",
        cancel: true,
        label: "Medivac Platform",
        kind: "building",
        card: ["co_TychusMedicTransportUnits_TychusMedivacPlatform", "tSelectBuilder", "tHalt"],
      },
    ],
  },
  mengsk: {
    label: "Mengsk",
    race: "terran",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "laborer",
        cancel: true,
        label: "Dominion Laborer",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_TerranBuild_SCVMengsk_Mengsk",
          "co_TerranBuildAdvanced_SCVMengsk_Mengsk",
          "co_TrooperMengskEnlist_SCVMengsk",
          "repair",
          "spray",
          "tHalt",
        ],
      },
      {
        id: "laborer_build0",
        cancel: true,
        label: "Build Structure",
        kind: "building",
        parent: "laborer",
        card: [
          "co_CommandCenterMengsk_SCVMengsk",
          "co_RefineryMengsk_SCVMengsk",
          "co_BunkerMengsk_SCVMengsk",
          "co_BarracksMengsk_SCVMengsk",
          "co_EngineeringBayMengsk_SCVMengsk",
          "co_ArtilleryMengsk_SCVMengsk",
          "co_MissileTurretMengsk_SCVMengsk",
        ],
      },
      {
        id: "laborer_build1",
        cancel: true,
        label: "Build Advanced Structure",
        kind: "building",
        parent: "laborer",
        card: [
          "co_GhostAcademyMengsk_SCVMengsk",
          "co_FactoryMengsk_SCVMengsk",
          "co_ArmoryMengsk_SCVMengsk",
          "co_StarportMengsk_SCVMengsk",
          "co_FusionCoreMengsk_SCVMengsk",
        ],
      },
      {
        id: "trooper",
        cancel: true,
        label: "Dominion Trooper",
        kind: "unit",
        card: [
          "co_SCVMengskEnlist_TrooperMengsk",
          "co_TrooperMengskBuild_TrooperMengsk_Mengsk",
          "co_TrooperMengskSpecializeImproved_TrooperMengsk",
          "co_TrooperMengskSpecializeFlamethrower_TrooperMengsk",
          "co_TrooperMengskSpecializeAA_TrooperMengsk",
        ],
      },
      {
        id: "trooper_build0",
        cancel: true,
        label: "Build Combat Structure",
        kind: "building",
        parent: "trooper",
        card: [
          "co_BunkerMengsk_TrooperMengsk",
          "co_ArtilleryMengsk_TrooperMengsk",
          "co_MissileTurretMengsk_TrooperMengsk",
        ],
      },
      {
        id: "marauder",
        cluster: "basic",
        label: "Aegis Guard",
        kind: "unit",
        card: ["co_MarauderMengskAttackSpeedBoost_MarauderMengsk"],
      },
      {
        id: "ghost",
        cluster: "basic",
        cancel: true,
        label: "Emperor’s Shadow",
        kind: "unit",
        card: [
          "co_GhostMengskHoldFire_GhostMengsk",
          "co_WeaponsFreeMengsk_GhostMengsk",
          "co_GhostMengskIrradiate_GhostMengsk",
          "co_GhostMengskEMP_GhostMengsk",
          "co_GhostMengskSuperCloak_GhostMengsk",
          "co_NukeCalldownMengsk_GhostMengsk",
        ],
      },
      {
        id: "siegetank",
        cluster: "basic",
        label: "Shock Division",
        kind: "unit",
        card: ["co_SiegeModeMengsk", "co_UnsiegeMengsk_SiegeTankMengsk"],
      },
      {
        id: "thor",
        cluster: "basic",
        cancel: true,
        label: "Blackhammer",
        kind: "unit",
        card: ["co_ThorMengskSiege_ThorMengsk", "co_ThorMengskUnsiege_ThorMengsk"],
      },
      {
        id: "viking",
        cluster: "basic",
        label: "Sky Fury",
        kind: "unit",
        card: [
          "co_FighterModeMengsk_VikingMengskFighter",
          "co_AssaultModeMengsk_VikingMengskFighter",
        ],
      },
      {
        id: "medivac",
        cluster: "flying",
        label: "Imperial Intercessor",
        kind: "unit",
        card: [
          "co_HealMengsk_MedivacMengsk",
          "co_IgniteAfterburnersMengsk_MedivacMengsk",
          "tBunkerLoad",
          "tBunkerUnloadAll",
        ],
      },
      {
        id: "raven",
        cluster: "flying",
        label: "Imperial Witness",
        kind: "unit",
        card: ["co_MorphtoRavenMengskSieged_RavenMengsk", "co_MorphtoRavenMengsk_RavenMengsk"],
      },
      {
        id: "battlecruiser",
        cluster: "basic",
        label: "Pride of Augustgrad",
        kind: "unit",
        card: ["co_YamatoGunMengsk", "co_BattlecruiserMengskHyperjump_BattlecruiserMengsk"],
      },
      {
        id: "commandcenter",
        cancel: true,
        label: "Enlistment Center",
        kind: "building",
        card: [
          "co_SCVMengsk",
          "co_TrooperMengsk_CommandCenterMengsk",
          "co_SCVMengskEnlistCC_CommandCenterMengsk",
          "co_TrooperMengskEnlistCC_CommandCenterMengsk",
          "tSelectBuilder",
          "co_Lift_commandcenterflying_6",
        ],
      },
      {
        id: "commandcenter_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "commandcenter",
        card: ["move", "stop", "hold", "patrol", "co_Land_14"],
      },
      {
        id: "refinery",
        cancel: true,
        label: "Refinery",
        kind: "building",
        card: ["tSelectBuilder", "tHalt"],
      },
      {
        id: "supplydepot",
        cancel: true,
        label: "Supply Bunker",
        kind: "building",
        card: [
          "stop",
          "attack",
          "co_SCVMengskEnlistCC_BunkerDepotMengsk",
          "co_TrooperMengskEnlistCC_BunkerDepotMengsk",
          "tSelectBuilder",
          "co_BunkerDepotMengskLoad",
          "co_BunkerMengskSalvage_BunkerDepotMengsk",
        ],
      },
      {
        id: "barracks",
        cancel: true,
        label: "Barracks",
        kind: "building",
        card: [
          "co_MarauderMengsk_BarracksMengsk",
          "co_GhostMengsk_BarracksMengsk",
          "tSelectBuilder",
          "tRally",
          "co_Lift_barracksflying_3",
        ],
      },
      {
        id: "barracks_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "barracks",
        card: ["move", "stop", "hold", "patrol", "co_Land_15"],
      },
      {
        id: "engineeringbay",
        cancel: true,
        label: "Engineering Bay",
        kind: "building",
        card: [
          "co_MengskTrooperWeaponsLevel1_EngineeringBayMengsk",
          "co_MengskTrooperArmorLevel1_EngineeringBayMengsk",
          "co_TrooperMengskDropTrainResearch_EngineeringBayMengsk",
          "co_StructureArmorMengsk_EngineeringBayMengsk",
          "co_BunkerDepotMengskRangeResearch_EngineeringBayMengsk",
          "co_ArtilleryMengskRangeResearch_EngineeringBayMengsk",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "artillery",
        cancel: true,
        label: "Earthsplitter Ordnance",
        kind: "building",
        card: [
          "stop",
          "tSelectBuilder",
          "co_ArtilleryMengskBombardment_ArtilleryMengsk",
          "co_ArtilleryMengskLoad",
          "co_Salvage_ArtilleryMengsk",
        ],
      },
      {
        id: "missileturret",
        cluster: "tower",
        cancel: true,
        label: "Missile Turret",
        kind: "building",
        card: ["stop", "attack", "tSelectBuilder", "co_Salvage_MissileTurretMengsk", "tHalt"],
      },
      {
        id: "ghostacademy",
        cancel: true,
        label: "Royal Academy",
        kind: "building",
        card: [
          "co_MarauderMengskSlowResearch_GhostAcademyMengsk",
          "co_GhostMengskGuidedStrikeRessearch_GhostAcademyMengsk",
          "co_NukeMengskArm_GhostAcademyMengsk",
        ],
      },
      {
        id: "factory",
        cancel: true,
        label: "Factory",
        kind: "building",
        card: [
          "co_SiegeTankMengsk_FactoryMengsk",
          "co_ThorMengsk_FactoryMengsk",
          "tSelectBuilder",
          "tRally",
          "co_Lift_factoryflying_4",
        ],
      },
      {
        id: "factory_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "factory",
        card: ["move", "stop", "hold", "patrol", "co_Land_16"],
      },
      {
        id: "armory",
        cancel: true,
        label: "Armory",
        kind: "building",
        card: [
          "co_MedivacMengskSiegeTankAirliftResearch_ArmoryMengsk",
          "co_ThorMengskArmorAuraResearch_ArmoryMengsk",
          "co_MechTransformationSpeedMengsk_ArmoryMengsk",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "starport",
        cancel: true,
        label: "Starport",
        kind: "building",
        card: [
          "co_VikingMengskFighter_StarportMengsk",
          "co_MedivacMengsk_StarportMengsk",
          "co_RavenMengsk_StarportMengsk",
          "co_BattlecruiserMengsk_StarportMengsk",
          "tSelectBuilder",
          "tRally",
          "co_Lift_starportflying_4",
        ],
      },
      {
        id: "starport_flying",
        cancel: true,
        label: "Flying",
        kind: "building",
        parent: "starport",
        card: ["move", "stop", "hold", "patrol", "co_Land_17"],
      },
      {
        id: "fusioncore",
        cancel: true,
        label: "Fusion Core",
        kind: "building",
        card: [
          "co_MedivacMengskDoubleHealBeamResearch_FusionCoreMengsk",
          "co_MedivacMengskPermanentCloakResearch_FusionCoreMengsk",
          "co_BlimpMengskTopbarRegenResearch_FusionCoreMengsk",
          "co_VikingMengskSpeedResearch_FusionCoreMengsk",
          "co_BattlecruiserMengskRangeAuraResearch_FusionCoreMengsk",
          "tSelectBuilder",
          "tHalt",
        ],
      },
    ],
  },
  kerrigan: {
    label: "Kerrigan",
    race: "zerg",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "kerrigan",
        cluster: "basic",
        label: "Kerrigan",
        kind: "unit",
        card: [
          "co_MindBolt_K5Kerrigan",
          "co_PsionicLift_K5Kerrigan",
          "co_KerriganVoidCoopEconDrop_K5Kerrigan",
          "co_KerriganVoidCoopCrushingGripWave_K5Kerrigan",
          "co_BurrowDown_kerriganburrowed",
        ],
      },
      {
        id: "kerrigan_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "kerrigan",
        card: [
          "co_MindBolt_K5KerriganBurrowed",
          "co_PsionicLift_K5KerriganBurrowed",
          "co_KerriganVoidCoopEconDrop_K5KerriganBurrowed",
          "co_KerriganVoidCoopCrushingGripWave_K5KerriganBurrowed",
          "unburrow",
        ],
      },
      {
        id: "larva",
        cancel: true,
        label: "Larva",
        kind: "unit",
        card: ["zDrone", "zOver", "zZerglingLarva", "zHydra", "zUltraliskLarva", "zMuta"],
      },
      {
        id: "drone",
        cluster: "basic",
        cancel: true,
        label: "Drone",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_ZergBuild_Drone_Kerrigan",
          "co_ZergBuildAdvanced_Drone_Kerrigan",
          "spray",
          "burrow",
        ],
      },
      {
        id: "drone_build0",
        cancel: true,
        label: "Basic Mutation",
        kind: "building",
        parent: "drone",
        card: ["zbHatch", "zbExtract", "co_SpawningPool_Drone", "zbEvo", "zbSpine", "zbSpore"],
      },
      {
        id: "drone_build1",
        cancel: true,
        label: "Advanced Mutation",
        kind: "building",
        parent: "drone",
        card: ["zbHydra", "zbSpire", "zbNydus", "zbUltra"],
      },
      {
        id: "queen",
        cluster: "basic",
        label: "Queen",
        kind: "unit",
        card: [
          "co_BuildCreepTumor_QueenCoop_queencreeptumor",
          "co_MorphMorphalisk_QueenCoop",
          "co_Transfusion_QueenCoop",
          "co_BurrowDown_queenburrowed",
        ],
      },
      {
        id: "queen_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "queen",
        card: ["unburrow"],
      },
      {
        id: "queen_creeptumor",
        cluster: "basic",
        label: "Creep Tumor",
        kind: "unit",
        parent: "queen",
        card: ["zBuildCreepTumorPropagateCreep"],
      },
      {
        id: "overlord",
        cluster: "flying",
        cancel: true,
        label: "Overlord",
        kind: "unit",
        card: [
          "zMorphToOverseerOverlord",
          "co_GenerateCreep_Overlord_overlordgeneratingcreep",
          "tBunkerLoad",
          "tBunkerUnloadAll",
        ],
      },
      {
        id: "overlord_generatingcreep",
        cluster: "flying",
        cancel: true,
        label: "Generating Creep",
        kind: "unit",
        parent: "overlord",
        card: ["zStopGenerateCreep"],
      },
      {
        id: "overseer",
        cluster: "flying",
        label: "Overseer",
        kind: "unit",
        card: ["zMorphtoOverseerSiege", "zMorphtoOverseerNormal"],
      },
      {
        id: "zergling",
        cluster: "basic",
        label: "Zergling",
        kind: "unit",
        card: ["co_BurrowDown_zerglingburrowed"],
      },
      {
        id: "zergling_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "zergling",
        card: ["unburrow"],
      },
      {
        id: "hydralisk",
        cluster: "basic",
        label: "Hydralisk",
        kind: "unit",
        card: [
          "co_Lurker_HydraliskLurker",
          "co_HydraliskFrenzy_HydraliskLurker",
          "co_BurrowDown_hydraliskburrowed",
        ],
      },
      {
        id: "hydralisk_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "hydralisk",
        card: ["unburrow"],
      },
      {
        id: "lurker",
        cluster: "flying",
        label: "Lurker",
        kind: "unit",
        card: ["co_BurrowLurkerMP_lurkerburrowed"],
      },
      {
        id: "lurker_burrowed",
        cluster: "flying",
        label: "Burrowed",
        kind: "unit",
        parent: "lurker",
        card: [
          "stop",
          "attack",
          "co_LurkerCancelHoldFire_LurkerBurrowed",
          "co_LurkerHoldFire_LurkerBurrowed",
          "co_LurkerBurrowUp",
        ],
      },
      {
        id: "mutalisk",
        cluster: "basic",
        label: "Mutalisk",
        kind: "unit",
        card: ["co_BroodLord_MutaliskBroodlord"],
      },
      {
        id: "ultralisk",
        cluster: "basic",
        label: "Ultralisk",
        kind: "unit",
        card: ["co_BurrowChargeCampaign_HotSTorrasque", "co_BurrowDown_ultraliskburrowed"],
      },
      {
        id: "ultralisk_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "ultralisk",
        card: ["unburrow"],
      },
      {
        id: "hatchery",
        cancel: true,
        label: "Hatchery",
        kind: "building",
        card: [
          "zLarva",
          "zQueen",
          "zOverlordspeed",
          "co_EvolveVentralSacks",
          "zRallyEgg",
          "tRally",
          "co_Lair_Hatchery_hatcherylair",
        ],
      },
      {
        id: "hatchery_lair",
        cancel: true,
        label: "Lair",
        kind: "building",
        parent: "hatchery",
        card: [
          "zLarva",
          "zQueen",
          "zOverlordspeed",
          "co_EvolveVentralSacks_2",
          "zRallyEgg",
          "tRally",
          "zHiveLair",
        ],
      },
      {
        id: "spawningpool",
        cancel: true,
        label: "Spawning Pool",
        kind: "building",
        card: [
          "zZerglingmovementspeedSpawning",
          "co_EvolveHardenedCarapace_SpawningPool",
          "zZerglingattackspeedSpawningPo",
          "co_EvolveZerglingArmorShred_SpawningPool",
        ],
      },
      {
        id: "evolutionchamber",
        cancel: true,
        label: "Evolution Chamber",
        kind: "building",
        card: [
          "zZergmeleeweapons1EvolutionCha",
          "zZergmissileweapons1EvolutionC",
          "zZerggroundarmor1EvolutionCham",
          "co_EvolveKerriganHeroicFortitude_EvolutionChamber",
          "co_EvolveK5ChainLightning_EvolutionChamber",
          "co_EvolveK5Cooldowns_EvolutionChamber",
        ],
      },
      {
        id: "spinecrawler",
        cluster: "tower",
        cancel: true,
        label: "Spine Crawler",
        kind: "building",
        card: ["stop", "attack", "co_SpineCrawlerUproot_SpineCrawler_spinecrawleruprooted"],
      },
      {
        id: "spinecrawler_uprooted",
        cluster: "tower",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "spinecrawler",
        card: ["move", "stop", "hold", "patrol", "zSpineCrawlerRootSpineCrawlerU"],
      },
      {
        id: "sporecrawler",
        cluster: "tower",
        cancel: true,
        label: "Spore Crawler",
        kind: "building",
        card: ["stop", "attack", "co_SporeCrawlerUproot_SporeCrawler_sporecrawleruprooted"],
      },
      {
        id: "sporecrawler_uprooted",
        cluster: "tower",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "sporecrawler",
        card: ["move", "stop", "hold", "patrol", "zSporeCrawlerRootSporeCrawlerU"],
      },
      {
        id: "hydraliskden",
        cancel: true,
        label: "Hydralisk Den",
        kind: "building",
        card: [
          "zEvolveMuscularAugmentsHydrali",
          "co_EvolveAncillaryCarapace_HydraliskDen",
          "co_EvolveFrenzy_HydraliskDen",
          "co_ResearchLurkerRange_HydraliskDen",
          "co_LurkerDen_HydraliskDen",
        ],
      },
      {
        id: "spire",
        cancel: true,
        label: "Spire",
        kind: "building",
        card: [
          "zZergflyerattack1",
          "zZergflyerarmor1",
          "co_EvolveMutaliskRapidRegeneration_Spire",
          "co_EvolveKerriganViciousGlaive_Spire",
          "co_EvolveSeveringGlave_Spire",
          "co_EvolveGuardianAttackRangeIncrease_Spire",
          "co_GreaterSpireBroodlord_Spire",
        ],
      },
      {
        id: "nydusnetwork",
        cancel: true,
        label: "Omega Network",
        kind: "building",
        card: [
          "stop",
          "co_ZagaraVoidCoopNydusWorm_NydusNetwork",
          "tRally",
          "tBunkerLoad",
          "tBunkerUnloadAll",
        ],
      },
      {
        id: "ultraliskcavern",
        cancel: true,
        label: "Ultralisk Cavern",
        kind: "building",
        card: [
          "zEvolveChitinousPlatingUltrali",
          "co_EvolveBurrowCharge_UltraliskCavern",
          "co_EvolveTissueAssimilation_UltraliskCavern",
        ],
      },
    ],
  },
  zagara: {
    label: "Zagara",
    race: "zerg",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "zagara",
        cluster: "basic",
        label: "Zagara",
        kind: "unit",
        card: [
          "co_ZagaraVoidCoopBanelingBarrage_ZagaraVoidCoop",
          "co_ZagaraVoidCoopSpawnHunterKillers_ZagaraVoidCoop",
          "co_ZagaraVoidCoopMassFrenzy_ZagaraVoidCoop",
          "co_MassRoachDrop_ZagaraVoidCoop",
          "co_CommanderPrestigeZagaraZagaraDeepTunnel_ZagaraVoidCoop",
          "co_BurrowDown_zagaraburrowed",
        ],
      },
      {
        id: "zagara_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "zagara",
        card: [
          "co_ZagaraVoidCoopBanelingBarrage_ZagaraVoidCoopBurrowed",
          "co_ZagaraVoidCoopSpawnHunterKillers_ZagaraVoidCoopBurrowed",
          "co_ZagaraVoidCoopMassFrenzy_ZagaraVoidCoopBurrowed",
          "co_MassRoachDrop_ZagaraVoidCoopBurrowed",
          "unburrow",
        ],
      },
      {
        id: "larva",
        cancel: true,
        label: "Larva",
        kind: "unit",
        card: [
          "zDrone",
          "zOver",
          "zZerglingLarva",
          "co_Aberration_Larva",
          "zRoach",
          "zSwarmHostMPLarva",
        ],
      },
      {
        id: "drone",
        cluster: "basic",
        cancel: true,
        label: "Drone",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_ZergBuild_Drone_Zagara",
          "co_ZergBuildAdvanced_Drone_Zagara",
          "spray",
          "burrow",
        ],
      },
      {
        id: "drone_build0",
        cancel: true,
        label: "Basic Mutation",
        kind: "building",
        parent: "drone",
        card: [
          "zbHatch",
          "zbExtract",
          "co_SpawningPool_Drone_2",
          "zbEvo",
          "zbBane",
          "zbSpine",
          "zbSpore",
          "co_ZagaraBileLauncher_Drone",
        ],
      },
      {
        id: "drone_build1",
        cancel: true,
        label: "Advanced Mutation",
        kind: "building",
        parent: "drone",
        card: ["co_ScourgeNest_Drone"],
      },
      {
        id: "queen",
        cluster: "basic",
        label: "Queen",
        kind: "unit",
        card: [
          "co_BuildCreepTumor_QueenCoop_queencreeptumor_2",
          "co_MorphMorphalisk_QueenCoop_2",
          "co_Transfusion_QueenCoop_2",
          "co_BurrowDown_queenburrowed_2",
        ],
      },
      {
        id: "queen_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "queen",
        card: ["unburrow"],
      },
      {
        id: "queen_creeptumor",
        cluster: "basic",
        label: "Creep Tumor",
        kind: "unit",
        parent: "queen",
        card: ["zBuildCreepTumorPropagateCreep"],
      },
      {
        id: "overlord",
        cluster: "flying",
        cancel: true,
        label: "Overlord",
        kind: "unit",
        card: [
          "zMorphToOverseerOverlord",
          "co_GenerateCreep_Overlord_overlordgeneratingcreep_2",
          "tBunkerLoad",
          "tBunkerUnloadAll",
        ],
      },
      {
        id: "overlord_generatingcreep",
        cluster: "flying",
        cancel: true,
        label: "Generating Creep",
        kind: "unit",
        parent: "overlord",
        card: ["zStopGenerateCreep"],
      },
      {
        id: "overseer",
        cluster: "flying",
        label: "Overseer",
        kind: "unit",
        card: ["zMorphtoOverseerSiege", "zMorphtoOverseerNormal"],
      },
      {
        id: "zergling",
        cluster: "basic",
        label: "Zergling",
        kind: "unit",
        card: ["zBanelingZergling", "co_BurrowDown_zerglingburrowed_2"],
      },
      {
        id: "zergling_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "zergling",
        card: ["move", "stop", "hold", "patrol", "attack", "unburrow"],
      },
      {
        id: "baneling",
        cluster: "basic",
        label: "Baneling",
        kind: "unit",
        card: [
          "co_Explode_HotSSplitterlingBig",
          "co_EnableBuildingAttack_HotSSplitterlingBig",
          "co_DisableBuildingAttack_HotSSplitterlingBig",
          "co_BurrowDown_banelingburrowed",
        ],
      },
      {
        id: "baneling_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "baneling",
        card: ["co_Explode_HotSSplitterlingBigBurrowed", "unburrow"],
      },
      {
        id: "aberration",
        label: "Aberration",
        kind: "unit",
        card: ["co_BurrowDown_aberrationburrowed"],
      },
      {
        id: "aberration_burrowed",
        label: "Burrowed",
        kind: "unit",
        parent: "aberration",
        card: ["unburrow"],
      },
      {
        id: "scourge",
        cluster: "basic",
        label: "Scourge",
        kind: "unit",
        card: [
          "co_DetonateScourge_Scourge",
          "co_EnableBuildingAttackScourge_Scourge",
          "co_DisableBuildingAttackScourge_Scourge",
        ],
      },
      {
        id: "corruptor",
        cluster: "basic",
        cancel: true,
        label: "Corruptor",
        kind: "unit",
        card: ["co_CorruptionAbility_ZagaraCorruptor"],
      },
      {
        id: "hunterkiller",
        cluster: "basic",
        label: "Hunter Killer",
        kind: "unit",
        card: ["co_BurrowDown_hunterkillerburrowed"],
      },
      {
        id: "hunterkiller_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "hunterkiller",
        card: ["unburrow"],
      },
      {
        id: "roach",
        cluster: "basic",
        label: "Roach",
        kind: "unit",
        card: ["co_BurrowDown_roachburrowed"],
      },
      {
        id: "roach_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "roach",
        card: ["move", "stop", "hold", "patrol", "attack", "unburrow"],
      },
      {
        id: "hatchery",
        cancel: true,
        label: "Hatchery",
        kind: "building",
        card: [
          "zLarva",
          "zQueen",
          "zOverlordspeed",
          "co_EvolveVentralSacks_3",
          "zRallyEgg",
          "tRally",
          "co_Lair_Hatchery_hatcherylair_2",
        ],
      },
      {
        id: "hatchery_lair",
        cancel: true,
        label: "Lair",
        kind: "building",
        parent: "hatchery",
        card: [
          "zLarva",
          "zQueen",
          "zOverlordspeed",
          "co_EvolveVentralSacks_4",
          "zRallyEgg",
          "tRally",
          "zHiveLair",
        ],
      },
      {
        id: "spawningpool",
        cancel: true,
        label: "Spawning Pool",
        kind: "building",
        card: [
          "zZerglingmovementspeedSpawning",
          "co_EvolveHardenedCarapace_SpawningPool_2",
          "zZerglingattackspeedSpawningPo",
          "co_EvolveZerglingArmorShred_SpawningPool_2",
          "co_EvolveBileLauncherIncreasedRange_SpawningPool",
          "co_EvolveBileLauncherBombardmentCooldown_SpawningPool",
        ],
      },
      {
        id: "evolutionchamber",
        cancel: true,
        label: "Evolution Chamber",
        kind: "building",
        card: [
          "zZergmeleeweapons1EvolutionCha",
          "zZergmissileweapons1EvolutionC",
          "zZerggroundarmor1EvolutionCham",
          "co_EvolveKerriganHeroicFortitude_EvolutionChamber_2",
          "co_EvolveK5ChainLightning_EvolutionChamber_2",
          "co_EvolveK5Cooldowns_EvolutionChamber_2",
        ],
      },
      {
        id: "banelingnest",
        cancel: true,
        label: "Baneling Nest",
        kind: "building",
        card: [
          "zEvolveCentrificalHooksBanelin",
          "co_EvolveBanelingCorrosiveBile_BanelingNest",
          "co_EvolveBanelingRupture_BanelingNest",
          "co_EvolveBanelingHeal_BanelingNest",
          "co_ZagaraVoidCoopBanelingSpawner_BanelingNest",
        ],
      },
      {
        id: "spinecrawler",
        cluster: "tower",
        cancel: true,
        label: "Spine Crawler",
        kind: "building",
        card: ["stop", "attack", "co_SpineCrawlerUproot_SpineCrawler_spinecrawleruprooted_2"],
      },
      {
        id: "spinecrawler_uprooted",
        cluster: "tower",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "spinecrawler",
        card: ["move", "stop", "hold", "patrol", "zSpineCrawlerRootSpineCrawlerU"],
      },
      {
        id: "sporecrawler",
        cluster: "tower",
        cancel: true,
        label: "Spore Crawler",
        kind: "building",
        card: ["stop", "attack", "co_SporeCrawlerUproot_SporeCrawler_sporecrawleruprooted_2"],
      },
      {
        id: "sporecrawler_uprooted",
        cluster: "tower",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "sporecrawler",
        card: ["move", "stop", "hold", "patrol", "zSporeCrawlerRootSporeCrawlerU"],
      },
      {
        id: "bilelauncher",
        cancel: true,
        label: "Bile Launcher",
        kind: "building",
        card: ["stop", "co_BileLauncherBombardment_BileLauncherZagara"],
      },
      {
        id: "scourgenest",
        cancel: true,
        label: "Scourge Nest",
        kind: "building",
        card: [
          "zZergflyerattack1",
          "zZergflyerarmor1",
          "co_EvolveScourgeSplashDamage_ScourgeNest",
          "co_EvolveScourgeGasCostReduction_ScourgeNest",
          "co_CommanderPrestigeZagaraMaxSupplyScourgeSpawn_ScourgeNest",
        ],
      },
    ],
  },
  abathur: {
    label: "Abathur",
    race: "zerg",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "larva",
        cancel: true,
        label: "Larva",
        kind: "unit",
        card: ["zDrone", "zOver", "zRoach", "zHydra", "zMuta", "zViperLarva"],
      },
      {
        id: "drone",
        cluster: "basic",
        cancel: true,
        label: "Drone",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_ZergBuild_Drone_Abathur",
          "co_ZergBuildAdvanced_Drone_Abathur",
          "spray",
          "burrow",
        ],
      },
      {
        id: "drone_build0",
        cancel: true,
        label: "Basic Mutation",
        kind: "building",
        parent: "drone",
        card: ["zbHatch", "zbExtract", "zbEvo", "zbRoachW", "zbSpine", "zbSpore"],
      },
      {
        id: "drone_build1",
        cancel: true,
        label: "Advanced Mutation",
        kind: "building",
        parent: "drone",
        card: ["zbInfPit", "zbSpire", "zbNydus"],
      },
      {
        id: "queen",
        cluster: "basic",
        label: "Swarm Queen",
        kind: "unit",
        card: [
          "co_BuildCreepTumor_Queen_queencreeptumor",
          "zTransfusionQueen",
          "co_EvolveToBrutalisk_Queen",
          "co_BurrowDown_queenburrowed_3",
        ],
      },
      {
        id: "queen_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "queen",
        card: ["unburrow"],
      },
      {
        id: "queen_creeptumor",
        cluster: "basic",
        label: "Creep Tumor",
        kind: "unit",
        parent: "queen",
        card: ["zBuildCreepTumorPropagateCreep"],
      },
      {
        id: "overlord",
        cluster: "flying",
        cancel: true,
        label: "Overlord",
        kind: "unit",
        card: [
          "zMorphToOverseerOverlord",
          "co_GenerateCreep_Overlord_overlordgeneratingcreep_3",
          "tBunkerLoad",
          "tBunkerUnloadAll",
        ],
      },
      {
        id: "overlord_generatingcreep",
        cluster: "flying",
        cancel: true,
        label: "Generating Creep",
        kind: "unit",
        parent: "overlord",
        card: ["zStopGenerateCreep"],
      },
      {
        id: "overseer",
        cluster: "flying",
        label: "Overseer",
        kind: "unit",
        card: ["zMorphtoOverseerSiege", "zMorphtoOverseerNormal"],
      },
      {
        id: "roach",
        cluster: "basic",
        label: "Roach",
        kind: "unit",
        card: [
          "co_Ravager_RoachVile",
          "co_BrutaliskDeepTunnel_RoachVile",
          "co_EvolveToBrutalisk_RoachVile",
          "co_BurrowDown_roachburrowed_2",
        ],
      },
      {
        id: "roach_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "roach",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "co_BrutaliskDeepTunnel_RoachVileBurrowed",
          "co_EvolveToBrutalisk_RoachVileBurrowed",
          "unburrow",
        ],
      },
      {
        id: "roach_unupgradedburrowed",
        cluster: "basic",
        label: "Roach: Unupgraded Burrowed",
        kind: "unit",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "co_BrutaliskDeepTunnel_RoachBurrowed",
          "co_EvolveToBrutalisk_RoachBurrowed",
          "unburrow",
        ],
      },
      {
        id: "ravager",
        cluster: "basic",
        label: "Ravager",
        kind: "unit",
        card: [
          "co_RavagerAbathurCorrosiveBile_RavagerAbathur",
          "co_BrutaliskDeepTunnel_RavagerAbathur",
          "co_EvolveToBrutalisk_RavagerAbathur",
          "co_BurrowDown_ravagerburrowed",
        ],
      },
      {
        id: "ravager_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "ravager",
        card: ["co_BrutaliskDeepTunnel_RavagerAbathur_2", "unburrow"],
      },
      {
        id: "swarmhost",
        cluster: "flying",
        label: "Swarm Host",
        kind: "unit",
        card: [
          "co_LocustLaunch_SwarmHost",
          "co_AbathurDeepTunnel",
          "co_EvolveToBrutalisk_SwarmHost",
          "co_SwarmHostRootBurrow_swarmhostburrowed",
        ],
      },
      {
        id: "swarmhost_burrowed",
        cluster: "flying",
        label: "Burrowed",
        kind: "unit",
        parent: "swarmhost",
        card: [
          "stop",
          "attack",
          "co_LocustLaunch_SwarmHostBurrowed",
          "co_AbathurDeepTunnel_2",
          "co_EvolveToBrutalisk_SwarmHostBurrowed",
          "co_SwarmHostUprootUnburrow",
        ],
      },
      {
        id: "swarmhost_prestigeburrowed",
        cluster: "flying",
        label: "Prestige Burrowed",
        kind: "unit",
        parent: "swarmhost_prestigeunburrowed",
        card: [
          "stop",
          "attack",
          "co_LocustLaunch_SwarmHostBurrowed_2",
          "co_BrutaliskDeepTunnel_SwarmHostBurrowed",
          "co_EvolveToBrutalisk_SwarmHostBurrowed_2",
          "co_SwarmHostUprootUnburrow_2",
        ],
      },
      {
        id: "swarmhost_prestigeunburrowed",
        cluster: "flying",
        label: "Swarm Host: Prestige Unburrowed",
        kind: "unit",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "co_LocustLaunch_SwarmHost_2",
          "co_BrutaliskDeepTunnel_SwarmHost",
          "co_EvolveToBrutalisk_SwarmHost_2",
          "co_SwarmHostRootBurrow_swarmhostprestigeburrowed",
        ],
      },
      {
        id: "mutalisk",
        cluster: "basic",
        label: "Mutalisk",
        kind: "unit",
        card: [
          "co_MorphToGuardian_Mutalisk",
          "co_MorphtoDevourer_Mutalisk",
          "co_EvolveToLeviathan_Mutalisk",
        ],
      },
      {
        id: "guardian",
        cluster: "basic",
        label: "Guardian",
        kind: "unit",
        card: ["co_EvolveToLeviathan_GuardianMP"],
      },
      {
        id: "devourer",
        cluster: "basic",
        label: "Devourer",
        kind: "unit",
        card: ["co_CorrosiveAcidDevourer_Devourer", "co_EvolveToLeviathan_Devourer"],
      },
      {
        id: "viper",
        cluster: "flying",
        label: "Viper",
        kind: "unit",
        card: [
          "zFaceEmbraceViper",
          "co_DisablingCloud_Viper",
          "co_ViperConsumption_Viper",
          "zParasiticBombViper",
          "co_EvolveToLeviathan_Viper",
        ],
      },
      {
        id: "brutalisk",
        cluster: "basic",
        label: "Brutalisk",
        kind: "unit",
        card: ["co_BrutaliskDeepTunnel_Brutalisk", "co_BurrowDown_brutaliskburrowed"],
      },
      {
        id: "brutalisk_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "brutalisk",
        card: ["unburrow"],
      },
      {
        id: "hatchery",
        cancel: true,
        label: "Hatchery",
        kind: "building",
        card: [
          "zLarva",
          "zQueen",
          "zOverlordspeed",
          "co_EvolveVentralSacks_5",
          "zRallyEgg",
          "tRally",
          "co_Lair_Hatchery_hatcherylair_3",
        ],
      },
      {
        id: "hatchery_lair",
        cancel: true,
        label: "Lair",
        kind: "building",
        parent: "hatchery",
        card: [
          "zLarva",
          "zQueen",
          "zOverlordspeed",
          "co_EvolveVentralSacks_6",
          "zRallyEgg",
          "tRally",
          "zHiveLair",
        ],
      },
      {
        id: "roachwarren",
        cancel: true,
        label: "Roach Warren",
        kind: "building",
        card: [
          "zEvolveGlialRegenerationRoachW",
          "zEvolveTunnelingClawsRoachWarr",
          "co_EvolveHydriodicBile_RoachWarren",
          "co_EvolveAdaptivePlating_RoachWarren",
          "co_EvolveCorrosiveBileRadiusIncrease_RoachWarren",
          "co_EvolveCorrosiveBileDamageIncrease_RoachWarren",
        ],
      },
      {
        id: "evolutionchamber",
        cancel: true,
        label: "Evolution Chamber",
        kind: "building",
        card: [
          "zZergmissileweapons1EvolutionC",
          "zZerggroundarmor1EvolutionCham",
          "co_Transfusion_EvolutionChamber",
          "co_EvolveHatcheryDoubleQueue_EvolutionChamber",
        ],
      },
      {
        id: "spinecrawler",
        cluster: "tower",
        cancel: true,
        label: "Spine Crawler",
        kind: "building",
        card: ["stop", "attack", "co_SpineCrawlerUproot_SpineCrawler_spinecrawleruprooted_3"],
      },
      {
        id: "spinecrawler_uprooted",
        cluster: "tower",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "spinecrawler",
        card: ["move", "stop", "hold", "patrol", "zSpineCrawlerRootSpineCrawlerU"],
      },
      {
        id: "sporecrawler",
        cluster: "tower",
        cancel: true,
        label: "Spore Crawler",
        kind: "building",
        card: ["stop", "attack", "co_SporeCrawlerUproot_SporeCrawler_sporecrawleruprooted_3"],
      },
      {
        id: "sporecrawler_uprooted",
        cluster: "tower",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "sporecrawler",
        card: ["move", "stop", "hold", "patrol", "zSporeCrawlerRootSporeCrawlerU"],
      },
      {
        id: "infestationpit",
        cancel: true,
        label: "Infestation Pit",
        kind: "building",
        card: [
          "co_HotSPressurizedGlands_InfestationPit",
          "co_EvolveViperImprovedCastRange_InfestationPit",
          "co_EvolveInfestorEnergyUpgrade_InfestationPit",
          "zResearchNeuralParasiteInfesta",
        ],
      },
      {
        id: "spire",
        cancel: true,
        label: "Spire",
        kind: "building",
        card: [
          "zZergflyerattack1",
          "zZergflyerarmor1",
          "co_EvolveMutaliskRapidRegeneration_Spire_2",
          "co_EvolveSunderingGlave_Spire",
          "co_EvolveGuardianAttackRangeIncrease_Spire_2",
          "co_EvolveDevourerAoEDamage_Spire",
          "co_GreaterSpireBroodlord_Spire_2",
        ],
      },
      {
        id: "nydusnetwork",
        cancel: true,
        label: "Nydus Network",
        kind: "building",
        card: [
          "stop",
          "co_ZagaraVoidCoopNydusWorm_NydusNetwork_2",
          "tRally",
          "tBunkerLoad",
          "tBunkerUnloadAll",
        ],
      },
      {
        id: "toxicnest",
        cancel: true,
        label: "Toxic Nest",
        kind: "building",
        card: ["co_ToxicNestExplode_ToxicNest"],
      },
    ],
  },
  stukov: {
    label: "Stukov",
    race: "zerg",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "scv",
        cluster: "basic",
        cancel: true,
        label: "Infested SCV",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_TerranBuild_SISCV_Stukov",
          "co_TerranBuildAdvanced_SISCV_Stukov",
          "repair",
          "spray",
          "tHalt",
        ],
      },
      {
        id: "scv_build0",
        cancel: true,
        label: "Build Structure",
        kind: "building",
        parent: "scv",
        card: [
          "co_SICommandCenter_SISCV",
          "co_SIRefinery_SISCV",
          "co_SICivilianStructure_SISCV",
          "co_SIBarracks_SISCV",
          "co_SIEngineeringBay_SISCV",
          "co_SIInfestedBunker_SISCV",
          "co_SIMissileTurret_SISCV",
        ],
      },
      {
        id: "scv_build1",
        cancel: true,
        label: "Build Advanced Structure",
        kind: "building",
        parent: "scv",
        card: ["co_SIFactory_SISCV", "co_SIArmory_SISCV", "co_SIStarport_SISCV"],
      },
      {
        id: "civilian",
        cluster: "basic",
        label: "Infested Civilian",
        kind: "unit",
        card: ["co_BurrowDown_civilianburrowed"],
      },
      {
        id: "civilian_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "civilian",
        card: ["unburrow"],
      },
      {
        id: "overlord",
        cluster: "flying",
        cancel: true,
        label: "Overlord",
        kind: "unit",
        card: [
          "co_MorphToOverseer_SIOverlord",
          "co_GenerateCreep_SIOverlord_overlordgeneratingcreep",
        ],
      },
      {
        id: "overlord_generatingcreep",
        cluster: "flying",
        cancel: true,
        label: "Generating Creep",
        kind: "unit",
        parent: "overlord",
        card: ["zStopGenerateCreep"],
      },
      {
        id: "overseer",
        cluster: "flying",
        label: "Overseer",
        kind: "unit",
        card: ["zMorphtoOverseerSiege", "zMorphtoOverseerNormal"],
      },
      {
        id: "volatile",
        label: "Volatile Infested",
        kind: "unit",
        card: [
          "co_ExplodeVolatileInfested_SIVolatileInfested",
          "co_EnableBuildingAttackVolatileInfested_SIVolatileInfested",
          "co_BurrowDown_volatileburrowed",
        ],
      },
      {
        id: "volatile_burrowed",
        label: "Burrowed",
        kind: "unit",
        parent: "volatile",
        card: ["unburrow"],
      },
      {
        id: "marine",
        cluster: "basic",
        label: "Infested Marine",
        kind: "unit",
        card: ["co_BurrowDown_marineburrowed"],
      },
      {
        id: "marine_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "marine",
        card: ["unburrow"],
      },
      {
        id: "diamondback",
        cluster: "basic",
        label: "Infested Diamondback",
        kind: "unit",
        card: ["co_StukovInfestedDiamondbackSnare_StukovInfestedDiamondBack"],
      },
      {
        id: "siegetank",
        cluster: "basic",
        label: "Infested Siege Tank",
        kind: "unit",
        card: [
          "co_StukovInfestedSiegeTankRoot_StukovInfestedSiegeTank",
          "co_StukovInfestedSiegeTankUproot_StukovInfestedSiegeTank",
          "co_StukovInfestedSiegeTankDeepTunnel_StukovInfestedSiegeTank",
        ],
      },
      {
        id: "banshee",
        cluster: "basic",
        label: "Infested Banshee",
        kind: "unit",
        card: [
          "co_CommanderPrestigeStukovBansheesDeploy_StukovInfestedBanshee",
          "tCloakOnBanshee",
          "tCloakOff",
          "tBunkerLoad",
          "co_SIBansheeUnloadAll",
        ],
      },
      {
        id: "banshee_burrowed",
        cluster: "basic",
        label: "Infested Banshee: Burrowed",
        kind: "unit",
        card: ["unburrow"],
      },
      {
        id: "queen",
        cluster: "basic",
        label: "Brood Queen",
        kind: "unit",
        card: [
          "co_QueenClassicParasite_SIQueen",
          "co_QueenMPSpawnBroodlings_SIQueen",
          "co_SIQueenFungalGrowth_SIQueen",
        ],
      },
      {
        id: "apocalisk",
        label: "Apocalisk",
        kind: "unit",
        card: ["co_SIClusterRockets_StukovApocalisk", "co_ApocaliskBurrowCharge_StukovApocalisk"],
      },
      {
        id: "commandcenter",
        cancel: true,
        label: "Infested Command Center",
        kind: "building",
        card: [
          "co_SISCV",
          "co_SIOverlord_SICommandCenter",
          "co_ResearchHeavyInfestation_SICommandCenter",
          "zOverlordspeed",
          "tSelectBuilder",
          "tRally",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "co_SIUproot_SICommandCenter_commandcenteruprooted",
        ],
      },
      {
        id: "commandcenter_uprooted",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "commandcenter",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "co_SIRoot_SICommandCenterFlying",
        ],
      },
      {
        id: "refinery",
        cancel: true,
        label: "Infested Refinery",
        kind: "building",
        card: ["tSelectBuilder", "tHalt"],
      },
      {
        id: "colonistcompound",
        cluster: "flying",
        cancel: true,
        label: "Infested Colonist Compound",
        kind: "building",
        card: [
          "co_ResearchSIBarracksTrainInfestedCivilianLevel2_SICivilianStructure",
          "co_EvolveStukovInfestedInfestedCivilianLeap_SICivilianStructure",
          "co_EvolveStukovInfestedCivilianSpawnBroodlingsOnDeath_SICivilianStructure",
          "tSelectBuilder",
          "co_SIInfestedCivilian_SICivilianStructure",
          "co_SIStukovPlaceHordeRally_SICivilianStructure",
          "co_SIUproot_SICivilianStructure_colonistcompounduprooted",
        ],
      },
      {
        id: "colonistcompound_uprooted",
        cluster: "flying",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "colonistcompound",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "co_SIInfestedCivilian_SICivilianStructureFlying",
          "co_SIRoot_SICivilianStructureFlying",
        ],
      },
      {
        id: "barracks",
        cancel: true,
        label: "Infested Barracks",
        kind: "building",
        card: [
          "co_SIInfestedMarine_SIBarracks",
          "tSelectBuilder",
          "co_SIStukovPlaceHordeRally_SIBarracks",
          "co_SITechLabBarracks_SIBarracks",
          "co_SIUproot_SIBarracks_barracksuprooted",
        ],
      },
      {
        id: "barracks_techlab",
        cancel: true,
        label: "Infested Barracks: Tech Lab",
        kind: "building",
        card: [
          "co_EvolveSIMarineTrooperImprovedRange_SIBarracksTechLab",
          "co_EvolvePlaguedMunitions_SIBarracksTechLab",
        ],
      },
      {
        id: "barracks_uprooted",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "barracks",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "co_SITechLabBarracks_SIBarracks_2",
          "co_SIRoot_SIBarracksFlying",
        ],
      },
      {
        id: "engineeringbay",
        cancel: true,
        label: "Infested Engineering Bay",
        kind: "building",
        card: [
          "co_TerranInfantryWeaponsLevel1_SIEngineeringBay",
          "co_TerranInfantryArmorLevel1_SIEngineeringBay",
          "co_ResearchInfestedBunkerLifeRegen_SIEngineeringBay",
          "co_ResearchInfestedBunkerArmor_SIEngineeringBay",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "bunker",
        cancel: true,
        label: "Infested Bunker",
        kind: "building",
        card: [
          "stop",
          "attack",
          "co_SIInfestedBunkerSpawnInfestedMarine_SIInfestedBunker",
          "tSelectBuilder",
          "co_SIStukovPlaceHordeRally_SIInfestedBunker",
          "tBunkerLoad",
          "tBunkerUnloadAll",
          "co_SIInfestedBunkerUproot_SIInfestedBunker_bunkeruprooted",
          "tHalt",
        ],
      },
      {
        id: "bunker_uprooted",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "bunker",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "tBunkerLoad",
          "tBunkerUnloadAll",
          "co_SIInfestedBunkerRoot_SIInfestedBunkerUprooted",
        ],
      },
      {
        id: "missileturret",
        cluster: "tower",
        cancel: true,
        label: "Infested Missile Turret",
        kind: "building",
        card: [
          "stop",
          "attack",
          "tSelectBuilder",
          "co_Salvage_SIMissileTurret",
          "co_SIUproot_SIMissileTurret_missileturretuprooted",
        ],
      },
      {
        id: "missileturret_uprooted",
        cluster: "tower",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "missileturret",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "co_Salvage_SIMissileTurret_2",
          "co_SIRoot_SIMissileTurretFlying",
        ],
      },
      {
        id: "factory",
        cancel: true,
        label: "Infested Factory",
        kind: "building",
        card: [
          "co_SIDiamondBack_SIFactory",
          "co_SISiegeTank_SIFactory",
          "tSelectBuilder",
          "tRally",
          "co_SITechLabFactory_SIFactory",
          "co_SIUproot_SIFactory_factoryuprooted",
        ],
      },
      {
        id: "factory_techlab",
        cancel: true,
        label: "Infested Factory: Tech Lab",
        kind: "building",
        card: [
          "co_EvolveSIDiamondbackImprovedEnsnare_SIFactoryTechLab",
          "co_EvolveSIDiamondbackSnailTrail_SIFactoryTechLab",
          "co_ResearchAutoCreateInfestedCivilianAmmo_SIFactoryTechLab",
          "co_ResearchInfestedSiegeTankArmoredDamage_SIFactoryTechLab",
        ],
      },
      {
        id: "factory_uprooted",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "factory",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "co_SITechLabFactory_SIFactory_2",
          "co_SIRoot_SIFactoryFlying",
        ],
      },
      {
        id: "armory",
        cancel: true,
        label: "Infested Armory",
        kind: "building",
        card: [
          "co_TerranVehicleAndShipWeaponsLevel1_SIArmory",
          "co_TerranVehicleAndShipPlatingLevel1_SIArmory",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "starport",
        cancel: true,
        label: "Infested Starport",
        kind: "building",
        card: [
          "co_SILiberator_SIStarport",
          "co_SIBanshee_SIStarport",
          "co_SIQueen",
          "tSelectBuilder",
          "tRally",
          "co_SITechLabStarport_SIStarport",
          "co_SIUproot_SIStarport_starportuprooted",
        ],
      },
      {
        id: "starport_techlab",
        cancel: true,
        label: "Infested Starport: Tech Lab",
        kind: "building",
        card: [
          "co_ResearchSILiberatorImprovedAoeAttack_SIStarportTechLab",
          "co_ResearchSILiberatorBecometheSwarm_SIStarportTechLab",
          "co_ResearchStukovInfestedBansheeBurrowRegeneration_SIStarportTechLab",
          "co_ResearchStukovInfestedBansheeInfestedLife_SIStarportTechLab",
          "co_ResearchSIQueenFungalGrowth_SIStarportTechLab",
          "co_ResearchSIQueenEnergy_SIStarportTechLab",
        ],
      },
      {
        id: "starport_uprooted",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "starport",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "co_SITechLabStarport_SIStarport_2",
          "co_SIRoot_SIStarportFlying",
        ],
      },
    ],
  },
  dehaka: {
    label: "Dehaka",
    race: "zerg",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "dehaka",
        cluster: "basic",
        label: "Dehaka",
        kind: "unit",
        card: [
          "co_DehakaLeapStomp_DehakaCoop",
          "co_DehakaIntimidatingRoar_DehakaCoop",
          "co_DehakaConsume_DehakaCoop",
          "co_MammothBreath_DehakaCoop",
          "co_DehakaDeepTunnel_DehakaCoop",
          "co_DehakaLearnAbilities_DehakaCoop_dehakalearn",
        ],
      },
      {
        id: "dehaka_learn",
        cluster: "basic",
        label: "Learn",
        kind: "unit",
        parent: "dehaka",
        card: [
          "co_LearnDehakaMendingAura_DehakaCoop",
          "co_LearnDehakaDetector_DehakaCoop",
          "co_LearnDehakaArmorUpgrade_DehakaCoop",
          "co_DehakaAirAttackUpgrade_DehakaCoop",
          "co_LearnDehakaLeapStomp_DehakaCoop",
          "co_LearnDehakaIntimidatingRoar_DehakaCoop",
          "co_LearnDehakaConsume_DehakaCoop",
          "co_LearnDehakaMammothBreath_DehakaCoop",
        ],
      },
      {
        id: "zweihaka",
        cancel: true,
        label: "Zweihaka",
        kind: "unit",
        card: [
          "co_DehakaLeapStomp_DehakaCoopClone",
          "co_DehakaIntimidatingRoar_DehakaCoopClone",
          "co_DehakaConsume_DehakaCoopClone",
          "co_MammothBreath_DehakaCoopClone",
          "co_DehakaDeepTunnel_DehakaCoopClone",
          "co_DehakaLearnAbilities_DehakaCoopClone_zweihakalearn",
        ],
      },
      {
        id: "zweihaka_learn",
        cancel: true,
        label: "Learn",
        kind: "unit",
        parent: "zweihaka",
        card: [
          "co_LearnDehakaMendingAura_DehakaCoopClone",
          "co_LearnDehakaDetector_DehakaCoopClone",
          "co_LearnDehakaArmorUpgrade_DehakaCoopClone",
          "co_DehakaAirAttackUpgrade_DehakaCoopClone",
          "co_LearnDehakaLeapStomp_DehakaCoopClone",
          "co_LearnDehakaIntimidatingRoar_DehakaCoopClone",
          "co_LearnDehakaConsume_DehakaCoopClone",
          "co_LearnDehakaMammothBreath_DehakaCoopClone",
        ],
      },
      {
        id: "drone",
        cluster: "basic",
        cancel: true,
        label: "Primal Drone",
        kind: "unit",
        card: ["gatherProt", "returnCargo", "co_DehakaBuild_DehakaDrone_Dehaka", "spray", "burrow"],
      },
      {
        id: "drone_build0",
        cancel: true,
        label: "Basic Mutation",
        kind: "building",
        parent: "drone",
        card: [
          "co_DehakaHatchery_DehakaDrone",
          "co_DehakaBarracks_DehakaDrone",
          "co_DehakaGlevigStructure_DehakaDrone",
          "co_DehakaMurvarStructure_DehakaDrone",
          "co_DehakaDakrunStructure_DehakaDrone",
          "co_DehakaNydusDestroyer_DehakaDrone",
        ],
      },
      {
        id: "zergling",
        cluster: "basic",
        label: "Primal Zergling",
        kind: "unit",
        card: ["co_DehakaRavasaurMerge_DehakaZerglingLevel2", "co_BurrowDown_zerglingburrowed_3"],
      },
      {
        id: "zergling_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "zergling",
        card: ["unburrow"],
      },
      {
        id: "ravasaur",
        cluster: "basic",
        label: "Ravasaur",
        kind: "unit",
        card: ["co_BurrowDown_ravasaurburrowed"],
      },
      {
        id: "ravasaur_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "ravasaur",
        card: ["unburrow"],
      },
      {
        id: "roach",
        cluster: "basic",
        label: "Primal Roach",
        kind: "unit",
        card: [
          "co_DehakaRoachLevel2Merge_DehakaRoachLevel2",
          "co_DehakaRoachGuardianMerge_DehakaRoachLevel2",
          "co_BurrowDown_roachburrowed_3",
        ],
      },
      {
        id: "roach_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "roach",
        card: ["move", "stop", "hold", "patrol", "attack", "unburrow"],
      },
      {
        id: "igniter",
        cluster: "basic",
        label: "Primal Igniter",
        kind: "unit",
        card: ["co_BurrowDown_igniterburrowed"],
      },
      {
        id: "igniter_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "igniter",
        card: ["move", "stop", "hold", "patrol", "attack", "unburrow"],
      },
      {
        id: "guardian",
        cluster: "basic",
        label: "Primal Guardian",
        kind: "unit",
        card: ["co_DehakaGuardianMineCharge_DehakaGuardian"],
      },
      {
        id: "hydralisk",
        cluster: "basic",
        label: "Primal Hydralisk",
        kind: "unit",
        card: [
          "co_DehakaHydraliskToMutalisk_DehakaHydraliskLevel2",
          "co_DehakaHydraliskImpalerMerge_DehakaHydraliskLevel2",
          "co_BurrowDown_hydraliskburrowed_2",
        ],
      },
      {
        id: "hydralisk_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "hydralisk",
        card: ["unburrow"],
      },
      {
        id: "lurker",
        cluster: "flying",
        label: "Impaler",
        kind: "unit",
        card: ["co_ImpalerBurrowDown_lurkerburrowed"],
      },
      {
        id: "lurker_burrowed",
        cluster: "flying",
        label: "Burrowed",
        kind: "unit",
        parent: "lurker",
        card: ["move", "stop", "hold", "patrol", "attack", "co_ImpalerBurrowUp"],
      },
      {
        id: "swarmhost",
        cluster: "flying",
        label: "Primal Host",
        kind: "unit",
        card: [
          "co_DehakaSpawnLocusts_DehakaSwarmHost",
          "co_DehakaSwarmHostMerge_DehakaSwarmHost",
          "co_SwarmHostBurrowDown_swarmhostburrowed",
        ],
      },
      {
        id: "swarmhost_burrowed",
        cluster: "flying",
        label: "Burrowed",
        kind: "unit",
        parent: "swarmhost",
        card: [
          "stop",
          "attack",
          "co_DehakaSpawnLocusts_DehakaSwarmHostBurrowed",
          "co_SwarmHostBurrowUp",
        ],
      },
      {
        id: "creeperhost",
        cluster: "basic",
        label: "Creeper Host",
        kind: "unit",
        card: [
          "co_DehakaSpawnLocustsBomb_DehakaPrimalSwarmHost",
          "co_SwarmHostBurrowDown_creeperhostburrowed",
        ],
      },
      {
        id: "creeperhost_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "creeperhost",
        card: [
          "stop",
          "attack",
          "co_DehakaSpawnLocustsBomb_DehakaPrimalSwarmHostBurrowed",
          "co_SwarmHostBurrowUp_2",
        ],
      },
      {
        id: "ultralisk",
        cluster: "basic",
        label: "Primal Ultralisk",
        kind: "unit",
        card: [
          "co_DehakaUltraliskCrashingCharge_DehakaUltraliskLevel2",
          "co_DehakaUltraliskLevel2Merge_DehakaUltraliskLevel2",
          "co_BurrowDown_ultraliskburrowed_2",
        ],
      },
      {
        id: "ultralisk_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "ultralisk",
        card: ["unburrow"],
      },
      {
        id: "tyrannozor",
        label: "Tyrannozor",
        kind: "unit",
        card: [
          "co_DehakaTyrannozorFanOfKnives_DehakaUltraliskLevel3",
          "co_BurrowDown_tyrannozorburrowed",
        ],
      },
      {
        id: "tyrannozor_burrowed",
        label: "Burrowed",
        kind: "unit",
        parent: "tyrannozor",
        card: ["unburrow"],
      },
      {
        id: "murvar",
        label: "Murvar",
        kind: "unit",
        card: ["co_CoopMurvarSpawnCreepers_DehakaMurvar", "co_MurvarPukeCoop_DehakaMurvar"],
      },
      {
        id: "dakrun",
        label: "Dakrun",
        kind: "unit",
        card: ["co_DakrunCrashingCharge_DehakaDakrun"],
      },
      {
        id: "hatchery",
        cancel: true,
        label: "Primal Hive",
        kind: "building",
        card: [
          "co_DehakaDrone_DehakaHatchery",
          "co_BuildDehakaExtractor_DehakaHatchery",
          "co_RallySCV",
          "co_DehakaLearnPrimalWeaponsLevel1_DehakaHatchery",
          "co_DehakaLearnPrimalArmorLevel1_DehakaHatchery",
          "co_PrimalBuildingUproot_DehakaHatchery_hatcheryuprooted",
        ],
      },
      {
        id: "hatchery_uprooted",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "hatchery",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "tRally",
          "co_PrimalBuildingRoot_DehakaHatcheryUprooted",
        ],
      },
      {
        id: "barracks",
        cancel: true,
        label: "Primal Warden",
        kind: "building",
        card: [
          "co_DehakaZergling_DehakaBarracks",
          "co_DehakaRoach_DehakaBarracks",
          "co_DehakaHydralisk_DehakaBarracks",
          "co_DehakaSwarmHost_DehakaBarracks",
          "co_DehakaUltralisk_DehakaBarracks",
          "tRally",
          "co_PrimalBuildingUproot_DehakaBarracks_barracksuprooted",
        ],
      },
      {
        id: "barracks_uprooted",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "barracks",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "tRally",
          "co_PrimalBuildingRoot_DehakaBarracksUprooted",
        ],
      },
      {
        id: "dehakaden",
        label: "Dehaka’s Den",
        kind: "building",
        card: ["co_ConsumeDrone_DehakaCoopReviveCocoon", "tRally"],
      },
      {
        id: "glevigden",
        cancel: true,
        label: "Glevig’s Den",
        kind: "building",
        card: [
          "co_ResearchDehakaRavasaurVSArmor_DehakaGlevigStructure",
          "co_ResearchDehakaRavasaurRange_DehakaGlevigStructure",
          "co_DehakaRoachMoveSpeed_DehakaGlevigStructure",
          "co_DehakaGlevigRoachFireBreath_DehakaGlevigStructure",
          "co_ResearchDehakaHydraliskSpeed_DehakaGlevigStructure",
          "co_ResearchDehakaImpalerTenderize_DehakaGlevigStructure",
        ],
      },
      {
        id: "murvarden",
        cancel: true,
        label: "Murvar’s Den",
        kind: "building",
        card: [
          "co_ResearchSlicingGlave_DehakaMurvarStructure",
          "co_ResearchDehakaMutaliskDamageReduction_DehakaMurvarStructure",
          "co_ResearchDehakaMutaliskRespawnOnDeath_DehakaMurvarStructure",
          "co_ResearchDehakaGuardianExplosiveBomb_DehakaMurvarStructure",
          "co_ResearchDehakaGuardianFury_DehakaMurvarStructure",
          "co_DehakaMurvarCreeperAir_DehakaMurvarStructure",
        ],
      },
      {
        id: "dakrunden",
        cancel: true,
        label: "Dakrun’s Den",
        kind: "building",
        card: [
          "co_ResearchDehakaUltraliskCrashingCharge_DehakaDakrunStructure",
          "co_ResearchDehakaUltraliskRegen_DehakaDakrunStructure",
          "co_ResearchDehakaUltraliskBash_DehakaDakrunStructure",
          "co_ResearchDehakaTyrannozorFanOfKnives_DehakaDakrunStructure",
          "co_ResearchDehakaTyrannozorArmorAura_DehakaDakrunStructure",
        ],
      },
      {
        id: "wurm",
        cluster: "tower",
        label: "Primal Wurm",
        kind: "building",
        card: [
          "stop",
          "attack",
          "co_NydusDestroyerBeam_DehakaNydusDestroyer",
          "co_NydusDestroyerDeepTunnel_DehakaNydusDestroyer",
        ],
      },
      {
        id: "greaterwurm",
        cluster: "tower",
        label: "Greater Primal Wurm",
        kind: "building",
        card: [
          "stop",
          "attack",
          "co_DehakaNydusDestroyerTimedNoFoodBeam_DehakaNydusDestroyerTimedNoFood",
          "co_GreaterNydusDestroyerDeepTunnel_DehakaNydusDestroyerTimedNoFood",
        ],
      },
      {
        id: "glevig",
        cluster: "tower",
        label: "Glevig",
        kind: "building",
        card: [
          "stop",
          "attack",
          "co_GlevigFirebreath_DehakaGlevig",
          "co_GlevigTunnel_DehakaGlevig",
        ],
      },
    ],
  },
  stetmann: {
    label: "Stetmann",
    race: "zerg",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "gary",
        cluster: "basic",
        label: "Gary",
        kind: "unit",
        card: [
          "co_GaryStetmannOrb_GaryStetmann",
          "co_PowerTowerOverchargeStetmannSpeed_GaryStetmann",
          "co_GaryStetmannRecall_GaryStetmann",
          "co_MorphToSuperGaryStetmann_GaryStetmann_garysupergary",
        ],
      },
      {
        id: "gary_supergary",
        cluster: "basic",
        label: "Super Gary",
        kind: "unit",
        parent: "gary",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "co_GaryStetmannOrb_SuperGaryStetmann",
          "co_PowerTowerOverchargeStetmannSpeed_SuperGaryStetmann",
          "co_GaryStetmannRecall_SuperGaryStetmann",
          "co_PowerFieldSuperGaryStetmannSpeed_SuperGaryStetmann",
        ],
      },
      {
        id: "larva",
        cancel: true,
        label: "Mecha Larva",
        kind: "unit",
        card: [
          "co_DroneStetmann_LarvaStetmann",
          "co_OverlordStetmann_LarvaStetmann",
          "co_ZerglingStetmann_LarvaStetmann",
          "co_HydraliskStetmann_LarvaStetmann",
          "co_CorruptorStetmann_LarvaStetmann",
          "co_InfestorStetmann_LarvaStetmann",
          "co_UltraliskStetmann_LarvaStetmann",
        ],
      },
      {
        id: "drone",
        cluster: "basic",
        cancel: true,
        label: "Mecha Drone",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_ZergBuild_DroneStetmann_Stetmann",
          "co_ZergBuildAdvanced_DroneStetmann_Stetmann",
          "co_RepairStetmann",
          "spray",
          "unburrow",
        ],
      },
      {
        id: "drone_build0",
        cancel: true,
        label: "Basic Mutation",
        kind: "building",
        parent: "drone",
        card: [
          "co_HatcheryStetmann_DroneStetmann",
          "co_ExtractorStetmann_DroneStetmann",
          "co_SpawningPoolStetmann_DroneStetmann",
          "co_EvolutionChamberStetmann_DroneStetmann",
          "co_BanelingNestStetmann_DroneStetmann",
          "co_SpineCrawlerStetmann_DroneStetmann",
          "co_SporeCrawlerStetmann_DroneStetmann",
        ],
      },
      {
        id: "drone_build1",
        cancel: true,
        label: "Advanced Mutation",
        kind: "building",
        parent: "drone",
        card: [
          "co_HydraliskDenStetmann_DroneStetmann",
          "co_InfestationPitStetmann_DroneStetmann",
          "co_SpireStetmann_DroneStetmann",
          "co_UltraliskCavernStetmann_DroneStetmann",
        ],
      },
      {
        id: "overlord",
        cluster: "flying",
        cancel: true,
        label: "Mecha Overlord",
        kind: "unit",
        card: ["co_MorphToOverseerStetmann_OverlordStetmann", "tBunkerLoad", "tBunkerUnloadAll"],
      },
      {
        id: "overseer",
        cluster: "flying",
        label: "Mecha Overseer",
        kind: "unit",
        card: ["co_MorphtoOverseerNormalStetmann_OverseerStetmann"],
      },
      {
        id: "zergling",
        cluster: "basic",
        label: "Mecha Zergling",
        kind: "unit",
        card: ["co_BanelingStetmann_ZerglingStetmann", "co_BurrowDown_zerglingburrowed_4"],
      },
      {
        id: "zergling_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "zergling",
        card: ["unburrow"],
      },
      {
        id: "baneling",
        cluster: "basic",
        label: "Mecha Baneling",
        kind: "unit",
        card: [
          "co_ExplodeStetmann_BanelingStetmann",
          "co_EnableBuildingAttack_BanelingStetmann",
          "co_BanelingStetmannMovementSpeed_BanelingStetmann",
          "co_BurrowDown_banelingburrowed_2",
        ],
      },
      {
        id: "baneling_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "baneling",
        card: ["co_ExplodeStetmann_BanelingStetmannBurrowed", "unburrow"],
      },
      {
        id: "baneling_structureattack",
        cluster: "basic",
        label: "Mecha Baneling: Structure Attack",
        kind: "unit",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "co_ExplodeStetmann_BanelingStetmann_2",
          "co_DisableBuildingAttack_BanelingStetmann",
          "burrow",
        ],
      },
      {
        id: "roach",
        cluster: "basic",
        label: "Mecha Roach",
        kind: "unit",
        card: ["co_BurrowDown_roachburrowed_4"],
      },
      {
        id: "roach_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "roach",
        card: ["move", "stop", "hold", "patrol", "attack", "unburrow"],
      },
      {
        id: "ravager",
        cluster: "basic",
        label: "Mecha Ravager",
        kind: "unit",
        card: [
          "co_RavagerStetmannCorrosiveBile_RavagerStetmann",
          "co_BurrowDown_ravagerburrowed_2",
        ],
      },
      {
        id: "ravager_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "ravager",
        card: ["unburrow"],
      },
      {
        id: "hydralisk",
        cluster: "basic",
        label: "Mecha Hydralisk",
        kind: "unit",
        card: [
          "co_HydraliskStetmannMissilePowerOn",
          "co_HydraliskStetmannMissilePowerOff_HydraliskStetmann",
          "co_LurkerStetmann_HydraliskStetmann",
          "co_BurrowDown_hydraliskburrowed_3",
        ],
      },
      {
        id: "hydralisk_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "hydralisk",
        card: ["unburrow"],
      },
      {
        id: "lurker",
        cluster: "flying",
        label: "Mecha Lurker",
        kind: "unit",
        card: [
          "co_LurkerStetmannTunnelingBurst_LurkerStetmann",
          "co_LurkerStetmannChannelingSpines_LurkerStetmann",
          "co_LurkerBurrowDown_lurkerburrowed",
        ],
      },
      {
        id: "lurker_burrowed",
        cluster: "flying",
        label: "Burrowed",
        kind: "unit",
        parent: "lurker",
        card: [
          "stop",
          "attack",
          "co_LurkerStetmannTunnelingBurst_LurkerStetmannBurrowed",
          "co_LurkerStetmannChannelingSpines_LurkerStetmannBurrowed",
          "co_LurkerCancelHoldFire_LurkerStetmannBurrowed",
          "co_LurkerHoldFire_LurkerStetmannBurrowed",
          "co_LurkerBurrowUp_2",
        ],
      },
      {
        id: "corruptor",
        cluster: "basic",
        cancel: true,
        label: "Mecha Corruptor",
        kind: "unit",
        card: [
          "co_CorruptorStetmannMissilePods_CorruptorStetmann",
          "co_CausticSprayStetmann_CorruptorStetmann",
          "co_BroodLordStetmann_CorruptorStetmann",
        ],
      },
      {
        id: "broodlord",
        cluster: "basic",
        label: "Mecha Battlecarrier Lord",
        kind: "unit",
        card: [
          "co_BroodLordStetmannBroodlings_BroodLordStetmann",
          "co_BroodLordStetmannBombers_BroodLordStetmann",
          "co_BroodLordStetmannYamatoCannon",
        ],
      },
      {
        id: "infestor",
        cluster: "flying",
        cancel: true,
        label: "Mecha Infestor",
        kind: "unit",
        card: [
          "co_InfestorStetmannEggLaunch_InfestorStetmann",
          "co_InfestorStetmannHealingTentacle_InfestorStetmann",
          "co_InfestorStetmannInfestBuilding_InfestorStetmann",
          "co_BurrowDown_infestorburrowed",
        ],
      },
      {
        id: "infestor_burrowed",
        cluster: "flying",
        cancel: true,
        label: "Burrowed",
        kind: "unit",
        parent: "infestor",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "co_InfestorStetmannEggLaunch_InfestorStetmannBurrowed",
          "co_InfestorStetmannHealingTentacle_InfestorStetmannBurrowed",
          "co_InfestorStetmannInfestBuilding_InfestorStetmannBurrowed",
          "unburrow",
        ],
      },
      {
        id: "ultralisk",
        cluster: "basic",
        label: "Mecha Ultralisk",
        kind: "unit",
        card: [
          "co_UltraliskStetmannBurrowCharge_UltraliskStetmann",
          "co_UltraliskStetmannMechanicalLifeLeech_UltraliskStetmann",
          "co_BurrowDown_ultraliskburrowed_3",
        ],
      },
      {
        id: "ultralisk_burrowed",
        cluster: "basic",
        label: "Burrowed",
        kind: "unit",
        parent: "ultralisk",
        card: ["unburrow"],
      },
      {
        id: "hatchery",
        cancel: true,
        label: "Mecha Hatchery",
        kind: "building",
        card: [
          "co_LarvaStetmann",
          "co_ResearchOverlordStetmannSpeed",
          "co_ResearchOverlordStetmannVentralSacks",
          "co_RallyEggStetmann",
          "tRally",
          "co_LairStetmann_HatcheryStetmann_hatcherymechalair",
        ],
      },
      {
        id: "hatchery_mechalair",
        cancel: true,
        label: "Mecha Lair",
        kind: "building",
        parent: "hatchery",
        card: [
          "co_LarvaStetmann_2",
          "co_ResearchOverlordStetmannSpeed_2",
          "co_ResearchOverlordStetmannVentralSacks_2",
          "co_RallyEggStetmann_2",
          "tRally",
          "co_HiveStetmann_LairStetmann",
        ],
      },
      {
        id: "spawningpool",
        cancel: true,
        label: "Mecha Spawning Pool",
        kind: "building",
        card: [
          "co_ResearchZerglingStetmannMovementSpeed_SpawningPoolStetmann",
          "co_ResearchZerglingStetmannHardenedShield_SpawningPoolStetmann",
          "co_ResearchZerglingStetmannAttackSpeed_SpawningPoolStetmann",
          "co_ZerglingStetmannRespawn_SpawningPoolStetmann",
        ],
      },
      {
        id: "evolutionchamber",
        cancel: true,
        label: "Mecha Evolution Chamber",
        kind: "building",
        card: [
          "co_ZergMeleeWeaponsStetmann1_EvolutionChamberStetmann",
          "co_ZergMissileWeaponsStetmann1_EvolutionChamberStetmann",
          "co_ZergGroundArmorStetmann1_EvolutionChamberStetmann",
        ],
      },
      {
        id: "banelingnest",
        cancel: true,
        label: "Mecha Baneling Nest",
        kind: "building",
        card: [
          "co_ResearchBanelingStetmannMovementSpeed_BanelingNestStetmann",
          "co_ResearchBanelingStetmannExtraDamage_BanelingNestStetmann",
          "co_ResearchBanelingStetmannManaShieldBonus_BanelingNestStetmann",
        ],
      },
      {
        id: "spinecrawler",
        cluster: "tower",
        cancel: true,
        label: "Mecha Spine Crawler",
        kind: "building",
        card: [
          "stop",
          "attack",
          "co_SpineCrawlerUprootStetmann_SpineCrawlerStetmann_spinecrawleruprooted",
        ],
      },
      {
        id: "spinecrawler_uprooted",
        cluster: "tower",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "spinecrawler",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "co_SpineCrawlerRootStetmann_SpineCrawlerUprootedStetmann",
        ],
      },
      {
        id: "sporecrawler",
        cluster: "tower",
        cancel: true,
        label: "Mecha Spore Crawler",
        kind: "building",
        card: [
          "stop",
          "attack",
          "co_SporeCrawlerUprootStetmann_SporeCrawlerStetmann_sporecrawleruprooted",
        ],
      },
      {
        id: "sporecrawler_uprooted",
        cluster: "tower",
        cancel: true,
        label: "Uprooted",
        kind: "building",
        parent: "sporecrawler",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "co_SporeCrawlerRootStetmann_SporeCrawlerUprootedStetmann",
        ],
      },
      {
        id: "hydraliskden",
        cancel: true,
        label: "Mecha Hydralisk Den",
        kind: "building",
        card: [
          "co_ResearchHydraliskStetmannMovementSpeed_HydraliskDenStetmann",
          "co_ResearchHydraliskStetmannDamage_HydraliskDenStetmann",
          "co_ResearchHydraliskStetmannRange_HydraliskDenStetmann",
          "co_ResearchLurkerStetmannTunnelingBurstRange_HydraliskDenStetmann",
          "co_ReserachLurkerStetmannChannelingSpines_HydraliskDenStetmann",
          "co_LurkerDenStetmann_HydraliskDenStetmann",
          "co_HydraliskStetmannRespawn_HydraliskDenStetmann",
        ],
      },
      {
        id: "infestationpit",
        cancel: true,
        label: "Mecha Infestation Pit",
        kind: "building",
        card: [
          "co_InfestorStetmannBonusRavager_InfestationPitStetmann",
          "co_InfestorStetmannRespawn_InfestationPitStetmann",
        ],
      },
      {
        id: "spire",
        cancel: true,
        label: "Mecha Spire",
        kind: "building",
        card: [
          "co_ZergFlyerAttackStetmann1",
          "co_ZergFlyerArmorStetmann1",
          "co_CorruptorStetmannBiggerAoE_SpireStetmann",
          "co_ResearchCorruptorCausticSprayStetmann_SpireStetmann",
          "co_BroodLordStetmannBombersLearn_SpireStetmann",
          "co_BroodLordStetmannYamato_SpireStetmann",
          "co_GreaterSpireStetmann_SpireStetmann",
          "co_CorruptorStetmannRespawn_SpireStetmann",
        ],
      },
      {
        id: "ultraliskcavern",
        cancel: true,
        label: "Mecha Ultralisk Cavern",
        kind: "building",
        card: [
          "co_ResearchUltraliskStetmannBurrowChargeMechanicalStun_UltraliskCavernStetmann",
          "co_ReserachUltraliskStetmannMechanicalLifeLeech_UltraliskCavernStetmann",
          "co_ReserachUltraliskStetmannArmor_UltraliskCavernStetmann",
          "co_UltraliskStetmannRespawn_UltraliskCavernStetmann",
        ],
      },
      {
        id: "stetellite",
        label: "Stetellite",
        kind: "building",
        card: ["co_FASTOverloadStetmann_PowerTowerStetmann"],
      },
      { id: "garyroom", label: "Gary’s Room", kind: "building", card: ["tRally"] },
    ],
  },
  artanis: {
    label: "Artanis",
    race: "protoss",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "probe",
        cluster: "basic",
        cancel: true,
        label: "Probe",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_ProtossBuild_Probe_Artanis",
          "co_ProtossBuildAdvanced_Probe_Artanis",
          "spray",
        ],
      },
      {
        id: "probe_build0",
        cancel: true,
        label: "Warp In Structure",
        kind: "building",
        parent: "probe",
        card: ["pNexus", "pAssim", "pPylon", "pGate", "pForge", "pCyber", "pCannon"],
      },
      {
        id: "probe_build1",
        cancel: true,
        label: "Warp In Advanced Structure",
        kind: "building",
        parent: "probe",
        card: ["pTwilight", "pStargate", "pRobo", "pArchives", "pFleet", "pRoboBay"],
      },
      {
        id: "zealot",
        cluster: "basic",
        label: "Zealot",
        kind: "unit",
        card: ["co_Charge_ZealotAiur", "co_VoidZealotWhirlwind_ZealotAiur"],
      },
      {
        id: "hightemplar",
        cluster: "basic",
        label: "High Templar",
        kind: "unit",
        card: ["pFeedbackHighTemplar", "pPsiStormHighTemplar", "pAWrp"],
      },
      {
        id: "archon",
        cluster: "basic",
        label: "Archon",
        kind: "unit",
        card: ["co_Feedback_Archon", "co_PsiStorm_Archon"],
      },
      {
        id: "immortal",
        cluster: "basic",
        label: "Immortal",
        kind: "unit",
        card: ["co_ImmortalOverload_Immortal"],
      },
      {
        id: "observer",
        cluster: "flying",
        label: "Observer",
        kind: "unit",
        card: ["pMorphtoObserverSiege", "pMorphtoObserver"],
      },
      {
        id: "reaver",
        cluster: "basic",
        label: "Reaver",
        kind: "unit",
        card: ["co_ReaverScarabs_Reaver"],
      },
      {
        id: "phoenix",
        cluster: "basic",
        cancel: true,
        label: "Phoenix",
        kind: "unit",
        card: ["pGravitonBeamPhoenix"],
      },
      {
        id: "tempest",
        cluster: "basic",
        cancel: true,
        label: "Tempest",
        kind: "unit",
        card: ["co_LightningBomb_Tempest"],
      },
      {
        id: "nexus",
        cancel: true,
        label: "Nexus",
        kind: "building",
        card: ["pProbe", "tRally", "co_TimeWarp_Nexus"],
      },
      {
        id: "gateway",
        cancel: true,
        label: "Gateway",
        kind: "building",
        card: ["pZealot", "pStalker", "pHT", "tRally"],
      },
      {
        id: "forge",
        cancel: true,
        label: "Forge",
        kind: "building",
        card: [
          "pProtossGroundWeaponsLevel1For",
          "pProtossGroundArmorLevel1Forge",
          "pProtossShieldsLevel1Forge",
        ],
      },
      {
        id: "photoncannon",
        cluster: "tower",
        cancel: true,
        label: "Photon Cannon",
        kind: "building",
        card: ["stop", "attack"],
      },
      {
        id: "cyberneticscore",
        cancel: true,
        label: "Cybernetics Core",
        kind: "building",
        card: ["pProtossAirWeaponsLevel1Cybern", "pProtossAirArmorLevel1Cybernet"],
      },
      {
        id: "twilightcouncil",
        cancel: true,
        label: "Twilight Council",
        kind: "building",
        card: [
          "pResearchChargeTwilightCouncil",
          "co_ResearchDragoonRange_TwilightCouncil",
          "co_ResearchWhirlwind_TwilightCouncil",
          "co_ResearchDragoonChassis_TwilightCouncil",
        ],
      },
      {
        id: "templararchives",
        cancel: true,
        label: "Templar Archives",
        kind: "building",
        card: [
          "pResearchPsiStormTemplarArchiv",
          "co_ResearchHighTemplarEnergyUpgrade_TemplarArchive",
          "co_ResearchHealingPsionicStorm_TemplarArchive",
        ],
      },
      {
        id: "roboticsfacility",
        cancel: true,
        label: "Robotics Facility",
        kind: "building",
        card: [
          "pImmortalRoboticsFacility",
          "pColossusRoboticsFacility",
          "pObserverRoboticsFacility",
          "tRally",
        ],
      },
      {
        id: "roboticsbay",
        cancel: true,
        label: "Robotics Bay",
        kind: "building",
        card: [
          "pResearchGraviticBoosterRoboti",
          "pResearchExtendedThermalLanceR",
          "co_ResearchReaverIncreasedScarabCount_RoboticsBay",
          "co_ResearchReaverIncreasedScarabSplashRadius_RoboticsBay",
        ],
      },
      {
        id: "stargate",
        cancel: true,
        label: "Stargate",
        kind: "building",
        card: ["pPhoenixStargate", "pVoidRayStargate", "tRally"],
      },
      {
        id: "fleetbeacon",
        cancel: true,
        label: "Fleet Beacon",
        kind: "building",
        card: [
          "pAnionPulseCrystalsFleetBeacon",
          "co_ResearchDoubleGravitonBeam_FleetBeacon",
          "co_ResearchTempestDisintegration_FleetBeacon",
        ],
      },
    ],
  },
  vorazun: {
    label: "Vorazun",
    race: "protoss",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "probe",
        cluster: "basic",
        cancel: true,
        label: "Probe",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_ProtossBuild_Probe_Vorazun",
          "co_ProtossBuildAdvanced_Probe_Vorazun",
          "spray",
        ],
      },
      {
        id: "probe_build0",
        cancel: true,
        label: "Warp In Structure",
        kind: "building",
        parent: "probe",
        card: ["pNexus", "pAssim", "pPylon", "pGate", "pForge", "pCyber", "pCannon"],
      },
      {
        id: "probe_build1",
        cancel: true,
        label: "Warp In Advanced Structure",
        kind: "building",
        parent: "probe",
        card: ["pTwilight", "pStargate", "pFleet", "pDark"],
      },
      {
        id: "zealot",
        cluster: "basic",
        label: "Centurion",
        kind: "unit",
        card: [
          "co_VoidZealotShadowCharge_ZealotShakuras",
          "co_VoidZealotShadowChargeStun_ZealotShakuras",
        ],
      },
      {
        id: "stalker",
        cluster: "basic",
        label: "Stalker",
        kind: "unit",
        card: ["co_StalkerBlinkShieldRestoreBase_StalkerShakuras"],
      },
      {
        id: "darktemplar",
        cluster: "basic",
        label: "Dark Templar",
        kind: "unit",
        card: [
          "co_VoidDarkTemplarShadowFury_DarkTemplarShakuras",
          "co_DarkTemplarShadowDash_DarkTemplarShakuras",
          "co_VoidStasis_DarkTemplarShakuras",
        ],
      },
      {
        id: "darkarchon",
        cluster: "basic",
        label: "Dark Archon",
        kind: "unit",
        card: ["co_DarkArchonConfusion_DarkArchon", "co_DarkArchonMindControl_DarkArchon"],
      },
      {
        id: "corsair",
        cluster: "basic",
        label: "Corsair",
        kind: "unit",
        card: ["co_CorsairMPDisruptionWeb_CorsairMP"],
      },
      {
        id: "oracle",
        cluster: "basic",
        cancel: true,
        label: "Oracle",
        kind: "unit",
        card: ["pOracleWeaponOn", "pOracleWeaponOff", "pOracleBuildStasisTrap"],
      },
      {
        id: "shadowguard",
        label: "Shadow Guard",
        kind: "unit",
        card: [
          "co_VoidShadowGuardShadowFury_VorazunShadowGuard",
          "co_ShadowGuardBlink_VorazunShadowGuard",
          "co_VoidStasis_VorazunShadowGuard",
        ],
      },
      {
        id: "nexus",
        cancel: true,
        label: "Nexus",
        kind: "building",
        card: ["pProbe", "tRally", "co_TimeWarp_Nexus_2"],
      },
      {
        id: "gateway",
        cancel: true,
        label: "Gateway",
        kind: "building",
        card: [
          "pZealot",
          "pStalker",
          "pDT",
          "co_DarkArchon_Gateway",
          "tRally",
          "co_UpgradeToWarpGate_Gateway_gatewaywarpgate",
        ],
      },
      {
        id: "gateway_warpgate",
        cancel: true,
        label: "Warp Gate",
        kind: "building",
        parent: "gateway",
        card: [
          "pZealot",
          "pStalker",
          "pDT",
          "co_DarkArchon_WarpGate",
          "pMorphBackToGatewayWarpGate",
        ],
      },
      {
        id: "forge",
        cancel: true,
        label: "Forge",
        kind: "building",
        card: [
          "pProtossGroundWeaponsLevel1For",
          "pProtossGroundArmorLevel1Forge",
          "pProtossShieldsLevel1Forge",
        ],
      },
      {
        id: "photoncannon",
        cluster: "tower",
        cancel: true,
        label: "Photon Cannon",
        kind: "building",
        card: ["stop", "attack"],
      },
      {
        id: "cyberneticscore",
        cancel: true,
        label: "Cybernetics Core",
        kind: "building",
        card: [
          "pProtossAirWeaponsLevel1Cybern",
          "pProtossAirArmorLevel1Cybernet",
          "pResearchWarpGateCyberneticsCo",
        ],
      },
      {
        id: "twilightcouncil",
        cancel: true,
        label: "Twilight Council",
        kind: "building",
        card: [
          "pResearchChargeTwilightCouncil",
          "co_ResearchDragoonRange_TwilightCouncil_2",
          "co_ResearchWhirlwind_TwilightCouncil_2",
          "co_ResearchDragoonChassis_TwilightCouncil_2",
        ],
      },
      {
        id: "darkshrine",
        cancel: true,
        label: "Dark Shrine",
        kind: "building",
        card: [
          "co_ResearchShadowFury_DarkShrine",
          "co_ResearchShadowDash_DarkShrine",
          "co_ResearchVoidStasis_DarkShrine",
          "co_ResearchDarkArchonFullStartingEnergy_DarkShrine",
          "co_ResearchDarkArchonMindControl_DarkShrine",
        ],
      },
      {
        id: "stargate",
        cancel: true,
        label: "Stargate",
        kind: "building",
        card: ["pPhoenixStargate", "pVoidRayStargate", "pOracleStargate", "tRally"],
      },
      {
        id: "fleetbeacon",
        cancel: true,
        label: "Fleet Beacon",
        kind: "building",
        card: [
          "pAnionPulseCrystalsFleetBeacon",
          "co_ResearchDoubleGravitonBeam_FleetBeacon_2",
          "co_ResearchTempestDisintegration_FleetBeacon_2",
          "co_ResearchOracleStasisWardUpgrade_FleetBeacon",
        ],
      },
      {
        id: "darkpylon",
        cancel: true,
        label: "Dark Pylon",
        kind: "building",
        card: ["co_DarkPylonRecall_DarkPylon"],
      },
    ],
  },
  karax: {
    label: "Karax",
    race: "protoss",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "probe",
        cluster: "basic",
        cancel: true,
        label: "Probe",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_ProtossBuild_Probe_Karax",
          "co_ProtossBuildAdvanced_Probe_Karax",
          "spray",
        ],
      },
      {
        id: "probe_build0",
        cancel: true,
        label: "Warp In Structure",
        kind: "building",
        parent: "probe",
        card: [
          "pNexus",
          "pAssim",
          "pPylon",
          "pGate",
          "pForge",
          "pBattery",
          "pCyber",
          "pCannon",
          "co_KhaydarinMonolith_Probe",
        ],
      },
      {
        id: "probe_build1",
        cancel: true,
        label: "Warp In Advanced Structure",
        kind: "building",
        parent: "probe",
        card: ["pTwilight", "pStargate", "pRobo", "pFleet", "pRoboBay"],
      },
      {
        id: "zealot",
        cluster: "basic",
        label: "Sentinel",
        kind: "unit",
        card: ["co_Charge_ZealotPurifier"],
      },
      {
        id: "sentry",
        cluster: "basic",
        cancel: true,
        label: "Energizer",
        kind: "unit",
        card: [
          "co_VoidSentryChronoBeam_SentryPurifier",
          "co_EnergizerReclamation_SentryPurifier",
          "co_VoidSentryPhasingMode_SentryPurifier",
          "co_VoidSentryMobileMode_SentryPurifier",
        ],
      },
      {
        id: "immortal",
        cluster: "basic",
        label: "Immortal",
        kind: "unit",
        card: ["co_ImmortalOverload_Immortal_2", "co_ImmortalShakurasShadowCannon_Immortal"],
      },
      {
        id: "observer",
        cluster: "flying",
        label: "Observer",
        kind: "unit",
        card: ["pMorphtoObserverSiege", "pMorphtoObserver"],
      },
      {
        id: "phoenix",
        cluster: "basic",
        cancel: true,
        label: "Mirage",
        kind: "unit",
        card: ["co_GravitonBeam_PhoenixPurifier"],
      },
      {
        id: "carrier",
        cluster: "basic",
        cancel: true,
        label: "Carrier",
        kind: "unit",
        card: ["pInterceptorCarrier", "co_RepairDrones_Carrier"],
      },
      {
        id: "nexus",
        cancel: true,
        label: "Nexus",
        kind: "building",
        card: ["pProbe", "tRally", "co_TimeWarp_Nexus_3"],
      },
      {
        id: "gateway",
        cancel: true,
        label: "Gateway",
        kind: "building",
        card: ["pZealot", "pSentry", "tRally", "co_UpgradeToWarpGate_Gateway_gatewaywarpgate_2"],
      },
      {
        id: "gateway_warpgate",
        cancel: true,
        label: "Warp Gate",
        kind: "building",
        parent: "gateway",
        card: ["pZealot", "pSentry", "pMorphBackToGatewayWarpGate"],
      },
      {
        id: "shieldbattery",
        cancel: true,
        label: "Shield Battery",
        kind: "building",
        card: ["stop", "pShieldBatteryRecharge", "co_ShieldBatteryStructureBarrier_ShieldBattery"],
      },
      {
        id: "forge",
        cancel: true,
        label: "Forge",
        kind: "building",
        card: [
          "pProtossGroundWeaponsLevel1For",
          "pProtossGroundArmorLevel1Forge",
          "pProtossShieldsLevel1Forge",
          "co_ResearchKaraxTurretRange_Forge",
          "co_ResearchKaraxTurretAttackSpeed_Forge",
          "co_ResearchStructureBarrier_Forge",
        ],
      },
      {
        id: "photoncannon",
        cluster: "tower",
        cancel: true,
        label: "Photon Cannon",
        kind: "building",
        card: ["stop", "attack"],
      },
      {
        id: "monolith",
        cancel: true,
        label: "Khaydarin Monolith",
        kind: "building",
        card: ["stop", "attack"],
      },
      {
        id: "cyberneticscore",
        cancel: true,
        label: "Cybernetics Core",
        kind: "building",
        card: [
          "pProtossAirWeaponsLevel1Cybern",
          "pProtossAirArmorLevel1Cybernet",
          "pResearchWarpGateCyberneticsCo",
        ],
      },
      {
        id: "twilightcouncil",
        cancel: true,
        label: "Twilight Council",
        kind: "building",
        card: [
          "pResearchChargeTwilightCouncil",
          "co_ResearchDragoonRange_TwilightCouncil_3",
          "co_ResearchWhirlwind_TwilightCouncil_3",
          "co_ResearchDragoonChassis_TwilightCouncil_3",
        ],
      },
      {
        id: "roboticsfacility",
        cancel: true,
        label: "Robotics Facility",
        kind: "building",
        card: [
          "pImmortalRoboticsFacility",
          "pColossusRoboticsFacility",
          "pObserverRoboticsFacility",
          "tRally",
        ],
      },
      {
        id: "roboticsbay",
        cancel: true,
        label: "Robotics Bay",
        kind: "building",
        card: [
          "pResearchGraviticBoosterRoboti",
          "pResearchExtendedThermalLanceR",
          "co_ResearchReaverIncreasedScarabCount_RoboticsBay_2",
          "co_ResearchReaverIncreasedScarabSplashRadius_RoboticsBay_2",
        ],
      },
      {
        id: "stargate",
        cancel: true,
        label: "Stargate",
        kind: "building",
        card: ["pPhoenixStargate", "pVoidRayStargate", "tRally"],
      },
      {
        id: "fleetbeacon",
        cancel: true,
        label: "Fleet Beacon",
        kind: "building",
        card: [
          "pAnionPulseCrystalsFleetBeacon",
          "co_ResearchDoubleGravitonBeam_FleetBeacon_3",
          "co_ResearchTempestDisintegration_FleetBeacon_3",
          "co_ResearchInterceptorLaunchSpeedUpgrade_FleetBeacon",
        ],
      },
      {
        id: "solarforge",
        cancel: true,
        label: "Solar Forge",
        kind: "building",
        card: [
          "co_ResearchSolarEfficiencyLevel1_SolarForge",
          "co_ResearchSOARepairBeamExtraTarget_SolarForge",
          "co_ResearchSOAOrbitalStrikeUpgrade_SolarForge",
          "co_ResearchSOASolarLanceUpgrade_SolarForge",
        ],
      },
      {
        id: "solarforge_destroyed",
        cancel: true,
        label: "Solar Forge: Destroyed",
        kind: "building",
        card: ["co_BrokenSolarForge_SolarForge"],
      },
    ],
  },
  alarak: {
    label: "Alarak",
    race: "protoss",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "alarak",
        label: "Alarak",
        kind: "unit",
        card: ["co_AlarakDeadlyCharge", "co_AlarakKnockback", "co_AlarakEmpower"],
      },
      {
        id: "alarak_alaraksbeacon",
        label: "Alarak: Alarak’s Beacon",
        kind: "unit",
        card: ["tRally", "co_AlarakDeadlyCharge_2", "co_AlarakKnockback_2", "co_AlarakEmpower_2"],
      },
      {
        id: "probe",
        cluster: "basic",
        cancel: true,
        label: "Probe",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_ProtossBuild_Probe_Alarak",
          "co_ProtossBuildAdvanced_Probe_Alarak",
          "spray",
        ],
      },
      {
        id: "probe_build0",
        cancel: true,
        label: "Warp In Structure",
        kind: "building",
        parent: "probe",
        card: ["pNexus", "pAssim", "pPylon", "pGate", "pForge", "pCyber", "pCannon"],
      },
      {
        id: "probe_build1",
        cancel: true,
        label: "Warp In Advanced Structure",
        kind: "building",
        parent: "probe",
        card: ["pTwilight", "pRobo", "pArchives", "pRoboBay"],
      },
      { id: "stalker", cluster: "basic", label: "Slayer", kind: "unit", card: ["pBlink"] },
      {
        id: "sentry",
        cluster: "basic",
        cancel: true,
        label: "Havoc",
        kind: "unit",
        card: ["co_TargetLock_Monitor", "co_SentryTaldarimForceField_Monitor"],
      },
      {
        id: "hightemplar",
        cluster: "basic",
        label: "Ascendant",
        kind: "unit",
        card: [
          "co_VoidHighTemplarPsiOrb_HighTemplarTaldarim",
          "co_VoidHighTemplarMindBlast_HighTemplarTaldarim",
          "co_AscendantSacrifice_HighTemplarTaldarim",
        ],
      },
      {
        id: "warpprism",
        cluster: "flying",
        label: "War Prism",
        kind: "unit",
        card: [
          "co_ACAlarakPhasingMode_WarpPrismTaldarim",
          "co_ACAlarakTransportMode_WarpPrismTaldarim",
          "tBunkerLoad",
          "tBunkerUnloadAll",
        ],
      },
      {
        id: "mothership",
        cluster: "basic",
        label: "Mothership",
        kind: "unit",
        card: [
          "co_SOAMothershipLineAttack_SOAMothershipv4",
          "co_AlarakMothershipMassTeleport_SOAMothershipv4",
          "co_VoidRay_SOAMothershipv4",
        ],
      },
      {
        id: "nexus",
        cancel: true,
        label: "Nexus",
        kind: "building",
        card: ["pProbe", "tRally", "co_TimeWarp_Nexus_4"],
      },
      {
        id: "gateway",
        cancel: true,
        label: "Gateway",
        kind: "building",
        card: [
          "pZealot",
          "pSentry",
          "pStalker",
          "pHT",
          "tRally",
          "co_UpgradeToWarpGate_Gateway_gatewaywarpgate_3",
        ],
      },
      {
        id: "gateway_warpgate",
        cancel: true,
        label: "Warp Gate",
        kind: "building",
        parent: "gateway",
        card: ["pZealot", "pSentry", "pStalker", "pHT", "pMorphBackToGatewayWarpGate"],
      },
      {
        id: "forge",
        cancel: true,
        label: "Forge",
        kind: "building",
        card: [
          "pProtossGroundWeaponsLevel1For",
          "pProtossGroundArmorLevel1Forge",
          "pProtossShieldsLevel1Forge",
          "co_ResearchKaraxTurretRange_Forge_2",
          "co_ResearchKaraxTurretAttackSpeed_Forge_2",
        ],
      },
      {
        id: "photoncannon",
        cluster: "tower",
        cancel: true,
        label: "Photon Cannon",
        kind: "building",
        card: ["stop", "attack"],
      },
      {
        id: "cyberneticscore",
        cancel: true,
        label: "Cybernetics Core",
        kind: "building",
        card: [
          "pProtossAirWeaponsLevel1Cybern",
          "pProtossAirArmorLevel1Cybernet",
          "co_ResearchAlarakTargetLockBuff_CyberneticsCore",
          "pResearchWarpGateCyberneticsCo",
        ],
      },
      {
        id: "twilightcouncil",
        cancel: true,
        label: "Death Council",
        kind: "building",
        card: [
          "pResearchChargeTwilightCouncil",
          "co_ResearchDragoonRange_TwilightCouncil_4",
          "co_ResearchWhirlwind_TwilightCouncil_4",
          "co_ResearchDragoonChassis_TwilightCouncil_4",
        ],
      },
      {
        id: "templararchives",
        cancel: true,
        label: "Ascendant Archives",
        kind: "building",
        card: [
          "pResearchPsiStormTemplarArchiv",
          "co_ResearchHighTemplarEnergyUpgrade_TemplarArchive_2",
          "co_ResearchHealingPsionicStorm_TemplarArchive_2",
        ],
      },
      {
        id: "roboticsfacility",
        cancel: true,
        label: "Robotics Facility",
        kind: "building",
        card: [
          "pImmortalRoboticsFacility",
          "pColossusRoboticsFacility",
          "pWarpinDisruptorRoboticsFacili",
          "tRally",
        ],
      },
      {
        id: "roboticsbay",
        cancel: true,
        label: "Robotics Bay",
        kind: "building",
        card: [
          "pResearchGraviticBoosterRoboti",
          "pResearchExtendedThermalLanceR",
          "co_ResearchReaverIncreasedScarabCount_RoboticsBay_3",
          "co_ResearchReaverIncreasedScarabSplashRadius_RoboticsBay_3",
        ],
      },
    ],
  },
  fenix: {
    label: "Fenix",
    race: "protoss",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "fenix",
        cluster: "basic",
        label: "Fenix",
        kind: "unit",
        card: [
          "co_FenixThunderousChargeCoop_FenixCoop",
          "co_FenixWhirlwind_FenixCoop",
          "co_VoidShieldCapacitor_FenixCoop",
        ],
      },
      {
        id: "fenix_solaritedragoon",
        cluster: "basic",
        label: "Fenix: Solarite Dragoon",
        kind: "unit",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "co_FenixDragoonChargedBuster_FenixDragoon",
          "co_FenixDragoonAirBomb_FenixDragoon",
          "co_FenixDragoonArsenalOvercharge_FenixDragoon",
        ],
      },
      {
        id: "fenix_cybrosarbiter",
        cluster: "basic",
        label: "Fenix: Cybros Arbiter",
        kind: "unit",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "co_FenixArbiterStasisField_FenixArbiter",
          "co_FenixArbiterCloakField_FenixArbiter",
          "co_ArbiterMPRecall_FenixArbiter",
        ],
      },
      {
        id: "probe",
        cluster: "basic",
        cancel: true,
        label: "Probe",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_ProtossBuild_Probe_Fenix",
          "co_ProtossBuildAdvanced_Probe_Fenix",
          "spray",
        ],
      },
      {
        id: "probe_build0",
        cancel: true,
        label: "Warp In Structure",
        kind: "building",
        parent: "probe",
        card: ["pNexus", "pAssim", "pPylon", "pGate", "pForge", "pCyber", "pCannon"],
      },
      {
        id: "probe_build1",
        cancel: true,
        label: "Warp In Advanced Structure",
        kind: "building",
        parent: "probe",
        card: ["pTwilight", "pStargate", "pRobo", "pFleet", "pRoboBay"],
      },
      {
        id: "zealot",
        cluster: "basic",
        label: "Legionnaire",
        kind: "unit",
        card: ["co_Charge_ZealotPurifier_2"],
      },
      {
        id: "sentry",
        cluster: "basic",
        cancel: true,
        label: "Conservator",
        kind: "unit",
        card: [
          "co_FenixSentryGuardianZone_SentryFenix",
          "co_VoidSentryPhasingMode_SentryFenix",
          "co_VoidSentryMobileMode_SentryFenix",
        ],
      },
      {
        id: "immortal",
        cluster: "basic",
        label: "Immortal",
        kind: "unit",
        card: ["co_ImmortalOverload_Immortal_3"],
      },
      {
        id: "observer",
        cluster: "flying",
        label: "Observer",
        kind: "unit",
        card: ["pMorphtoObserverSiege", "pMorphtoObserver"],
      },
      {
        id: "disruptor",
        cluster: "flying",
        label: "Disruptor",
        kind: "unit",
        card: ["co_FenixPurificationNova_Disruptor"],
      },
      {
        id: "carrier",
        cluster: "basic",
        cancel: true,
        label: "Carrier",
        kind: "unit",
        card: ["pInterceptorCarrier"],
      },
      {
        id: "zealotchampion",
        label: "Kaldalis",
        kind: "unit",
        card: ["co_FenixKaldalisZealotCharge_FenixKaldalisZealot"],
      },
      {
        id: "adeptchampion",
        label: "Talis",
        kind: "unit",
        card: ["co_FenixTalisAdeptBounceShot_FenixTalisAdept"],
      },
      {
        id: "immortalchampion",
        label: "Taldarin",
        kind: "unit",
        card: ["co_ImmortalOverload_FenixTaldarinImmortal"],
      },
      {
        id: "colossuschampion",
        label: "Warbringer",
        kind: "unit",
        card: ["co_FenixWarbringerColossusPowerShot_FenixWarbringerColossus"],
      },
      {
        id: "scoutchampion",
        label: "Mojo",
        kind: "unit",
        card: ["co_FenixMojoMissiles_FenixMojoScout"],
      },
      {
        id: "carrierchampion",
        cancel: true,
        label: "Clolarion",
        kind: "unit",
        card: ["co_FenixClolarionInterceptor_FenixClolarionCarrier"],
      },
      {
        id: "nexus",
        cancel: true,
        label: "Nexus",
        kind: "building",
        card: ["pProbe", "tRally", "co_TimeWarp_Nexus_5"],
      },
      {
        id: "gateway",
        cancel: true,
        label: "Gateway",
        kind: "building",
        card: [
          "pZealot",
          "pSentry",
          "pStalker",
          "tRally",
          "co_UpgradeToWarpGate_Gateway_gatewaywarpgate_4",
        ],
      },
      {
        id: "gateway_warpgate",
        cancel: true,
        label: "Warp Gate",
        kind: "building",
        parent: "gateway",
        card: ["pZealot", "pSentry", "pStalker", "pMorphBackToGatewayWarpGate"],
      },
      {
        id: "forge",
        cancel: true,
        label: "Forge",
        kind: "building",
        card: [
          "pProtossGroundWeaponsLevel1For",
          "pProtossGroundArmorLevel1Forge",
          "pProtossShieldsLevel1Forge",
          "co_ResearchKaraxTurretRange_Forge_3",
          "co_ResearchKaraxTurretAttackSpeed_Forge_3",
          "co_ResearchStructureBarrier_Forge_2",
        ],
      },
      {
        id: "photoncannon",
        cluster: "tower",
        cancel: true,
        label: "Photon Cannon",
        kind: "building",
        card: ["stop", "attack"],
      },
      {
        id: "cyberneticscore",
        cancel: true,
        label: "Cybernetics Core",
        kind: "building",
        card: [
          "pProtossAirWeaponsLevel1Cybern",
          "pProtossAirArmorLevel1Cybernet",
          "co_ResearchAlarakTargetLockBuff_CyberneticsCore_2",
          "pResearchWarpGateCyberneticsCo",
        ],
      },
      {
        id: "twilightcouncil",
        cancel: true,
        label: "Twilight Council",
        kind: "building",
        card: [
          "pResearchChargeTwilightCouncil",
          "co_ResearchDragoonRange_TwilightCouncil_5",
          "co_ResearchWhirlwind_TwilightCouncil_5",
          "co_ResearchDragoonChassis_TwilightCouncil_5",
        ],
      },
      {
        id: "roboticsfacility",
        cancel: true,
        label: "Robotics Facility",
        kind: "building",
        card: [
          "pImmortalRoboticsFacility",
          "pColossusRoboticsFacility",
          "pObserverRoboticsFacility",
          "pWarpinDisruptorRoboticsFacili",
          "tRally",
        ],
      },
      {
        id: "roboticsbay",
        cancel: true,
        label: "Robotics Bay",
        kind: "building",
        card: [
          "pResearchGraviticBoosterRoboti",
          "pResearchExtendedThermalLanceR",
          "co_ResearchReaverIncreasedScarabCount_RoboticsBay_4",
          "co_ResearchReaverIncreasedScarabSplashRadius_RoboticsBay_4",
          "co_FenixImmortalResearchDetonationShot_RoboticsBay",
          "co_ResearchFenixWarbringerColossusPowerShot_RoboticsBay",
        ],
      },
      {
        id: "stargate",
        cancel: true,
        label: "Stargate",
        kind: "building",
        card: ["pPhoenixStargate", "pVoidRayStargate", "tRally"],
      },
      {
        id: "fleetbeacon",
        cancel: true,
        label: "Fleet Beacon",
        kind: "building",
        card: [
          "pAnionPulseCrystalsFleetBeacon",
          "co_ResearchDoubleGravitonBeam_FleetBeacon_4",
          "co_ResearchTempestDisintegration_FleetBeacon_4",
          "co_ResearchOracleStasisWardUpgrade_FleetBeacon_2",
        ],
      },
      {
        id: "purifierconclave",
        cancel: true,
        label: "Purifier Conclave",
        kind: "building",
        card: [
          "co_FenixKaldalisZealotDownloadUpgrade",
          "co_FenixTalisAdeptDownloadUpgrade",
          "co_FenixTaldarinImmortalDownloadUpgrade",
          "co_FenixWarbringerColossusDownloadUpgrade",
          "co_FenixMojoScoutDownloadUpgrade",
          "co_FenixClolarionCarrierDownloadUpgrade",
        ],
      },
      {
        id: "purifierconclave_destroyed",
        cancel: true,
        label: "Purifier Conclave: Destroyed",
        kind: "building",
        card: ["co_BrokenFenixAltarOfPsiStorms_FenixAltarOfPsiStorms"],
      },
    ],
  },
  zeratul: {
    label: "Zeratul",
    race: "protoss",
    modes: ["coop"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "zeratul",
        cluster: "basic",
        label: "Zeratul",
        kind: "unit",
        card: [
          "co_ZeratulBlink_ZeratulCoop",
          "co_ZeratulSummonVoidSeeker_ZeratulCoop",
          "co_ZeratulShadowCleave_ZeratulCoop",
          "co_ProphecyVision_ZeratulCoop",
        ],
      },
      {
        id: "zeratul_zeratulsbeacon",
        cluster: "basic",
        label: "Zeratul: Zeratul’s Beacon",
        kind: "unit",
        card: ["tRally"],
      },
      {
        id: "probe",
        cluster: "basic",
        cancel: true,
        label: "Xel’Naga Precursor",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "co_ProtossBuild_Probe_Zeratul",
          "co_ProtossBuildAdvanced_Probe_Zeratul",
          "spray",
        ],
      },
      {
        id: "probe_build0",
        cancel: true,
        label: "Warp In Structure",
        kind: "building",
        parent: "probe",
        card: ["pNexus", "pGate", "pCyber", "pCannon"],
      },
      {
        id: "probe_build1",
        cancel: true,
        label: "Warp In Advanced Structure",
        kind: "building",
        parent: "probe",
        card: ["pRobo", "pRoboBay", "pDark"],
      },
      {
        id: "stalker",
        cluster: "basic",
        label: "Xel’Naga Ambusher",
        kind: "unit",
        card: ["co_Blink_ZeratulStalker"],
      },
      {
        id: "sentry",
        cluster: "basic",
        cancel: true,
        label: "Xel’Naga Shieldguard",
        kind: "unit",
        card: [
          "co_VoidSentryShieldRepair_ZeratulSentry",
          "co_ZeratulReflectionShield_ZeratulSentry",
        ],
      },
      {
        id: "darktemplar",
        cluster: "basic",
        label: "Void Templar",
        kind: "unit",
        card: ["co_Blink_ZeratulDarkTemplar"],
      },
      {
        id: "immortal",
        cluster: "basic",
        label: "Xel’Naga Enforcer",
        kind: "unit",
        card: ["co_ImmortalOverload_ZeratulImmortal"],
      },
      {
        id: "observer",
        cluster: "flying",
        label: "Xel’Naga Watcher",
        kind: "unit",
        card: ["co_MorphtoObserverSiege_ZeratulObserver", "co_MorphtoObserver_ZeratulObserver"],
      },
      {
        id: "disruptor",
        cluster: "flying",
        label: "Xel’Naga Abrogator",
        kind: "unit",
        card: ["co_ZeratulPurificationNovaTargeted_ZeratulDisruptor"],
      },
      {
        id: "warpprism",
        cluster: "flying",
        label: "Xel’Naga Void Array",
        kind: "unit",
        card: ["co_PhasingMode_ZeratulWarpPrism", "co_ZeratulWarpPrismSelectVoidRift"],
      },
      {
        id: "warpprism_wormholemode",
        cluster: "flying",
        label: "Xel’Naga Void Array: Wormhole Mode",
        kind: "unit",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "co_TransportMode_ZeratulWarpPrismPhasing",
          "co_ZeratulWarpPrismSelectVoidRift_2",
          "co_WarpPrismLoad",
          "co_ZeratulWarpPrismUnload_ZeratulWarpPrismPhasing",
          "co_ZeratulWarpPrismAutoUnloadOn_ZeratulWarpPrismPhasing",
          "co_ZeratulWarpPrismAutoUnloadOff_ZeratulWarpPrismPhasing",
        ],
      },
      {
        id: "avatarofform",
        cluster: "basic",
        label: "Avatar of Form",
        kind: "unit",
        card: [
          "co_EntropicBlast_ZeratulXelNagaConstructCyan",
          "co_ZeratulXelNagaConstructPsiStorm_ZeratulXelNagaConstructCyan",
          "co_ZeratulXelNagaConstructPsiBlast_ZeratulXelNagaConstructCyan",
        ],
      },
      {
        id: "avatarofessence",
        label: "Avatar of Essence",
        kind: "unit",
        card: ["co_ZeratulXelNagaConstructDevolve_ZeratulXelNagaConstruct"],
      },
      {
        id: "zealot",
        cluster: "basic",
        label: "Zealot",
        kind: "unit",
        card: ["co_Charge_ZeratulSummonZealot", "co_VoidZealotWhirlwind_ZeratulSummonZealot"],
      },
      {
        id: "telbrus",
        label: "Telbrus",
        kind: "unit",
        card: ["co_Feedback_ZeratulSummonKarass", "co_PsiStormTelbrus_ZeratulSummonKarass"],
      },
      {
        id: "darkarchon",
        cluster: "basic",
        label: "Dark Archon",
        kind: "unit",
        card: [
          "co_ZeratulDarkArchonMaelstrom_ZeratulDarkArchon",
          "co_ZeratulDarkArchonMindControl_ZeratulDarkArchon",
        ],
      },
      {
        id: "serdath",
        label: "Serdath",
        kind: "unit",
        card: [
          "co_ZeratulDarkArchonMaelstrom_ZeratulHeroDarkArchon",
          "co_ZeratulDarkArchonMindControl_ZeratulHeroDarkArchon",
        ],
      },
      {
        id: "nexus",
        cancel: true,
        label: "Ancient Nexus",
        kind: "building",
        card: ["pProbe", "co_TimeWarp_Nexus_6"],
      },
      {
        id: "gateway",
        cancel: true,
        label: "Xel’Naga Passageway",
        kind: "building",
        card: [
          "co_StalkerZeratul_ZeratulGateway",
          "co_SentryZeratul_ZeratulGateway",
          "co_DarkTemplarZeratul_ZeratulGateway",
          "tRally",
        ],
      },
      {
        id: "photoncannon",
        cluster: "tower",
        cancel: true,
        label: "Tesseract Cannon",
        kind: "building",
        card: [
          "stop",
          "attack",
          "co_ZeratulPhaseCannonProjectionPassive_ZeratulPhotonCannon",
          "co_ZeratulStructureBarrier_ZeratulPhotonCannon",
        ],
      },
      {
        id: "monolith",
        cancel: true,
        label: "Tesseract Monolith",
        kind: "building",
        card: [
          "stop",
          "attack",
          "co_ZeratulKhaydarinMonolithWarp_ZeratulKhaydarinMonolith",
          "co_ZeratulStructureBarrier_ZeratulKhaydarinMonolith",
        ],
      },
      {
        id: "roboticsfacility",
        cancel: true,
        label: "Constructs Facility",
        kind: "building",
        card: [
          "co_ImmortalZeratul_ZeratulRoboticsFacility",
          "co_ZeratulWarpinDisruptor_ZeratulRoboticsFacility",
          "co_WarpInZeratulWarpPrism_ZeratulRoboticsFacility",
          "co_ZeratulObserver_ZeratulRoboticsFacility",
          "tRally",
        ],
      },
    ],
  },
};
